(() => {
  if (!document.body.classList.contains('template-cad-account')) return;

  const ensureCadMainLoadingSpinner = () => {
    const main = document.querySelector('#main');
    if (!(main instanceof HTMLElement)) return null;

    let host = main.querySelector('[data-cad-main-loading]');
    if (!(host instanceof HTMLElement)) {
      host = document.createElement('div');
      host.dataset.cadMainLoading = 'true';
      host.setAttribute('role', 'status');
      host.setAttribute('aria-live', 'polite');
      host.setAttribute('aria-label', 'Loading');
      host.style.position = 'absolute';
      host.style.top = '25%';
      host.style.left = '0';
      host.style.right = '0';
      host.style.bottom = '0';
      host.style.display = 'none';
      host.style.alignItems = 'flex-start';
      host.style.justifyContent = 'center';
      host.style.background = 'transparent';
      host.style.zIndex = '4';

      const spinner = document.createElement('div');
      spinner.dataset.cadMainLoadingSpinner = 'true';
      spinner.style.width = '28px';
      spinner.style.height = '28px';
      spinner.style.borderRadius = '50%';
      spinner.style.border = '3px solid currentColor';
      spinner.style.borderRightColor = 'transparent';
      spinner.style.opacity = '0.75';

      if (typeof spinner.animate === 'function') {
        const animation = spinner.animate(
          [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }],
          { duration: 700, iterations: Infinity, easing: 'linear' }
        );
        animation.pause();
        spinner.__cadSpinAnimation = animation;
      }

      host.appendChild(spinner);
      main.appendChild(host);
    }

    const computed = window.getComputedStyle(main);
    if (computed.position === 'static') {
      main.style.position = 'relative';
    }

    return host;
  };

  const syncCadMainLoadingSpinner = () => {
    if (!document.body.classList.contains('template-cad-account')) return;
    const main = document.querySelector('#main');
    if (!(main instanceof HTMLElement)) return;

    const hasCadComponent = !!main.querySelector('cad-component');
    const spinnerHost = ensureCadMainLoadingSpinner();
    if (!spinnerHost) return;

    const spinner = spinnerHost.querySelector(
      '[data-cad-main-loading-spinner]'
    );
    const animation = spinner && spinner.__cadSpinAnimation;

    if (!hasCadComponent) {
      spinnerHost.style.display = 'flex';
      if (animation && typeof animation.play === 'function') animation.play();
      return;
    }

    spinnerHost.style.display = 'none';
    if (animation && typeof animation.pause === 'function') animation.pause();
  };

  const bindCadMainLoadingSpinner = () => {
    const main = document.querySelector('#main');
    if (!(main instanceof HTMLElement)) return false;

    if (main.__cadMainLoadingSpinnerBound === true) return true;
    main.__cadMainLoadingSpinnerBound = true;

    const observer = new MutationObserver(() => {
      syncCadMainLoadingSpinner();
    });
    observer.observe(main, { childList: true, subtree: true });
    main.__cadMainLoadingObserver = observer;

    syncCadMainLoadingSpinner();
    return true;
  };

  if (!bindCadMainLoadingSpinner()) {
    window.addEventListener(
      'DOMContentLoaded',
      () => {
        bindCadMainLoadingSpinner();
      },
      { once: true }
    );
  }

  // Check if customer exists in window object
  const hasCustomer =
    window.cadCustomerData !== null && window.cadCustomerData !== undefined;

  // isCadAppLoginPage is true if:
  // 1. URL includes login page path, OR
  // 2. Customer is not logged in (no customer data in window)
  const isCadAppLoginPage =
    window.location.pathname.includes('/apps/deluxe/account/login') ||
    !hasCustomer;

  const isCadAppRegisterPage = window.location.pathname.includes(
    '/apps/deluxe/account/register'
  );
  document.body.classList.toggle(
    'template-cad-auth-login-page',
    isCadAppLoginPage
  );
  document.body.classList.toggle(
    'template-cad-auth-register-page',
    isCadAppRegisterPage
  );

  const ACCOUNT_FRAME_SELECTOR =
    '.cad-account.cad-frame-content[data-frame="account"]';
  const FAVORITES_FRAME_SELECTOR =
    '.cad-favorites.cad-frame-content[data-frame="favorites"]';
  const ORDERS_FRAME_SELECTOR =
    '.cad-orders.cad-frame-content[data-frame="orders"]';
  const ADDRESSES_FRAME_SELECTOR =
    '.cad-addresses.cad-frame-content[data-frame="addresses"]';
  const LOYALTY_FRAME_SELECTOR =
    '.cad-loyalty.cad-frame-content[data-frame="loyalty"]';
  const CAD_ACCOUNT_SELECTOR = 'cad-account[data-mode="profile"]';
  const CODE8_SIGNUP_SELECTOR = '[data-code8-signup]';
  const CODE8_OPTIN_ROOT_SELECTOR = '[data-code8-optin]';
  const CODE8_AUTH_OPTIN_STORAGE_KEY = 'code8MarketingOptinAfterAuth';
  const CODE8_AUTH_OPTIN_FALLBACK_TEXT =
    'I agree to receive exclusive offers and updates from Code8 by email.';
  const CODE8_OPTIN_POPUP_RETRY_DELAY_MS = 250;
  const CODE8_OPTIN_POPUP_MAX_RETRIES = 40;
  const FAVORITES_TITLE = 'Saved items';
  const ADDRESSES_TITLE = 'My addresses';
  const LOYALTY_TITLE = 'Referral program';
  const LOYALTY_REFERRALS_TITLE = 'Referrals';
  const LOYALTY_WORKS_TITLE = 'How Does it Work';
  const LOYALTY_HOW_ICON_FILES = [
    'Frame_2.svg?v=1772816300',
    'Capa_1.svg?v=1772816368',
    'Layer_2.svg?v=1772816419'
  ];
  const LOYALTY_COPY_TOAST_DURATION_MS = 1800;
  const LOYALTY_COPY_TOAST_SUCCESS_MESSAGE = 'Link Copied!';
  const ACCOUNT_PHONE_MAX_LENGTH = 16;
  const ACCOUNT_PHONE_MIN_LOCAL_DIGITS = 7;
  const ACCOUNT_PHONE_MAX_LOCAL_DIGITS = 15;
  const ACCOUNT_PHONE_GB_MAX_LOCAL_DIGITS = 10;
  const ACCOUNT_PHONE_INVALID_MESSAGE = 'Please enter a valid phone number.';
  const CAD_ENDPOINT_PATH = '/apps/deluxe/endpoint';
  const CAD_ACCOUNT_PAGE_PATH = '/apps/deluxe/account';
  const CAD_ACCOUNT_NAV_BLOCK_MS = 8_000;
  const CAD_ACCOUNT_SAVE_PENDING_TIMEOUT_MS = 12_000;
  const CAD_ENDPOINT_DEDUP_WINDOW_MS = 2_500;
  const CAD_TYPED_PHONE_TTL_MS = 180_000;
  const ACCOUNT_EDIT_SINGLE_COLUMN_ORDER = [
    'first_name',
    'birth',
    'last_name',
    'gender',
    'email',
    'skin_type',
    'phone',
    'skin_tone',
    'accepts_marketing'
  ];
  const ACCOUNT_EDIT_LEFT_COLUMN_ORDER = [
    'first_name',
    'last_name',
    'email',
    'phone',
    'accepts_marketing'
  ];
  const ACCOUNT_EDIT_RIGHT_COLUMN_ORDER = [
    'birth',
    'gender',
    'skin_type',
    'skin_tone'
  ];
  const FAVORITES_ITEMS_PER_PAGE = 9;
  const FAVORITES_ITEMS_PER_PAGE_TABLET = 8;
  const FAVORITES_TABLET_MEDIA_QUERY =
    '(min-width: 768px) and (max-width: 989px)';
  const FAVORITES_CONFIRM_POPUP_TEXT =
    'Are you sure you want to delete this from your wishlist?';
  const FAVORITES_CONFIRM_POPUP_CANCEL_LABEL = 'Cancel';
  const FAVORITES_CONFIRM_POPUP_CONFIRM_LABEL = 'Remove';
  const NAV_MENU_ITEM_SELECTOR = '.cad-nav__menu-item[data-nav]';
  const ADDRESSES_ITEMS_PER_PAGE = 9;
  const ADDRESS_HASH_SECTION = 'addresses';
  const ADDRESS_HASH_NEW = 'add-new';
  const ADDRESS_HASH_EDIT = 'edit-address';
  const ADDRESS_PHONE_DEFAULT_DIAL_CODE = '+44';
  const CAD_ADDRESS_SAVE_PENDING_TIMEOUT_MS = 12_000;
  const ADDRESS_REQUIRED_FIELD_MESSAGES = {
    address1: 'Field is required.',
    city: 'Field is required.'
  };
  const ADDRESS_REQUIRED_FIELD_KEYS = new Set(
    Object.keys(ADDRESS_REQUIRED_FIELD_MESSAGES)
  );
  const ADDRESS_FIELD_LABELS = {
    first_name: 'First name:',
    last_name: 'Last name:',
    address1: 'Address Line 1:',
    address2: 'Address Line 2:',
    company: 'Company',
    zip: 'Postal/Zip Code:',
    phone: 'Contact Number:',
    city: 'City',
    country: 'Country:',
    province: 'Greater area:',
    default: 'Mark as Default Address'
  };
  const ADDRESS_ITEM_SELECTOR =
    ':scope > .cad-frame--data > :is(cad-address, .default-address, .add-address, .cad--new-address, [data-cad-address-add-card])';
  const NATIVE_ADD_ADDRESS_BUTTON_SELECTOR = [
    ':scope > .cad-frame--data > .add-address',
    ':scope > .cad-frame--data .add-address',
    ':scope > .cad-frame--data > [data-cad-addresses-add-card]',
    ':scope > .cad-frame--data [data-cad-addresses-add-card]',
    ':scope > .cad-frame--data > [data-address-new-toggle]',
    ':scope > .cad-frame--data [data-address-new-toggle]'
  ].join(', ');
  const NATIVE_NEW_ADDRESS_FORM_SELECTOR = [
    ':scope > .cad-frame--data > .cad--new-address form',
    ':scope > .cad-frame--data .cad--new-address form',
    ':scope > .cad-frame--data > .add-address form',
    ':scope > .cad-frame--data .add-address form',
    ':scope > .cad-frame--data > [data-cad-address-new] form',
    ':scope > .cad-frame--data [data-cad-address-new] form',
    ':scope > .cad-frame--data > [data-address-new] form',
    ':scope > .cad-frame--data [data-address-new] form',
    ':scope > .cad-frame--data form#address_form_new',
    ':scope > .cad-frame--data form[id$=\"_new\"]'
  ].join(', ');
  const ADDRESS_EDIT_TOGGLE_SELECTOR =
    '.address-footer .edit, .address-footer [data-action="edit"], [data-cad-address-edit-trigger]';
  const ADDRESS_CARD_NON_CONTENT_LINE_PATTERN =
    /^(edit(?:\s+address)?|cancel|save|update|delete|back)$/i;
  const ADDRESS_EDITOR_ROWS = [
    {
      columns: 2,
      fields: ['first_name', 'last_name']
    },
    {
      columns: 1,
      fields: ['address1']
    },
    {
      columns: 1,
      fields: ['address2']
    },
    {
      columns: 3,
      fields: ['company', 'zip', 'phone']
    },
    {
      columns: 2,
      fields: ['city', 'country']
    },
    {
      columns: 1,
      fields: ['default']
    }
  ];
  const ORDERS_SUBTITLE =
    'View your orders and manage your account information';
  const NAV_LABELS = {
    account: 'My Account',
    orders: 'My Orders',
    favorites: 'Wishlist',
    addresses: 'Delivery Address',
    loyalty: 'Referral Program',
    link: 'LOG OUT'
  };
  const ICON_STROKE_WIDTH = 1.5;
  const createMenuIcon = (paths, viewBox = '0 0 24 24', width = 24) => `
    <svg
      aria-hidden="true"
      focusable="false"
      fill="none"
      class="icon-cad-menu"
      height="${width}"
      preserveAspectRatio="xMidYMid meet"
      stroke-width="${ICON_STROKE_WIDTH}"
      style="display: block; flex: none; height: ${width}px; max-height: ${width}px; max-width: ${width}px; min-height: ${width}px; min-width: ${width}px; width: ${width}px;"
      viewBox="${viewBox}"
      width="${width}"
    >
      ${paths}
    </svg>
  `;
  const NAV_ICONS = {
    account: createMenuIcon(
      `
      <g transform="translate(1 1)">
        <path d="M10.75 0.75C5.227 0.75 0.75 5.227 0.75 10.75C0.75 16.273 5.227 20.75 10.75 20.75C16.273 20.75 20.75 16.273 20.75 10.75C20.75 5.227 16.273 0.75 10.75 0.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.02344 17.096C3.02344 17.096 5.25244 14.25 10.7524 14.25C16.2524 14.25 18.4824 17.096 18.4824 17.096M10.7524 10.75C11.5481 10.75 12.3111 10.4339 12.8738 9.87132C13.4364 9.30871 13.7524 8.54565 13.7524 7.75C13.7524 6.95435 13.4364 6.19129 12.8738 5.62868C12.3111 5.06607 11.5481 4.75 10.7524 4.75C9.95679 4.75 9.19373 5.06607 8.63112 5.62868C8.06851 6.19129 7.75244 6.95435 7.75244 7.75C7.75244 8.54565 8.06851 9.30871 8.63112 9.87132C9.19373 10.4339 9.95679 10.75 10.7524 10.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    `,
      '0 0 24 24',
      24
    ),
    orders: createMenuIcon(`
      <path xmlns="http://www.w3.org/2000/svg" d="M7.5 8.25V6.75C7.5 5.55653 7.97411 4.41193 8.81802 3.56802C9.66193 2.72411 10.8065 2.25 12 2.25C13.1935 2.25 14.3381 2.72411 15.182 3.56802C16.0259 4.41193 16.5 5.55653 16.5 6.75V8.25M4.75 8.25C4.55109 8.25 4.36032 8.32902 4.21967 8.46967C4.07902 8.61032 4 8.80109 4 9L3 19.125C3 20.543 4.207 21.75 5.625 21.75H18.375C19.793 21.75 21 20.601 21 19.184L20 9C20 8.80109 19.921 8.61032 19.7803 8.46967C19.6397 8.32902 19.4489 8.25 19.25 8.25H4.75Z" stroke="#303030" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    `),
    favorites: createMenuIcon(`
      <path xmlns="http://www.w3.org/2000/svg" d="M4.08762 6.47701C4.51152 6.05309 5.01477 5.71682 5.56863 5.4874C6.12249 5.25798 6.71612 5.13989 7.31562 5.13989C7.91511 5.13989 8.50874 5.25798 9.0626 5.4874C9.61646 5.71682 10.1197 6.05309 10.5436 6.47701L12.0006 7.93401L13.4576 6.47701C14.3139 5.62089 15.4751 5.13998 16.686 5.14007C17.8968 5.14017 19.058 5.62126 19.9141 6.47751C20.7702 7.33376 21.2511 8.49503 21.251 9.70586C21.251 10.9167 20.7699 12.0779 19.9136 12.934L18.4566 14.39L18.4696 14.403L12.0136 20.86L12.0006 20.847L11.9876 20.86L5.53162 14.403L5.54462 14.39L4.08762 12.934C3.66355 12.5101 3.32715 12.0068 3.09764 11.4528C2.86813 10.8989 2.75 10.3051 2.75 9.70551C2.75 9.10589 2.86813 8.51215 3.09764 7.95819C3.32715 7.40424 3.66355 6.90093 4.08762 6.47701Z" stroke="#303030" stroke-width="1.5" stroke-linejoin="round"/>
    `),
    addresses: createMenuIcon(`
      <path d="M20 10C20 14.418 12 22 12 22C12 22 4 14.418 4 10C4 7.87827 4.84285 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10Z" stroke="#303030" stroke-width="1.5"/>
<path d="M12 11C12.2652 11 12.5196 10.8946 12.7071 10.7071C12.8946 10.5196 13 10.2652 13 10C13 9.73478 12.8946 9.48043 12.7071 9.29289C12.5196 9.10536 12.2652 9 12 9C11.7348 9 11.4804 9.10536 11.2929 9.29289C11.1054 9.48043 11 9.73478 11 10C11 10.2652 11.1054 10.5196 11.2929 10.7071C11.4804 10.8946 11.7348 11 12 11Z" fill="#303030" stroke="#303030" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    `),
    loyalty: createMenuIcon(`
      <path xmlns="http://www.w3.org/2000/svg" d="M12 13.1995C13.2829 13.1995 14.4712 12.7974 15.4462 12.1126C16.0969 12.7792 16.995 13.1995 18 13.1995C19.9884 13.1995 21.6 11.5873 21.6 9.60001C21.6 7.61251 19.9533 5.93907 17.8804 6.00329C17.3264 3.26275 14.9053 1.20001 12 1.20001C9.09562 1.20001 6.67406 3.26275 6.11953 6.00329C4.01297 5.95126 2.39995 7.61251 2.39995 9.60001C2.39995 11.5873 4.01245 13.1995 6 13.1995C7.00495 13.1995 7.90312 12.7786 8.55469 12.1126C9.52922 12.7974 10.7175 13.1995 12 13.1995ZM18 7.20001C19.3228 7.20001 20.4 8.27673 20.4 9.60001C20.4 10.9228 19.3228 12 18 12C17.3587 12 16.7789 11.7457 16.349 11.3339C17.3723 10.2577 18 8.8022 18 7.20001ZM12 2.39954C14.6466 2.39954 16.8 4.55275 16.8 7.20001C16.8 9.84704 14.6466 12 12 12C9.35344 12 7.2 9.84704 7.2 7.20001C7.2 4.55275 9.35344 2.39954 12 2.39954ZM6 12C4.67714 12 3.6 10.9228 3.6 9.60001C3.6 8.27673 4.67714 7.20001 6 7.20001C6 8.80009 6.6262 10.2534 7.64672 11.329C7.21734 11.7413 6.64125 12 6 12ZM24 19.2C24 15.8857 21.314 13.1995 18 13.1995C17.0981 13.1995 16.2488 13.4088 15.4833 13.7695C14.4633 13.4002 13.178 13.1995 12 13.1995C10.7573 13.1995 9.74109 13.4234 8.64745 13.8324C7.8487 13.433 6.95339 13.1995 6 13.1995C2.68594 13.1995 0 15.8857 0 19.2H3.09511C2.64698 20.3061 2.39995 21.5194 2.39995 22.8001H21.6C21.6 21.5194 21.3726 20.3061 20.9541 19.2H24ZM1.35234 18C1.88531 15.9317 3.76734 14.4001 6 14.4001C6.39516 14.4001 6.77625 14.4528 7.14141 14.547C5.70797 15.3837 4.51453 16.5715 3.68344 18H1.35234ZM3.68344 21.6001C4.26089 17.4774 7.78261 14.4001 12.172 14.4001C16.4625 14.4001 19.7873 17.4211 20.3241 21.6001H3.68344ZM17.0353 14.5027C17.3466 14.4357 17.6686 14.4001 18 14.4001C20.2327 14.4001 22.1142 15.9317 22.6476 18.0001H20.4032C19.6083 16.5459 18.4509 15.3415 17.0353 14.5027Z" fill="#303030"/>
    `)
  };
  const SUMMARY_FIELDS = [
    { key: 'first_name', label: 'First Name' },
    { key: 'last_name', label: 'Last Name' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Contact Number' },
    { key: 'birth', label: 'Birthdate' },
    { key: 'gender', label: 'Gender' },
    { key: 'skin_type', label: 'Skin Type' },
    { key: 'skin_tone', label: 'Skin Color' }
  ];
  const SNAPSHOT_FIELD_KEYS = [
    ...new Set([...SUMMARY_FIELDS.map(field => field.key), 'accepts_marketing'])
  ];
  const CAD_AUTH_GENERIC_ERROR_PATTERN =
    /^there was an error with your submission\.?\s*please try again\.?$/i;
  const CAD_AUTH_GENERIC_ERROR_MESSAGE =
    'Please check your details and try again.';

  const normalizeText = value =>
    value ? value.replace(/\s+/g, ' ').trim() : '';

  const getNormalizedLocationHash = () =>
    normalizeText(window.location.hash).replace(/^#/, '').toLowerCase();

  const getAddressModeFromHash = () => {
    const hash = getNormalizedLocationHash();
    if (hash === ADDRESS_HASH_NEW) return 'new';
    if (hash === ADDRESS_HASH_EDIT) return 'edit';
    return null;
  };

  const isAddressesSectionHash = () => {
    return getNormalizedLocationHash() === ADDRESS_HASH_SECTION;
  };

  const updateAddressLocationHash = (mode, { replace = true } = {}) => {
    const nextHash =
      mode === 'new'
        ? ADDRESS_HASH_NEW
        : mode === 'edit'
          ? ADDRESS_HASH_EDIT
          : null;
    const currentHash = getNormalizedLocationHash();
    const isAddressEditorHash =
      currentHash === ADDRESS_HASH_NEW || currentHash === ADDRESS_HASH_EDIT;

    if (nextHash) {
      if (currentHash === nextHash) return;
    } else if (!isAddressEditorHash) {
      return;
    }

    const finalHash = nextHash || ADDRESS_HASH_SECTION;
    const nextUrl = `${window.location.pathname}${window.location.search}#${finalHash}`;

    if (
      replace &&
      window.history &&
      typeof window.history.replaceState === 'function'
    ) {
      window.history.replaceState(window.history.state, '', nextUrl);
      return;
    }

    if (
      !replace &&
      window.history &&
      typeof window.history.pushState === 'function'
    ) {
      window.history.pushState(window.history.state, '', nextUrl);
      return;
    }

    window.location.hash = finalHash;
  };

  const escapeHtml = value =>
    `${value ?? ''}`
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const getCadScrollOffset = () => {
    const stickyHeader = [
      document.querySelector('sticky-header'),
      document.querySelector('.shopify-section-group-header-group'),
      document.querySelector('.shopify-section--header'),
      document.querySelector('.header')
    ].find(element => element && element.getBoundingClientRect().height > 0);

    if (!stickyHeader) return 32;

    return Math.max(
      32,
      Math.round(stickyHeader.getBoundingClientRect().height) + 16
    );
  };

  const ADDRESS_SCROLL_LOCK_CLASSES = [
    'no-scroll',
    'scroll-lock',
    'cad-scroll-lock',
    'overflow-hidden',
    'is-locked',
    'lock-scroll'
  ];

  const unlockAddressScroll = () => {
    [document.documentElement, document.body].forEach(root => {
      if (!(root instanceof HTMLElement)) return;

      [
        'overflow',
        'overflow-x',
        'overflow-y',
        'position',
        'top',
        'left',
        'right',
        'width',
        'height',
        'touch-action',
        'overscroll-behavior'
      ].forEach(property => {
        root.style.removeProperty(property);
      });

      ADDRESS_SCROLL_LOCK_CLASSES.forEach(className => {
        root.classList.remove(className);
      });
    });
  };

  const scrollToCadSectionTop = target => {
    if (!target) return;

    const top = Math.max(
      0,
      window.scrollY + target.getBoundingClientRect().top - getCadScrollOffset()
    );

    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  };

  const isElementVisible = element => {
    if (!element || element.hidden) return false;
    if (element.closest('[hidden], template, [aria-hidden="true"]')) {
      return false;
    }

    return element.getClientRects().length > 0;
  };

  const formatAddressHtml = lines => {
    if (!lines.length) return '-';

    return lines.map(line => `<span>${escapeHtml(line)}</span>`).join('');
  };

  const syncCadLoginCopy = () => {
    if (!isCadAppLoginPage && !isCadAppRegisterPage) return;

    const authRootSelector = "cad-login.cad_login[data-login-style='minimal']";
    const authHashRoutes = new Set(['login', 'recover', 'otp-login']);

    document
      .querySelectorAll(`${authRootSelector} a[href*="#"]`)
      .forEach(link => {
        if (!(link instanceof HTMLAnchorElement)) return;

        const rawHash = normalizeText(link.hash || link.getAttribute('href'))
          .replace(/^#/, '')
          .toLowerCase();
        if (!authHashRoutes.has(rawHash)) return;

        link.setAttribute('allow-hash-change', '');
      });

    if (isCadAppRegisterPage) {
      const registerUrl = `${window.location.pathname}${window.location.search}`;

      document
        .querySelectorAll(`${authRootSelector} cad-otp-login a[href="#login"]`)
        .forEach(link => {
          if (!(link instanceof HTMLAnchorElement)) return;
          if (normalizeText(link.textContent).toLowerCase() !== 'cancel')
            return;

          link.href = registerUrl;
          link.removeAttribute('allow-hash-change');
        });
    }

    const loginForm = document.querySelector(
      `${authRootSelector} #CadCustomerLoginForm1`
    );

    if (loginForm) {
      const submitLabel = loginForm.querySelector('.cad-cta span');
      if (submitLabel && normalizeText(submitLabel.textContent) !== 'LOGIN') {
        submitLabel.textContent = 'LOGIN';
      }

      const createAccountLink = loginForm.querySelector('a.create-account');
      if (createAccountLink instanceof HTMLElement) {
        const signature = 'dont-have-account-sign-up';
        if (createAccountLink.dataset.cadLabelSignature !== signature) {
          const accent = document.createElement('span');
          accent.textContent = 'Sign Up';

          createAccountLink.replaceChildren(
            document.createTextNode('Dont have an account? '),
            accent
          );
          createAccountLink.dataset.cadLabelSignature = signature;
        }
      }
    }

    if (isCadAppRegisterPage) {
      const registerHeader = document.querySelector(
        `${authRootSelector} #login > .login__header [data-user-form='register']`
      );
      if (
        registerHeader &&
        normalizeText(registerHeader.textContent) !== 'Sign Up'
      ) {
        registerHeader.textContent = 'Sign Up';
      }

      const createAccountSubmit = document.querySelector(
        `${authRootSelector} #createAccount .submit-text`
      );
      if (
        createAccountSubmit &&
        normalizeText(createAccountSubmit.textContent) !== 'CREATE ACCOUNT'
      ) {
        createAccountSubmit.textContent = 'CREATE ACCOUNT';
      }

      const registerLoginText = document.querySelector(
        `${authRootSelector} [cad-form-container] > .login`
      );
      if (registerLoginText instanceof HTMLElement) {
        const signature = 'already-have-account-sign-in';
        if (registerLoginText.dataset.cadLabelSignature !== signature) {
          const loginLink = document.createElement('a');
          loginLink.className = 'link';
          loginLink.href = '/apps/deluxe/account/login';
          loginLink.textContent = 'Sign In';

          registerLoginText.replaceChildren(
            document.createTextNode('Already have an account? '),
            loginLink
          );
          registerLoginText.dataset.cadLabelSignature = signature;
        }
      }
    }

    const authErrorNodes = document.querySelectorAll(
      `${authRootSelector} :is(.info, .error, .error-message)`
    );

    authErrorNodes.forEach(node => {
      if (!(node instanceof HTMLElement)) return;
      const currentText = normalizeText(node.textContent);
      if (!CAD_AUTH_GENERIC_ERROR_PATTERN.test(currentText)) return;
      if (currentText === CAD_AUTH_GENERIC_ERROR_MESSAGE) return;
      node.textContent = CAD_AUTH_GENERIC_ERROR_MESSAGE;
    });

    const getProviderKey = element => {
      if (!(element instanceof HTMLAnchorElement)) return '';

      try {
        const provider = normalizeText(
          new URL(element.href, window.location.origin).searchParams.get(
            'social'
          )
        ).toLowerCase();

        if (provider) return provider;
      } catch (_error) {}

      const iconClass = Array.from(
        element.querySelector('.cad-social-login__button')?.classList || []
      ).find(token => token.endsWith('-button'));

      if (!iconClass) return '';

      return iconClass.replace(/-button$/, '').toLowerCase();
    };

    const getProviderName = providerKey => {
      const key = normalizeText(providerKey).toLowerCase();

      const map = {
        google: 'Google',
        apple: 'Apple',
        twitter: 'X',
        x: 'X',
        facebook: 'Facebook',
        linkedin: 'LinkedIn',
        github: 'GitHub',
        microsoft: 'Microsoft',
        amazon: 'Amazon',
        shopify: 'Shopify'
      };

      if (map[key]) return map[key];
      if (!key) return 'Provider';

      return key
        .replace(/[_-]+/g, ' ')
        .split(' ')
        .filter(Boolean)
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
    };

    const socialLinks = document.querySelectorAll(
      `${authRootSelector} cad-social-login .cad-social-login__container--element`
    );

    socialLinks.forEach(link => {
      const providerKey = getProviderKey(link);
      const providerName = getProviderName(providerKey);
      const text = `Continue with ${providerName}`;
      const icon = link.querySelector('.cad-social-login__button');

      let label = link.querySelector('.cad-social-login__label');
      if (!label) {
        label = document.createElement('span');
        label.className = 'cad-social-login__label';
      }

      if (label.textContent !== text) {
        label.textContent = text;
      }

      if (icon) {
        icon.setAttribute('aria-hidden', 'true');
        if (icon.nextElementSibling !== label) {
          icon.insertAdjacentElement('afterend', label);
        }
      } else if (label.parentElement !== link) {
        link.appendChild(label);
      }

      link.dataset.cadSocialProvider = providerKey || 'provider';
      link.setAttribute('aria-label', text);
    });
  };

  const extractAddressLines = container => {
    if (!container) return [];

    const html = `${container.innerHTML || ''}`
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<\/div>/gi, '\n')
      .replace(/<\/li>/gi, '\n')
      .replace(/<\/span>/gi, '\n');

    const temp = document.createElement('div');
    temp.innerHTML = html;

    return `${temp.textContent || temp.innerText || ''}`
      .split('\n')
      .map(normalizeText)
      .filter(Boolean);
  };

  const sanitizeAddressCardLines = lines => {
    return (Array.isArray(lines) ? lines : [])
      .map(normalizeText)
      .filter(Boolean)
      .filter(line => !ADDRESS_CARD_NON_CONTENT_LINE_PATTERN.test(line));
  };

  const formatCadAddressPhoneLocal = digits => {
    const normalized = `${digits ?? ''}`.replace(/\D/g, '').slice(0, 15);
    if (!normalized) return '';
    return normalized.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
  };

  const normalizeCadAddressDialCode = value => {
    const digits = `${value ?? ''}`.replace(/[^\d]/g, '');
    return digits ? `+${digits}` : '';
  };

  const getCadAddressPhoneFlagByDialCode = dialCode => {
    const normalizedDialCode = normalizeCadAddressDialCode(dialCode);
    const byDialCode = {
      '+1': '🇺🇸',
      '+33': '🇫🇷',
      '+34': '🇪🇸',
      '+39': '🇮🇹',
      '+44': '🇬🇧',
      '+49': '🇩🇪',
      '+61': '🇦🇺',
      '+64': '🇳🇿',
      '+90': '🇹🇷',
      '+380': '🇺🇦'
    };

    return byDialCode[normalizedDialCode] || '🌐';
  };

  const getCadAddressPhoneCountryOptions = () => {
    const seenDialCodes = new Set();
    const options = [];

    document
      .querySelectorAll(
        `${CAD_ACCOUNT_SELECTOR} .cad-country-selector select option`
      )
      .forEach(option => {
        if (!(option instanceof HTMLOptionElement)) return;
        if (option.closest('[data-cad-address-phone-selector]')) return;

        const dialCode = normalizeCadAddressDialCode(option.value);
        if (!dialCode || seenDialCodes.has(dialCode)) return;

        const text = normalizeText(option.textContent);
        const flagMatch = text.match(/[\u{1F1E6}-\u{1F1FF}]{2}/u);
        const flag =
          flagMatch?.[0] || getCadAddressPhoneFlagByDialCode(dialCode);
        const label = normalizeText(
          text.replace(/[\u{1F1E6}-\u{1F1FF}]{2}/gu, '')
        );

        options.push({
          dialCode,
          flag,
          label: label || dialCode
        });
        seenDialCodes.add(dialCode);
      });

    if (options.length > 0) return options;

    const fallbackDialCode =
      normalizeCadAddressDialCode(ADDRESS_PHONE_DEFAULT_DIAL_CODE) ||
      ADDRESS_PHONE_DEFAULT_DIAL_CODE;

    return [
      {
        dialCode: fallbackDialCode,
        flag: getCadAddressPhoneFlagByDialCode(fallbackDialCode),
        label: fallbackDialCode
      }
    ];
  };

  const splitCadAddressPhoneValue = (
    rawValue,
    preferredDialCode = ADDRESS_PHONE_DEFAULT_DIAL_CODE,
    knownDialCodes = []
  ) => {
    const normalizedPreferredDialCode =
      normalizeCadAddressDialCode(preferredDialCode) ||
      ADDRESS_PHONE_DEFAULT_DIAL_CODE;
    const raw = normalizeText(rawValue);
    if (!raw) {
      return { dialCode: normalizedPreferredDialCode, digits: '' };
    }

    const normalizedKnownDialCodes = Array.from(
      new Set(
        [
          normalizedPreferredDialCode,
          ADDRESS_PHONE_DEFAULT_DIAL_CODE,
          ...knownDialCodes
        ]
          .map(normalizeCadAddressDialCode)
          .filter(Boolean)
      )
    ).sort((first, second) => second.length - first.length);

    const onlyDigits = raw.replace(/[^\d]/g, '');
    const hasExplicitDialCode = raw.startsWith('+') || raw.startsWith('00');

    if (hasExplicitDialCode) {
      for (const dialCode of normalizedKnownDialCodes) {
        const dialCodeDigits = dialCode.replace(/^\+/, '');
        if (!onlyDigits.startsWith(dialCodeDigits)) continue;

        return {
          dialCode,
          digits: onlyDigits.slice(dialCodeDigits.length)
        };
      }
    }

    return {
      dialCode: normalizedPreferredDialCode,
      digits: onlyDigits
    };
  };

  const buildCadAddressPhoneValue = (
    digits,
    dialCode = ADDRESS_PHONE_DEFAULT_DIAL_CODE
  ) => {
    const normalizedDialCode =
      normalizeCadAddressDialCode(dialCode) || ADDRESS_PHONE_DEFAULT_DIAL_CODE;
    const local = formatCadAddressPhoneLocal(digits);
    return local ? `${normalizedDialCode} ${local}` : '';
  };

  const enforceCadAddressPhoneSelectorStyles = (selector, flag, select) => {
    if (!(selector instanceof HTMLElement)) return;
    if (!(flag instanceof HTMLElement)) return;
    if (!(select instanceof HTMLSelectElement)) return;

    selector.style.setProperty('align-items', 'center', 'important');
    selector.style.setProperty(
      'border-left',
      '1px solid rgb(var(--border-color))',
      'important'
    );
    selector.style.setProperty('display', 'flex', 'important');
    selector.style.setProperty('gap', '0', 'important');
    selector.style.setProperty('height', '43px', 'important');
    selector.style.setProperty('justify-content', 'center', 'important');
    selector.style.setProperty('max-width', '78px', 'important');
    selector.style.setProperty('min-width', '78px', 'important');
    selector.style.setProperty('overflow', 'hidden', 'important');
    selector.style.setProperty('padding-block', '0', 'important');
    selector.style.setProperty('pointer-events', 'auto', 'important');
    selector.style.setProperty('position', 'absolute', 'important');
    selector.style.setProperty('right', '0', 'important');
    selector.style.setProperty('top', '50%', 'important');
    selector.style.setProperty('transform', 'translateY(-50%)', 'important');
    selector.style.setProperty('width', '78px', 'important');
    selector.style.setProperty('cursor', 'pointer', 'important');
    selector.style.setProperty('isolation', 'isolate', 'important');

    flag.style.setProperty('align-items', 'center', 'important');
    flag.style.setProperty('display', 'flex', 'important');
    flag.style.setProperty('font-size', '29px', 'important');
    flag.style.setProperty('height', '21px', 'important');
    flag.style.setProperty('justify-content', 'center', 'important');
    flag.style.setProperty('line-height', '21px', 'important');
    flag.style.setProperty('margin', '0', 'important');
    flag.style.setProperty('max-height', '21px', 'important');
    flag.style.setProperty('max-width', '27px', 'important');
    flag.style.setProperty('min-height', '21px', 'important');
    flag.style.setProperty('min-width', '27px', 'important');
    flag.style.setProperty('overflow', 'hidden', 'important');
    flag.style.setProperty('pointer-events', 'none', 'important');
    flag.style.setProperty('position', 'relative', 'important');
    flag.style.setProperty('transform', 'translate(-8px, -1px)', 'important');
    flag.style.setProperty('transform-origin', 'center', 'important');
    flag.style.setProperty('white-space', 'nowrap', 'important');
    flag.style.setProperty('width', '27px', 'important');
    flag.style.setProperty('z-index', '1', 'important');

    select.style.setProperty('appearance', 'none', 'important');
    select.style.setProperty('-webkit-appearance', 'none', 'important');
    select.style.setProperty('-moz-appearance', 'none', 'important');
    select.style.setProperty('background', 'transparent', 'important');
    select.style.setProperty('border', '0', 'important');
    select.style.setProperty('color', 'transparent', 'important');
    select.style.setProperty('cursor', 'pointer', 'important');
    select.style.setProperty('display', 'block', 'important');
    select.style.setProperty('height', '100%', 'important');
    select.style.setProperty('inset', '0', 'important');
    select.style.setProperty('line-height', '0', 'important');
    select.style.setProperty('margin', '0', 'important');
    select.style.setProperty('max-height', 'none', 'important');
    select.style.setProperty('min-height', '0', 'important');
    select.style.setProperty('opacity', '0', 'important');
    select.style.setProperty('padding', '0', 'important');
    select.style.setProperty('pointer-events', 'auto', 'important');
    select.style.setProperty('position', 'absolute', 'important');
    select.style.setProperty('width', '100%', 'important');
    select.style.setProperty('z-index', '2', 'important');
  };

  const syncCadAddressPhoneCountrySelector = (
    form,
    phoneInput,
    countryOptions
  ) => {
    if (!(form instanceof HTMLFormElement)) return null;
    if (!(phoneInput instanceof HTMLInputElement)) return null;

    const fieldBlock =
      phoneInput.closest('[data-cad-address-field="phone"]') ||
      getAddressFieldBlock(form, phoneInput);
    if (!(fieldBlock instanceof HTMLElement)) return null;

    fieldBlock.dataset.cadAddressPhoneField = 'true';

    let selector = fieldBlock.querySelector(
      '[data-cad-address-phone-selector]'
    );
    if (!(selector instanceof HTMLElement)) {
      selector = document.createElement('div');
      selector.className =
        'cad-country-selector cad-address-phone-country-selector';
      selector.dataset.cadAddressPhoneSelector = 'true';

      const flag = document.createElement('span');
      flag.className = 'flag';
      flag.setAttribute('aria-hidden', 'true');

      const select = document.createElement('select');
      select.className = 'cad-address-phone-country-select';
      select.setAttribute('aria-label', 'Select phone country code');

      selector.append(flag, select);
      fieldBlock.appendChild(selector);
    }

    const select = selector.querySelector('select');
    const flag = selector.querySelector('.flag');
    if (!(select instanceof HTMLSelectElement)) return null;
    if (!(flag instanceof HTMLElement)) return null;

    enforceCadAddressPhoneSelectorStyles(selector, flag, select);

    const normalizedOptions = (
      Array.isArray(countryOptions) ? countryOptions : []
    )
      .map(option => ({
        dialCode:
          normalizeCadAddressDialCode(option?.dialCode) ||
          ADDRESS_PHONE_DEFAULT_DIAL_CODE,
        flag:
          normalizeText(option?.flag) ||
          getCadAddressPhoneFlagByDialCode(option?.dialCode),
        label: normalizeText(option?.label)
      }))
      .filter((option, index, optionsArray) => {
        return (
          !!option.dialCode &&
          optionsArray.findIndex(
            candidate => candidate.dialCode === option.dialCode
          ) === index
        );
      });

    const fallbackDialCode =
      normalizeCadAddressDialCode(ADDRESS_PHONE_DEFAULT_DIAL_CODE) ||
      ADDRESS_PHONE_DEFAULT_DIAL_CODE;
    const fallbackOption = {
      dialCode: fallbackDialCode,
      flag: getCadAddressPhoneFlagByDialCode(fallbackDialCode),
      label: fallbackDialCode
    };
    const optionsForRender =
      normalizedOptions.length > 0 ? normalizedOptions : [fallbackOption];

    const serializedOptions = JSON.stringify(optionsForRender);
    if (select.dataset.cadAddressPhoneOptions !== serializedOptions) {
      select.replaceChildren();
      optionsForRender.forEach(option => {
        const optionNode = new Option(
          option.label || option.dialCode,
          option.dialCode
        );
        optionNode.dataset.flag = option.flag;
        select.options.add(optionNode);
      });
      select.dataset.cadAddressPhoneOptions = serializedOptions;
    }

    selector.dataset.cadAddressPhoneSelectorBound = 'true';
    selector.dataset.cadAddressPhoneOptions = serializedOptions;

    const dialCodes = optionsForRender.map(option => option.dialCode);
    const preferredDialCode =
      normalizeCadAddressDialCode(
        selector.dataset.cadAddressPhoneDialCode || ''
      ) ||
      normalizeCadAddressDialCode(
        `+${normalizeText(phoneInput.dataset.prefix).replace(/^\+/, '')}`
      ) ||
      dialCodes[0] ||
      fallbackDialCode;

    if (
      dialCodes.includes(preferredDialCode) &&
      select.value !== preferredDialCode
    ) {
      select.value = preferredDialCode;
    } else if (!dialCodes.includes(select.value) && dialCodes.length > 0) {
      select.value = dialCodes[0];
    }

    if (selector.dataset.cadAddressPhoneSelectBound !== 'true') {
      select.addEventListener('change', () => {
        const knownDialCodes = Array.from(select.options)
          .map(option => normalizeCadAddressDialCode(option.value))
          .filter(Boolean);
        const dialCode =
          normalizeCadAddressDialCode(select.value) ||
          knownDialCodes[0] ||
          fallbackDialCode;
        const parsed = splitCadAddressPhoneValue(
          phoneInput.value,
          dialCode,
          knownDialCodes
        );

        const nextValue = buildCadAddressPhoneValue(parsed.digits, dialCode);
        const nextPrefix = dialCode.replace(/^\+/, '');
        const nextPlaceholder = `${dialCode} 000 000 00 00`;

        if (phoneInput.value !== nextValue) {
          phoneInput.value = nextValue;
        }

        if (phoneInput.dataset.prefix !== nextPrefix) {
          phoneInput.dataset.prefix = nextPrefix;
        }

        if (phoneInput.getAttribute('placeholder') !== nextPlaceholder) {
          phoneInput.setAttribute('placeholder', nextPlaceholder);
        }

        const selectedOption = select.selectedOptions?.[0];
        const selectedFlag =
          normalizeText(selectedOption?.dataset.flag) ||
          getCadAddressPhoneFlagByDialCode(dialCode);
        if (flag.textContent !== selectedFlag) {
          flag.textContent = selectedFlag;
        }

        selector.dataset.cadAddressPhoneDialCode = dialCode;
      });
      selector.dataset.cadAddressPhoneSelectBound = 'true';
    }

    const selectedOption = select.selectedOptions?.[0];
    const selectedDialCode =
      normalizeCadAddressDialCode(select.value) ||
      dialCodes[0] ||
      fallbackDialCode;
    const selectedFlag =
      normalizeText(selectedOption?.dataset.flag) ||
      getCadAddressPhoneFlagByDialCode(selectedDialCode);
    if (flag.textContent !== selectedFlag) {
      flag.textContent = selectedFlag;
    }
    selector.dataset.cadAddressPhoneDialCode = selectedDialCode;

    return { selector, select, flag, dialCodes };
  };

  const bindCadAddressPhoneMask = form => {
    if (!(form instanceof HTMLFormElement)) return;

    const phoneInput = form.querySelector(
      'input[name="address[phone]"], input[name*="[phone]"]'
    );
    if (!(phoneInput instanceof HTMLInputElement)) return;
    if (phoneInput.type === 'hidden') return;

    const countryOptions = getCadAddressPhoneCountryOptions();
    const countrySelector = syncCadAddressPhoneCountrySelector(
      form,
      phoneInput,
      countryOptions
    );
    const countrySelect = countrySelector?.select;
    const countryFlag = countrySelector?.flag;
    const knownDialCodes = countrySelector?.dialCodes;

    const syncValue = () => {
      const parsed = splitCadAddressPhoneValue(
        phoneInput.value,
        countrySelect?.value || ADDRESS_PHONE_DEFAULT_DIAL_CODE,
        Array.isArray(knownDialCodes)
          ? knownDialCodes
          : Array.isArray(countryOptions)
            ? countryOptions.map(option => option.dialCode)
            : []
      );

      const effectiveDialCode =
        normalizeCadAddressDialCode(parsed.dialCode) ||
        ADDRESS_PHONE_DEFAULT_DIAL_CODE;

      if (countrySelector?.selector instanceof HTMLElement) {
        countrySelector.selector.dataset.cadAddressPhoneDialCode =
          effectiveDialCode;
      }

      if (countryFlag instanceof HTMLElement) {
        if (
          countrySelect instanceof HTMLSelectElement &&
          Array.from(countrySelect.options).some(
            option =>
              normalizeCadAddressDialCode(option.value) === effectiveDialCode
          )
        ) {
          if (
            normalizeCadAddressDialCode(countrySelect.value) !==
            effectiveDialCode
          ) {
            countrySelect.value = effectiveDialCode;
          }
        }

        const selectedOption =
          countrySelect instanceof HTMLSelectElement
            ? countrySelect.selectedOptions?.[0]
            : null;
        const resolvedFlag =
          normalizeText(selectedOption?.dataset.flag) ||
          getCadAddressPhoneFlagByDialCode(effectiveDialCode);
        if (countryFlag.textContent !== resolvedFlag) {
          countryFlag.textContent = resolvedFlag;
        }
      }

      const nextPrefix = effectiveDialCode.replace(/^\+/, '');
      const nextValue = buildCadAddressPhoneValue(
        parsed.digits,
        effectiveDialCode
      );
      const nextPlaceholder = `${effectiveDialCode} 000 000 00 00`;

      if (phoneInput.dataset.prefix !== nextPrefix) {
        phoneInput.dataset.prefix = nextPrefix;
      }

      if (phoneInput.value !== nextValue) {
        phoneInput.value = nextValue;
      }

      if (phoneInput.getAttribute('placeholder') !== nextPlaceholder) {
        phoneInput.setAttribute('placeholder', nextPlaceholder);
      }
    };

    phoneInput.setAttribute('type', 'tel');
    phoneInput.setAttribute('inputmode', 'tel');
    phoneInput.setAttribute('autocomplete', 'tel');

    if (phoneInput.__cadAddressPhoneMaskBound !== true) {
      phoneInput.addEventListener('input', syncValue);
      phoneInput.addEventListener('blur', syncValue);
      phoneInput.__cadAddressPhoneMaskBound = true;
      phoneInput.dataset.cadAddressPhoneMaskBound = 'true';
    }

    syncValue();
  };

  const getAddressFieldValue = (scope, fieldNames) => {
    if (!(scope instanceof Element)) return '';

    for (const fieldName of fieldNames) {
      const control = scope.querySelector(`[name="${fieldName}"]`);
      if (!(control instanceof HTMLInputElement)) continue;

      const value = normalizeText(control.value);
      if (value) return value;
    }

    return '';
  };

  const getNativeAddAddressButton = frame => {
    if (!(frame instanceof Element)) return null;

    const candidates = Array.from(
      frame.querySelectorAll(NATIVE_ADD_ADDRESS_BUTTON_SELECTOR)
    ).filter(node => !node.matches('[data-cad-address-add-card]'));

    const resolveActionTarget = candidate => {
      if (!(candidate instanceof HTMLElement)) return null;

      if (
        candidate.matches(
          'button, a, [role="button"], input[type="button"], input[type="submit"]'
        )
      ) {
        return candidate;
      }

      const nestedAction = candidate.querySelector(
        'button, a, [role="button"], input[type="button"], input[type="submit"]'
      );

      return nestedAction instanceof HTMLElement ? nestedAction : candidate;
    };

    const visibleCandidate = candidates.find(isElementVisible) || candidates[0];
    return resolveActionTarget(visibleCandidate) || null;
  };

  const getNativeNewAddressForm = frame => {
    if (!(frame instanceof Element)) return null;
    const scopedForms = Array.from(
      frame.querySelectorAll(':scope > .cad-frame--data form')
    ).filter(isAddressEditorForm);
    const explicitMatch = scopedForms.find(isNewAddressEditorForm);
    if (explicitMatch) return explicitMatch;

    return frame.querySelector(NATIVE_NEW_ADDRESS_FORM_SELECTOR);
  };

  const revealAddressEditorNode = node => {
    if (!(node instanceof HTMLElement)) return;

    node.hidden = false;
    node.removeAttribute('hidden');
    node.removeAttribute('aria-hidden');
    node.classList.remove('cad-hide', 'hidden');
    node.style.removeProperty('display');
    node.style.removeProperty('visibility');
    node.style.removeProperty('opacity');
  };

  const revealNewAddressEditor = form => {
    if (!(form instanceof HTMLFormElement)) return;

    revealAddressEditorNode(form);
    revealAddressEditorNode(form.parentElement);
    const editorHost = form.closest(
      '.edit, .cad--new-address, .add-address, [data-cad-address-new], [data-address-new]'
    );
    revealAddressEditorNode(editorHost);

    if (editorHost instanceof HTMLElement) {
      editorHost.classList.add('open');
      editorHost.classList.remove('closed');
    }

    const addressHost = form.closest(
      'cad-address, .add-address, .cad--new-address'
    );
    if (addressHost instanceof HTMLElement) {
      addressHost.classList.add('open');
      addressHost.classList.remove('closed');
    }

    let parent = form.parentElement;
    while (parent && !parent.matches('.cad-frame--data')) {
      revealAddressEditorNode(parent);
      parent = parent.parentElement;
    }
  };

  const clearNewAddressOpenRetry = frame => {
    if (!frame || !frame.__cadAddressNewOpenRetryTimer) return;

    window.clearTimeout(frame.__cadAddressNewOpenRetryTimer);
    frame.__cadAddressNewOpenRetryTimer = 0;
  };

  const ensureNativeNewAddressEditorOpened = frame => {
    if (!frame) return;

    clearNewAddressOpenRetry(frame);
    const tryOpen = () => {
      const form = getNativeNewAddressForm(frame);
      if (form) {
        revealNewAddressEditor(form);
        scheduleAddressesResync();
        return true;
      }

      const nativeAddButton = getNativeAddAddressButton(frame);
      if (nativeAddButton) {
        clickAddressControl(frame, nativeAddButton, true);
      }

      return false;
    };

    if (tryOpen()) return;

    frame.__cadAddressNewOpenRetryTimer = window.setTimeout(() => {
      frame.__cadAddressNewOpenRetryTimer = 0;
      if (frame.dataset.cadAddressesEditorMode !== 'new') return;
      tryOpen();
    }, 220);
  };

  const buildAddressLinesFromCardForm = card => {
    if (!(card instanceof Element)) return [];

    const form =
      card.querySelector('form[id^="address_form_"]') ||
      card.querySelector('form[action*="/account/addresses/"]');
    if (!(form instanceof HTMLFormElement)) return [];

    const firstName = getAddressFieldValue(form, [
      'address[firstName]',
      'address[first_name]'
    ]);
    const lastName = getAddressFieldValue(form, [
      'address[lastName]',
      'address[last_name]'
    ]);

    const fullName = normalizeText(
      [firstName, lastName].filter(Boolean).join(' ')
    );
    const lines = [];

    if (fullName) {
      lines.push(fullName);
    }

    [
      ['address[address1]'],
      ['address[address2]'],
      ['address[company]'],
      ['address[zip]'],
      ['address[phone]'],
      ['address[city]'],
      ['address[country]'],
      ['address[province]']
    ].forEach(fieldNames => {
      const value = getAddressFieldValue(form, fieldNames);
      if (value) {
        lines.push(value);
      }
    });

    return lines;
  };

  const formatDelimitedDate = (firstPart, secondPart, yearPart) => {
    const first = Number.parseInt(firstPart, 10);
    const second = Number.parseInt(secondPart, 10);
    const year = Number.parseInt(yearPart, 10);

    if (
      Number.isNaN(first) ||
      Number.isNaN(second) ||
      Number.isNaN(year) ||
      yearPart.length !== 4
    ) {
      return null;
    }

    if (first < 1 || first > 31 || second < 1 || second > 31) {
      return null;
    }

    if (first > 12 && second > 12) return null;

    let day = first;
    let month = second;

    if (second > 12 && first <= 12) {
      month = first;
      day = second;
    }

    if (month < 1 || month > 12 || day < 1 || day > 31) {
      return null;
    }

    return `${`${day}`.padStart(2, '0')}.${`${month}`.padStart(2, '0')}.${yearPart}`;
  };

  const formatDate = value => {
    const normalized = normalizeText(value);

    if (!normalized) return '-';

    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
      const [year, month, day] = normalized.split('-');
      return `${day}.${month}.${year}`;
    }

    if (/^\d{1,2}\.\d{1,2}\.\d{4}$/.test(normalized)) {
      const [firstPart, secondPart, yearPart] = normalized.split('.');
      return formatDelimitedDate(firstPart, secondPart, yearPart) || normalized;
    }

    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(normalized)) {
      const [firstPart, secondPart, yearPart] = normalized.split('/');
      return formatDelimitedDate(firstPart, secondPart, yearPart) || normalized;
    }

    const parsed = new Date(normalized);

    if (Number.isNaN(parsed.getTime())) {
      return normalized;
    }

    const day = `${parsed.getDate()}`.padStart(2, '0');
    const month = `${parsed.getMonth() + 1}`.padStart(2, '0');
    const year = parsed.getFullYear();

    return `${day}.${month}.${year}`;
  };

  const formatOrderDate = order => {
    const raw = normalizeText(order.dataset.createdAtRaw);

    if (raw) {
      const parsed = new Date(raw);

      if (!Number.isNaN(parsed.getTime())) {
        return new Intl.DateTimeFormat('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        }).format(parsed);
      }
    }

    const display = normalizeText(order.dataset.createdAt);

    if (!display) return '-';

    return normalizeText(display.split(' at ')[0]);
  };

  const getFavoritesItemsPerPage = () => {
    if (typeof window.matchMedia !== 'function') {
      return FAVORITES_ITEMS_PER_PAGE;
    }

    return window.matchMedia(FAVORITES_TABLET_MEDIA_QUERY).matches
      ? FAVORITES_ITEMS_PER_PAGE_TABLET
      : FAVORITES_ITEMS_PER_PAGE;
  };

  const parsePositiveInt = (value, fallback = 1) => {
    const parsed = Number.parseInt(`${value ?? ''}`, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  };

  const resolveCurrentPage = (rawPageValue, totalPages) => {
    return Math.min(Math.max(parsePositiveInt(rawPageValue, 1), 1), totalPages);
  };

  const applyPagedVisibility = (items, currentPage, itemsPerPage) => {
    items.forEach((item, index) => {
      const itemPage = Math.floor(index / itemsPerPage) + 1;
      const isVisible = itemPage === currentPage;
      item.hidden = !isVisible;
      item.style.display = isVisible ? '' : 'none';
    });
  };

  const buildPaginationMarkup = ({
    totalPages,
    currentPage,
    pageDataAttribute
  }) => {
    if (totalPages <= 1) return '';

    const pageMarkup = Array.from({ length: totalPages }, (_, index) => {
      const page = index + 1;

      if (page === currentPage) {
        return `<div class="page current">${page}</div>`;
      }

      return `<div class="page"><a href="#" ${pageDataAttribute}="${page}">${page}</a></div>`;
    }).join('');

    const prevMarkup =
      currentPage > 1
        ? `<div class="prev"><a href="#" ${pageDataAttribute}="${currentPage - 1}">Prev</a></div>`
        : '';

    const nextMarkup =
      currentPage < totalPages
        ? `<div class="next"><a href="#" ${pageDataAttribute}="${currentPage + 1}">Next</a></div>`
        : '';

    return `
      <div class="orders-pagination">
        ${prevMarkup}
        ${pageMarkup}
        ${nextMarkup}
      </div>
    `;
  };

  const syncPaginationMarkup = (host, pagination, cacheKey, markup) => {
    if (!host || !pagination) return;

    const nextMarkup = markup || '';
    if ((host[cacheKey] || '') === nextMarkup) return;

    pagination.innerHTML = nextMarkup;
    host[cacheKey] = nextMarkup;
  };

  const isBirthPlaceholderValue = (value, control) => {
    const normalized = normalizeText(value).toLowerCase();
    if (!normalized) return true;

    const placeholder = normalizeText(
      control?.getAttribute('placeholder')
    ).toLowerCase();
    if (placeholder && normalized === placeholder) return true;

    const defaultValue = normalizeText(
      control?.getAttribute('data-default') || control?.dataset?.default
    ).toLowerCase();
    if (
      defaultValue &&
      normalized === defaultValue &&
      /[dmy]/i.test(defaultValue)
    ) {
      return true;
    }

    if (/^[dmy.\-/\s]+$/i.test(normalized) && /[dmy]/i.test(normalized)) {
      return true;
    }

    return normalized === '0000-00-00';
  };

  const normalizePhoneInputValue = value => {
    const compact = normalizeText(value).replace(/[^\d+]/g, '');
    if (!compact) return '';

    if (compact.startsWith('+')) {
      return `+${compact.slice(1).replace(/\+/g, '')}`;
    }

    return compact.replace(/\+/g, '');
  };

  const getPhonePrefixDigits = input => {
    if (!(input instanceof HTMLInputElement)) return '';

    const inputPrefix = normalizeText(input.dataset.prefix);
    if (inputPrefix) return inputPrefix.replace(/[^\d]/g, '');

    const cadField = input.closest('cad-field');
    const selectedPrefix = normalizeText(
      cadField?.querySelector('.cad-country-selector select option:checked')
        ?.value
    );
    if (selectedPrefix) return selectedPrefix.replace(/[^\d]/g, '');

    return '';
  };

  const toCadE164PhoneValue = (rawValue, input) => {
    const normalized = normalizePhoneInputValue(rawValue);
    if (!normalized) return '';

    const digits = normalized
      .replace(/^\+/, '')
      .replace(/^00/, '')
      .replace(/[^\d]/g, '');
    if (!digits) return '';

    const prefixDigits = getPhonePrefixDigits(input);

    if (!prefixDigits) {
      return `+${digits}`;
    }

    let localDigits = digits;

    if (localDigits.startsWith(prefixDigits)) {
      localDigits = localDigits.slice(prefixDigits.length);
    }

    localDigits = localDigits.replace(/^0+/, '') || localDigits;

    if (prefixDigits === '44') {
      while (localDigits.startsWith('44') && localDigits.length > 10) {
        localDigits = localDigits.slice(2);
      }
    }

    return localDigits ? `+${prefixDigits}${localDigits}` : `+${prefixDigits}`;
  };

  const clearPhoneFieldInvalidState = input => {
    if (!(input instanceof HTMLInputElement)) return;

    const wrapper = input.closest('.cad-frame--data__account--field');
    if (wrapper instanceof HTMLElement) {
      wrapper.classList.remove('invalid');
    }

    const error = input
      .closest('.cad-frame--field--container')
      ?.querySelector('.error');
    if (!(error instanceof HTMLElement)) return;

    if (
      /please enter a valid (value|phone number)/i.test(
        normalizeText(error.textContent)
      )
    ) {
      error.textContent = '';
    }
  };

  const setPhoneFieldInvalidState = (
    input,
    message = ACCOUNT_PHONE_INVALID_MESSAGE
  ) => {
    if (!(input instanceof HTMLInputElement)) return;

    const wrapper = input.closest('.cad-frame--data__account--field');
    if (wrapper instanceof HTMLElement) {
      wrapper.classList.add('invalid');
    }

    input.setCustomValidity(message);

    const error = input
      .closest('.cad-frame--field--container')
      ?.querySelector('.error');
    if (error instanceof HTMLElement) {
      error.textContent = message;
    }
  };

  const applyCadPhoneValue = (input, nextValue, dispatchEvents = false) => {
    if (!(input instanceof HTMLInputElement)) return;

    const value = normalizeText(nextValue);
    input.value = value;

    const cadField = input.closest('cad-field');
    if (cadField instanceof HTMLElement) {
      cadField.setAttribute('data-field-value', value);
    }

    const wrapper = input.closest('.cad-frame--data__account--field');
    if (wrapper instanceof HTMLElement) {
      if (wrapper.hasAttribute('data-current-value')) {
        wrapper.setAttribute('data-current-value', value);
      }
      wrapper.classList.remove('invalid');
    }

    if (!dispatchEvents) return;

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const getAccountPhoneInputs = frame => {
    if (!frame) return [];

    return Array.from(
      frame.querySelectorAll(
        `${CAD_ACCOUNT_SELECTOR} input[name="customer[phone]"], ${CAD_ACCOUNT_SELECTOR} input[type="tel"][name*="[phone]"]`
      )
    ).filter(
      input => input instanceof HTMLInputElement && input.type !== 'hidden'
    );
  };

  const isRenderedAccountInput = input => {
    if (!(input instanceof HTMLInputElement)) return false;
    if (input.type === 'hidden') return false;

    const style = window.getComputedStyle(input);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    return input.getClientRects().length > 0;
  };

  const getAccountPhoneInputRawValue = input => {
    if (!(input instanceof HTMLInputElement)) return '';

    const wrapper = input.closest('.cad-frame--data__account--field');
    const cadField =
      input.closest('cad-field') || wrapper?.querySelector('cad-field');

    const candidates = [
      normalizeText(input.value),
      normalizeText(wrapper?.getAttribute('data-current-value')),
      normalizeText(cadField?.getAttribute('data-field-value'))
    ];

    return candidates.find(Boolean) || '';
  };

  const getPhoneLocalDigits = (rawValue, input) => {
    const normalized = toCadE164PhoneValue(rawValue, input);
    if (!normalized) return '';

    const digits = normalized.replace(/^\+/, '').replace(/[^\d]/g, '');
    const prefixDigits = getPhonePrefixDigits(input);
    let localDigits = digits;

    if (prefixDigits && localDigits.startsWith(prefixDigits)) {
      localDigits = localDigits.slice(prefixDigits.length);
    }

    localDigits = localDigits.replace(/^0+/, '') || localDigits;
    return localDigits;
  };

  const getPhoneLocalDigitsLength = (rawValue, input) => {
    return getPhoneLocalDigits(rawValue, input).length;
  };

  const isPhoneInputValueValid = (input, rawValue = input?.value) => {
    const rawInput = `${rawValue ?? ''}`;
    const raw = normalizeText(rawInput);
    if (!raw) return true;

    if (/\s/.test(rawInput)) return false;
    if (/[A-Za-zА-Яа-яЁёІіЇїЄєҐґ]/.test(rawInput)) return false;

    const localDigits = getPhoneLocalDigits(raw, input);
    const localDigitsLength = localDigits.length;
    if (localDigitsLength < ACCOUNT_PHONE_MIN_LOCAL_DIGITS) return false;

    const prefixDigits = getPhonePrefixDigits(input);
    if (
      prefixDigits === '44' &&
      localDigitsLength > ACCOUNT_PHONE_GB_MAX_LOCAL_DIGITS
    ) {
      return false;
    }

    return localDigitsLength <= ACCOUNT_PHONE_MAX_LOCAL_DIGITS;
  };

  const validatePhoneInput = (input, rawValue = input?.value) => {
    if (!(input instanceof HTMLInputElement)) return true;

    if (isPhoneInputValueValid(input, rawValue)) {
      input.setCustomValidity('');
      clearPhoneFieldInvalidState(input);
      return true;
    }

    setPhoneFieldInvalidState(input, ACCOUNT_PHONE_INVALID_MESSAGE);
    return false;
  };

  const syncAccountPhoneLabel = frame => {
    if (!frame) return;

    frame
      .querySelectorAll(
        `${CAD_ACCOUNT_SELECTOR} [data-customer-field="phone"] .cad-frame--data__account--label span`
      )
      .forEach(label => {
        if (!(label instanceof HTMLElement)) return;
        if (label.textContent === 'Contact Number') return;
        label.textContent = 'Contact Number';
      });
  };

  const syncAccountPhoneValidation = frame => {
    syncAccountPhoneLabel(frame);

    getAccountPhoneInputs(frame).forEach(input => {
      if (input.type !== 'text') {
        input.setAttribute('type', 'text');
      }
      input.setAttribute('inputmode', 'tel');
      input.setAttribute('autocomplete', 'tel');
      input.removeAttribute('pattern');
      input.removeAttribute('maxlength');

      input.setCustomValidity('');

      if (input.dataset.cadPhoneValidationBound === 'true') return;

      input.dataset.cadPhoneValidationBound = 'true';

      input.addEventListener('input', event => {
        input.setCustomValidity('');
        clearPhoneFieldInvalidState(input);
        if (!event.isTrusted) return;
        rememberCadTypedPhoneValue(input, input.value);
      });

      input.addEventListener('change', event => {
        validatePhoneInput(input);
        if (!event.isTrusted) return;
        rememberCadTypedPhoneValue(input, input.value);
      });

      input.addEventListener('invalid', () => {
        validatePhoneInput(input);
      });
    });
  };

  const normalizeAccountPhoneBeforeSubmit = frame => {
    const phoneInputs = getAccountPhoneInputs(frame);
    if (!phoneInputs.length) return true;

    const sourceInput =
      phoneInputs.find(input => isRenderedAccountInput(input)) ||
      phoneInputs[phoneInputs.length - 1] ||
      phoneInputs[0];
    if (!(sourceInput instanceof HTMLInputElement)) return;

    const hasFreshTypedValue =
      normalizeText(cadLatestTypedPhoneValue) &&
      Date.now() - cadLatestTypedPhoneAt <= CAD_TYPED_PHONE_TTL_MS;
    const rawSourceValue = hasFreshTypedValue
      ? cadLatestTypedPhoneValue
      : getAccountPhoneInputRawValue(sourceInput);

    if (!normalizeText(rawSourceValue)) {
      phoneInputs.forEach(input => {
        input.setCustomValidity('');
        clearPhoneFieldInvalidState(input);
      });
      return true;
    }

    if (!validatePhoneInput(sourceInput, rawSourceValue)) {
      return false;
    }

    const normalizedValue = toCadE164PhoneValue(rawSourceValue, sourceInput);
    if (!normalizedValue) {
      setPhoneFieldInvalidState(sourceInput, ACCOUNT_PHONE_INVALID_MESSAGE);
      return false;
    }

    cadLatestTypedPhoneValue = normalizedValue;
    cadLatestTypedPhoneAt = Date.now();

    phoneInputs.forEach(input => {
      applyCadPhoneValue(input, normalizedValue, false);
      input.setCustomValidity('');
      clearPhoneFieldInvalidState(input);
    });

    sourceInput.dispatchEvent(new Event('input', { bubbles: true }));
    sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  const toBirthSubmitValue = value => {
    const normalized = normalizeText(value);
    if (!normalized) return '';

    const displayValue = formatDate(normalized);
    if (!/^\d{2}\.\d{2}\.\d{4}$/.test(displayValue)) {
      return normalized;
    }

    return displayValue.replace(/\./g, '/');
  };

  const normalizeAccountBirthBeforeSubmit = frame => {
    if (!(frame instanceof HTMLElement)) return true;

    const profile = frame.querySelector(CAD_ACCOUNT_SELECTOR);
    if (!(profile instanceof HTMLElement)) return true;

    const birthContainer = getAccountFieldByKey(profile, 'birth');
    if (!(birthContainer instanceof HTMLElement)) return true;

    const control = getFieldControl(birthContainer);
    if (
      !(
        control instanceof HTMLInputElement ||
        control instanceof HTMLTextAreaElement
      )
    ) {
      return true;
    }

    const rawValue = normalizeText(control.value);
    if (!rawValue || isBirthPlaceholderValue(rawValue, control)) return true;

    const submitValue = toBirthSubmitValue(rawValue);
    if (!submitValue || submitValue === rawValue) return true;

    control.value = submitValue;

    const wrapper = getFieldWrapper(birthContainer);
    if (wrapper?.hasAttribute('data-current-value')) {
      wrapper.setAttribute('data-current-value', submitValue);
    }

    const cadField = birthContainer.querySelector('cad-field');
    if (cadField) cadField.setAttribute('data-field-value', submitValue);

    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));

    return true;
  };

  let cadAccountSavePending = false;
  let cadAccountSavePendingTimer = 0;
  let cadAccountSaveNavigationSeen = false;
  let cadEndpointFetchInFlight = null;
  let cadEndpointFetchInFlightKey = '';
  let cadEndpointFetchInFlightAt = 0;
  let cadLatestTypedPhoneValue = '';
  let cadLatestTypedPhoneAt = 0;

  const rememberCadTypedPhoneValue = (input, value) => {
    if (!(input instanceof HTMLInputElement)) return;

    const normalizedValue = toCadE164PhoneValue(value, input);
    if (!normalizedValue) return;

    cadLatestTypedPhoneValue = normalizedValue;
    cadLatestTypedPhoneAt = Date.now();
  };

  const getCadPathname = targetUrl => {
    const value = normalizeText(targetUrl);
    if (!value) return '';

    try {
      return new URL(value, window.location.origin).pathname;
    } catch (_error) {
      return '';
    }
  };

  const isCadEndpointPath = targetUrl => {
    const pathname = getCadPathname(targetUrl);
    return (
      pathname === CAD_ENDPOINT_PATH || pathname === `${CAD_ENDPOINT_PATH}/`
    );
  };

  const isCadAccountPath = targetUrl => {
    const pathname = getCadPathname(targetUrl);
    return (
      pathname === CAD_ACCOUNT_PAGE_PATH ||
      pathname === `${CAD_ACCOUNT_PAGE_PATH}/`
    );
  };

  const shouldBlockCadAccountNavigation = targetUrl => {
    if (!isCadAccountPath(targetUrl)) return false;

    const blockUntil = Number.parseInt(
      `${window.__cadAccountNavBlockUntil ?? ''}`,
      10
    );
    const isTimeBlocked =
      Number.isFinite(blockUntil) && Date.now() <= blockUntil;

    if (!cadAccountSavePending && !isTimeBlocked) return false;

    if (!cadAccountSaveNavigationSeen) {
      cadAccountSaveNavigationSeen = true;
      return false;
    }

    return true;
  };

  const markCadAccountSavePending = frame => {
    cadAccountSavePending = true;
    cadAccountSaveNavigationSeen = false;
    if (frame instanceof HTMLElement) {
      frame.dataset.cadAccountSavePending = 'true';
    }

    window.__cadAccountNavBlockUntil = Date.now() + CAD_ACCOUNT_NAV_BLOCK_MS;

    window.clearTimeout(cadAccountSavePendingTimer);
    cadAccountSavePendingTimer = window.setTimeout(() => {
      cadAccountSavePending = false;
      if (frame instanceof HTMLElement) {
        delete frame.dataset.cadAccountSavePending;
      }
      window.__cadAccountNavBlockUntil = 0;
    }, CAD_ACCOUNT_SAVE_PENDING_TIMEOUT_MS);
  };

  const clearCadAccountSavePending = frame => {
    cadAccountSavePending = false;
    cadAccountSaveNavigationSeen = false;
    if (frame instanceof HTMLElement) {
      delete frame.dataset.cadAccountSavePending;
      const saveActionButton = frame.querySelector(
        '[data-cad-account-edit-save]'
      );
      if (saveActionButton instanceof HTMLButtonElement) {
        delete saveActionButton.dataset.cadLoading;
        saveActionButton.disabled = false;
        saveActionButton.removeAttribute('aria-busy');
      }
    }

    window.clearTimeout(cadAccountSavePendingTimer);
    cadAccountSavePendingTimer = 0;
    window.__cadAccountNavBlockUntil = 0;
    cadEndpointFetchInFlight = null;
    cadEndpointFetchInFlightKey = '';
    cadEndpointFetchInFlightAt = 0;
  };

  const getAddressEditorTitle = modeOrFrame =>
    (typeof modeOrFrame === 'string'
      ? modeOrFrame
      : modeOrFrame?.dataset?.cadAddressesEditorMode) === 'new'
      ? 'Add new Address'
      : 'Edit Address';

  const setManagedAddressesTitle = (frame, titleElement, text) => {
    if (!frame || !titleElement) return;

    frame.dataset.cadAddressesTitle = text;
    titleElement.dataset.cadAddressManagedTitle = text;
    titleElement.setAttribute('aria-label', text);

    if (normalizeText(titleElement.textContent) !== text) {
      titleElement.textContent = text;
    }
  };

  const getAddressFieldBlock = (form, control) => {
    if (!control) return null;

    const getScopedFieldControls = container =>
      Array.from(
        container.querySelectorAll(
          'input:not([type="hidden"]), select, textarea'
        )
      ).filter(field => field.closest('form') === form);

    const containerSelectors = [
      '.cad-frame--field--container',
      '.cad-frame--data__account--field',
      '.form-control',
      '.field',
      '.input-wrapper',
      '.cf-field',
      '.cf-field-container',
      '.checkbox-control'
    ];

    for (const selector of containerSelectors) {
      const container = control.closest(selector);

      if (container && container.closest('form') === form) {
        const controlsInContainer = getScopedFieldControls(container);

        if (
          container !== control &&
          control.type !== 'checkbox' &&
          controlsInContainer.length > 1
        ) {
          continue;
        }

        return container;
      }
    }

    const fallback =
      control.closest('label, div, p, li') || control.parentElement || control;

    return fallback.closest('form') === form ? fallback : control;
  };

  const getAddressFieldLabelNode = block => {
    if (!block) return null;

    return block.querySelector(
      'label, legend, .floating-label, .label, .field__label, .cad-frame--field--label, .cad-frame--data__account--label'
    );
  };

  const getAddressFieldLabelText = block => {
    if (!block) return '';

    const label = getAddressFieldLabelNode(block);

    return normalizeText(label?.textContent).toLowerCase();
  };

  const getAddressFieldKey = block => {
    if (!block) return '';

    const control = block.querySelector(
      'input:not([type="hidden"]), select, textarea'
    );
    const controlName = normalizeText(
      control?.getAttribute('name')
    ).toLowerCase();
    const labelText = getAddressFieldLabelText(block);
    const helperText = `${controlName} ${labelText}`;

    if (
      control?.type === 'checkbox' ||
      controlName.includes('address[default]') ||
      controlName.includes('[default]') ||
      helperText.includes('default')
    ) {
      return 'default';
    }

    if (
      helperText.includes('address[first_name]') ||
      helperText.includes('firstname') ||
      helperText.includes('first name')
    ) {
      return 'first_name';
    }

    if (
      helperText.includes('address[last_name]') ||
      helperText.includes('lastname') ||
      helperText.includes('last name')
    ) {
      return 'last_name';
    }

    if (
      helperText.includes('address[address1]') ||
      helperText.includes('address1') ||
      helperText.includes('address line 1') ||
      helperText.includes('address 1')
    ) {
      return 'address1';
    }

    if (
      helperText.includes('address[address2]') ||
      helperText.includes('address2') ||
      helperText.includes('address line 2') ||
      helperText.includes('address 2')
    ) {
      return 'address2';
    }

    if (helperText.includes('company')) return 'company';
    if (
      helperText.includes('address[zip]') ||
      helperText.includes('postal') ||
      helperText.includes('zip')
    ) {
      return 'zip';
    }

    if (
      helperText.includes('address[phone]') ||
      helperText.includes('phone') ||
      helperText.includes('contact number')
    ) {
      return 'phone';
    }

    if (helperText.includes('address[city]') || helperText.includes('city')) {
      return 'city';
    }

    if (
      helperText.includes('address[country]') ||
      helperText.includes('country')
    ) {
      return 'country';
    }

    if (
      helperText.includes('address[province]') ||
      helperText.includes('province') ||
      helperText.includes('state') ||
      helperText.includes('greater area')
    ) {
      return 'province';
    }

    return '';
  };

  const getAddressFormFieldControl = (form, fieldKey) => {
    if (!(form instanceof HTMLFormElement)) return null;

    const block = form.querySelector(`[data-cad-address-field="${fieldKey}"]`);
    if (block instanceof Element) {
      const control = block.querySelector(
        'input:not([type="hidden"]), select, textarea'
      );
      if (
        control instanceof HTMLInputElement ||
        control instanceof HTMLTextAreaElement ||
        control instanceof HTMLSelectElement
      ) {
        return control;
      }
    }

    const fallbackSelectors = {
      address1:
        'input[name="address[address1]"], textarea[name="address[address1]"], input[name*="[address1]"], textarea[name*="[address1]"]',
      city: 'input[name="address[city]"], textarea[name="address[city]"], input[name*="[city]"], textarea[name*="[city]"]'
    };

    const fallbackSelector = fallbackSelectors[fieldKey];
    if (!fallbackSelector) return null;

    const fallbackControl = form.querySelector(fallbackSelector);
    return fallbackControl instanceof HTMLInputElement ||
      fallbackControl instanceof HTMLTextAreaElement ||
      fallbackControl instanceof HTMLSelectElement
      ? fallbackControl
      : null;
  };

  const syncAddressFieldLabels = form => {
    if (!(form instanceof HTMLFormElement)) return;

    form.querySelectorAll('[data-cad-address-field-block]').forEach(block => {
      if (!(block instanceof HTMLElement)) return;

      const fieldKey =
        normalizeText(block.dataset.cadAddressField).toLowerCase() ||
        getAddressFieldKey(block);
      if (!fieldKey) return;

      const baseLabelText = ADDRESS_FIELD_LABELS[fieldKey];
      if (!baseLabelText) return;

      const labelText = ADDRESS_REQUIRED_FIELD_KEYS.has(fieldKey)
        ? `${baseLabelText} *`
        : baseLabelText;

      const label = getAddressFieldLabelNode(block);
      if (!(label instanceof HTMLElement)) return;

      if (normalizeText(label.textContent) === labelText) return;
      label.textContent = labelText;
    });
  };

  const getAddressFieldErrorHost = (form, control) => {
    if (
      !(
        control instanceof HTMLInputElement ||
        control instanceof HTMLTextAreaElement ||
        control instanceof HTMLSelectElement
      )
    ) {
      return null;
    }

    const candidate =
      control.closest('[data-cad-address-field-block]') ||
      getAddressFieldBlock(form, control) ||
      control.closest('.cad-frame--field--container') ||
      control.parentElement;

    if (!(candidate instanceof HTMLElement)) return null;

    if (
      candidate instanceof HTMLInputElement ||
      candidate instanceof HTMLTextAreaElement ||
      candidate instanceof HTMLSelectElement
    ) {
      const parentHost =
        candidate.parentElement instanceof HTMLElement
          ? candidate.parentElement
          : null;
      if (!(parentHost instanceof HTMLElement)) return null;

      if (!parentHost.hasAttribute('data-cad-address-field-block')) {
        parentHost.dataset.cadAddressFieldBlock = '';
      }

      return parentHost;
    }

    if (!candidate.hasAttribute('data-cad-address-field-block')) {
      candidate.dataset.cadAddressFieldBlock = '';
    }

    return candidate;
  };

  const getAddressFieldInlineErrorNode = (
    form,
    control,
    createIfMissing = false
  ) => {
    const host = getAddressFieldErrorHost(form, control);
    if (!(host instanceof HTMLElement)) return null;

    let errorNode = host.querySelector('[data-cad-address-field-error]');

    if (!(errorNode instanceof HTMLElement) && createIfMissing) {
      errorNode = document.createElement('div');
      errorNode.className = 'error cad-address-field-error';
      errorNode.dataset.cadAddressFieldError = '';
      errorNode.setAttribute('role', 'alert');
      errorNode.setAttribute('aria-live', 'polite');
      host.append(errorNode);
    }

    return errorNode instanceof HTMLElement ? errorNode : null;
  };

  const clearAddressFieldInvalidState = (form, control) => {
    const host = getAddressFieldErrorHost(form, control);
    const errorNode = getAddressFieldInlineErrorNode(form, control, false);

    if (
      control instanceof HTMLInputElement ||
      control instanceof HTMLTextAreaElement ||
      control instanceof HTMLSelectElement
    ) {
      control.setCustomValidity('');
      control.removeAttribute('aria-invalid');
    }

    if (host instanceof HTMLElement) {
      host.classList.remove('cad-address-field-has-error');
    }

    if (errorNode instanceof HTMLElement) {
      errorNode.textContent = '';
    }
  };

  const setAddressFieldInvalidState = (form, control, message) => {
    const host = getAddressFieldErrorHost(form, control);
    const errorNode = getAddressFieldInlineErrorNode(form, control, true);
    const normalizedMessage = normalizeText(message) || 'Field is required.';

    if (
      control instanceof HTMLInputElement ||
      control instanceof HTMLTextAreaElement ||
      control instanceof HTMLSelectElement
    ) {
      control.setCustomValidity(normalizedMessage);
      control.setAttribute('aria-invalid', 'true');
    }

    if (host instanceof HTMLElement) {
      host.classList.add('cad-address-field-has-error');
    }

    if (errorNode instanceof HTMLElement) {
      errorNode.textContent = normalizedMessage;
    }
  };

  const ensureAddressFormNoValidate = form => {
    if (!(form instanceof HTMLFormElement)) return;

    if (!form.noValidate) {
      form.noValidate = true;
    }

    if (!form.hasAttribute('novalidate')) {
      form.setAttribute('novalidate', 'novalidate');
    }
  };

  const ensureAddressRequiredFieldValidation = form => {
    if (!(form instanceof HTMLFormElement)) return;

    ensureAddressFormNoValidate(form);

    ['address1', 'city'].forEach(fieldKey => {
      const control = getAddressFormFieldControl(form, fieldKey);
      if (
        !(
          control instanceof HTMLInputElement ||
          control instanceof HTMLTextAreaElement ||
          control instanceof HTMLSelectElement
        )
      ) {
        return;
      }

      if (control.required) {
        control.required = false;
      }

      if (control.hasAttribute('required')) {
        control.removeAttribute('required');
      }

      if (control.getAttribute('aria-required') !== 'true') {
        control.setAttribute('aria-required', 'true');
      }

      if (control.getAttribute('autocomplete') !== 'off') {
        control.setAttribute('autocomplete', 'off');
      }

      if (
        control instanceof HTMLInputElement ||
        control instanceof HTMLTextAreaElement
      ) {
        if (control.getAttribute('autocorrect') !== 'off') {
          control.setAttribute('autocorrect', 'off');
        }

        if (control.getAttribute('spellcheck') !== 'false') {
          control.setAttribute('spellcheck', 'false');
        }
      }

      if (control.__cadAddressRequiredBound === true) return;

      const clearInvalid = () => {
        if (normalizeText(control.value)) {
          clearAddressFieldInvalidState(form, control);
        }
      };

      control.addEventListener('input', clearInvalid);
      control.addEventListener('change', clearInvalid);
      control.__cadAddressRequiredBound = true;
      control.dataset.cadAddressRequiredBound = 'true';
    });
  };

  const validateAddressRequiredFields = form => {
    if (!(form instanceof HTMLFormElement)) return true;

    ensureAddressRequiredFieldValidation(form);

    let hasErrors = false;

    ['address1', 'city'].forEach(fieldKey => {
      const control = getAddressFormFieldControl(form, fieldKey);
      if (
        !(
          control instanceof HTMLInputElement ||
          control instanceof HTMLTextAreaElement ||
          control instanceof HTMLSelectElement
        )
      ) {
        return;
      }

      if (normalizeText(control.value)) {
        clearAddressFieldInvalidState(form, control);
        return;
      }

      hasErrors = true;
      setAddressFieldInvalidState(
        form,
        control,
        ADDRESS_REQUIRED_FIELD_MESSAGES[fieldKey] || 'Field is required.'
      );
    });

    return !hasErrors;
  };

  const getAddressFieldGroup = (form, block, fieldKey) => {
    if (!block || !fieldKey) return null;
    if (fieldKey !== 'country' && fieldKey !== 'province') return null;

    const group = block.closest('country-selector');

    return group && group.closest('form') === form ? group : null;
  };

  const getAddressProvincePair = scope => {
    if (!scope) return {};

    const form = scope.matches?.('form') ? scope : scope.closest?.('form');

    if (!form) return {};

    const countryControl =
      scope.querySelector?.('select[name="address[country]"]') ||
      form.querySelector('select[name="address[country]"]');

    if (!countryControl) {
      return { form };
    }

    let provinceControl =
      scope.querySelector?.('select[name="address[province]"]') || null;
    let provinceContainer = null;

    const countryIdMatch = countryControl.id?.match(/^AddressCountry_(.+)$/);

    if (!provinceControl && countryIdMatch) {
      provinceControl = form.querySelector(
        `#AddressProvince_${countryIdMatch[1]}`
      );
      provinceContainer = form.querySelector(
        `#AddressProvinceContainer_${countryIdMatch[1]}`
      );
    }

    if (!provinceControl) {
      provinceControl = form.querySelector('select[name="address[province]"]');
    }

    if (!provinceContainer && provinceControl?.id) {
      const provinceIdMatch = provinceControl.id.match(
        /^AddressProvince_(.+)$/
      );

      if (provinceIdMatch) {
        provinceContainer = form.querySelector(
          `#AddressProvinceContainer_${provinceIdMatch[1]}`
        );
      }
    }

    if (!provinceContainer && provinceControl) {
      provinceContainer =
        provinceControl.closest('[data-cad-address-field-block]') ||
        provinceControl.parentElement;
    }

    return {
      countryControl,
      form,
      provinceContainer,
      provinceControl
    };
  };

  const decodeHtmlEntities = value => {
    if (!value) return '';

    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  };

  const parseAddressProvinceOptions = rawProvinces => {
    const raw = `${rawProvinces ?? ''}`.trim();
    if (!raw) return [];

    const sources = [raw];
    const decodedRaw = decodeHtmlEntities(raw);

    if (decodedRaw && decodedRaw !== raw) {
      sources.push(decodedRaw);
    }

    for (const source of sources) {
      try {
        const parsed = JSON.parse(source);

        if (!Array.isArray(parsed)) continue;

        return parsed
          .filter(Array.isArray)
          .map(([value, label]) => [
            `${value ?? ''}`,
            `${label ?? value ?? ''}`
          ]);
      } catch (_error) {}
    }

    return [];
  };

  const resolveAddressProvinceFallbackValue = form => {
    if (!(form instanceof HTMLFormElement)) return '';

    const mirrorValue = normalizeText(
      form.querySelector(
        'input[type="hidden"][data-cad-address-province-mirror]'
      )?.value
    );
    if (mirrorValue) return mirrorValue;

    const hiddenProvinceValue = normalizeText(
      form.querySelector(
        'input[type="hidden"][name="address[province]"]:not([data-cad-address-province-mirror])'
      )?.value
    );
    if (hiddenProvinceValue) return hiddenProvinceValue;

    return normalizeText(
      form.querySelector('country-selector')?.getAttribute('province')
    );
  };

  const stripAddressProvinceField = form => {
    if (!(form instanceof HTMLFormElement)) return;

    const provinceControls = Array.from(
      form.querySelectorAll(
        'input[name="address[province]"], select[name="address[province]"], textarea[name="address[province]"], input[name*="[province]"], select[name*="[province]"], textarea[name*="[province]"]'
      )
    ).filter(control => control.closest('form') === form);

    const provinceNodes = new Set();

    provinceControls.forEach(control => {
      const block = getAddressFieldBlock(form, control);
      if (block instanceof HTMLElement) {
        provinceNodes.add(block);
        return;
      }

      if (control instanceof HTMLElement) {
        provinceNodes.add(control);
      }
    });

    form
      .querySelectorAll(
        '[data-cad-address-province-fallback], [data-cad-address-province-mirror], [data-cad-address-field="province"]'
      )
      .forEach(node => {
        if (node instanceof Element && node.closest('form') === form) {
          provinceNodes.add(node);
        }
      });

    provinceNodes.forEach(node => {
      if (node instanceof Element && node.closest('form') === form) {
        node.remove();
      }
    });

    form.querySelectorAll('country-selector').forEach(group => {
      if (!(group instanceof HTMLElement) || group.closest('form') !== form) {
        return;
      }

      if (
        group.querySelector(
          'input[name="address[province]"], select[name="address[province]"], textarea[name="address[province]"]'
        )
      ) {
        return;
      }

      group.removeAttribute('province');
    });
  };

  const ensureAddressProvinceFallbackControl = form => {
    stripAddressProvinceField(form);
  };

  const syncAddressProvinceOptions = scope => {
    if (!scope) return;

    const { form, countryControl, provinceControl, provinceContainer } =
      getAddressProvincePair(scope);

    if (!countryControl || !provinceControl) return;

    const previousProvinceValue = provinceControl.value;
    const previousProvinceOptionsCount = provinceControl.options.length;

    const currentCountry = normalizeText(
      scope.getAttribute?.('country') ||
        countryControl.dataset.default ||
        countryControl.getAttribute('data-default')
    );

    if (
      currentCountry &&
      countryControl.options.length > 0 &&
      !countryControl.value
    ) {
      const selectedIndex = Array.from(countryControl.options).findIndex(
        option => normalizeText(option.textContent) === currentCountry
      );

      if (selectedIndex >= 0) {
        countryControl.selectedIndex = selectedIndex;
      }
    }

    const selectedOption = countryControl.options[countryControl.selectedIndex];
    const provinces = parseAddressProvinceOptions(
      selectedOption?.getAttribute('data-provinces')
    );

    if (provinceContainer) {
      provinceContainer.hidden = provinces.length === 0;
      provinceContainer.style.display = provinces.length === 0 ? 'none' : '';
    }

    if (provinces.length === 0) {
      provinceControl.replaceChildren();
      provinceControl.disabled = true;
      if (previousProvinceValue || previousProvinceOptionsCount > 0) {
        provinceControl.dispatchEvent(new Event('input', { bubbles: true }));
        provinceControl.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (form instanceof HTMLFormElement) {
        syncAddressProvinceMirror(form);
      }
      return;
    }

    const selectedProvince =
      normalizeText(provinceControl.value) ||
      normalizeText(scope.getAttribute?.('province')) ||
      normalizeText(provinceControl.dataset.default) ||
      normalizeText(provinceControl.getAttribute('data-default')) ||
      normalizeText(provinceControl.selectedOptions?.[0]?.textContent);
    const hasSelectedProvince = selectedProvince.length > 0;
    let hasMatchedProvince = false;

    provinceControl.replaceChildren();
    provinceControl.disabled = false;

    provinces.forEach(([value, label], index) => {
      const isSelected =
        (hasSelectedProvince &&
          (normalizeText(value) === selectedProvince ||
            normalizeText(label) === selectedProvince)) ||
        (!hasSelectedProvince && index === 0);

      if (isSelected) {
        hasMatchedProvince = true;
      }

      provinceControl.options.add(
        new Option(label, value, isSelected, isSelected)
      );
    });

    if (hasSelectedProvince && !hasMatchedProvince) {
      provinceControl.options.add(
        new Option(selectedProvince, selectedProvince, true, true),
        0
      );
    }

    if (
      provinceControl.value !== previousProvinceValue ||
      provinceControl.options.length !== previousProvinceOptionsCount
    ) {
      provinceControl.dispatchEvent(new Event('input', { bubbles: true }));
      provinceControl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (form instanceof HTMLFormElement) {
      syncAddressProvinceMirror(form);
    }
  };

  const syncAddressProvinceMirror = form => {
    if (!(form instanceof HTMLFormElement)) return;

    const { provinceControl } = getAddressProvincePair(form);
    const existingMirror = form.querySelector(
      'input[type="hidden"][data-cad-address-province-mirror]'
    );
    const fallbackInput = form.querySelector(
      '[data-cad-address-province-fallback-input]'
    );

    if (!provinceControl && !(fallbackInput instanceof HTMLInputElement)) {
      existingMirror?.remove();
      return;
    }

    const mirror = existingMirror || document.createElement('input');

    if (!existingMirror) {
      mirror.type = 'hidden';
      mirror.dataset.cadAddressProvinceMirror = 'true';
      form.appendChild(mirror);
    }

    mirror.name =
      provinceControl?.getAttribute('name') ||
      fallbackInput?.getAttribute('name') ||
      'address[province]';

    if (provinceControl) {
      mirror.value =
        provinceControl.value ||
        provinceControl.selectedOptions?.[0]?.value ||
        provinceControl.selectedOptions?.[0]?.textContent ||
        '';

      mirror.disabled = !provinceControl.disabled;
      return;
    }

    mirror.value = fallbackInput.value || '';
    mirror.disabled = false;
  };

  const ensureAddressProvinceSelection = form => {
    if (!(form instanceof HTMLFormElement)) return;

    const { countryControl, provinceControl, provinceContainer } =
      getAddressProvincePair(form);

    if (!countryControl || !provinceControl) {
      syncAddressProvinceMirror(form);
      return;
    }

    syncAddressProvinceOptions(form);

    if (provinceControl.disabled) {
      syncAddressProvinceMirror(form);
      return;
    }

    if (provinceContainer instanceof HTMLElement) {
      const provinceStyle = window.getComputedStyle(provinceContainer);
      if (provinceContainer.hidden || provinceStyle.display === 'none') {
        syncAddressProvinceMirror(form);
        return;
      }
    }

    if (normalizeText(provinceControl.value)) {
      syncAddressProvinceMirror(form);
      return;
    }

    const fallbackOption = Array.from(provinceControl.options).find(option => {
      return (
        (normalizeText(option.value) || normalizeText(option.textContent))
          .length > 0
      );
    });

    if (!fallbackOption) {
      syncAddressProvinceMirror(form);
      return;
    }

    provinceControl.value = fallbackOption.value;
    fallbackOption.selected = true;
    provinceControl.dispatchEvent(new Event('input', { bubbles: true }));
    provinceControl.dispatchEvent(new Event('change', { bubbles: true }));
    syncAddressProvinceMirror(form);
  };

  const bindAddressCountryGroup = group => {
    if (!group) return;

    if (group.dataset.cadAddressCountryBound === 'true') {
      syncAddressProvinceOptions(group);
      return;
    }

    const { countryControl } = getAddressProvincePair(group);

    if (!countryControl) return;

    countryControl.addEventListener('change', () => {
      syncAddressProvinceOptions(group);
    });

    group.dataset.cadAddressCountryBound = 'true';
    syncAddressProvinceOptions(group);
  };

  const refreshAddressCountryGroups = form => {
    if (!form) return;

    const groups = Array.from(form.querySelectorAll('country-selector'));

    if (groups.length > 0) {
      groups.forEach(group => {
        bindAddressCountryGroup(group);
      });

      return;
    }

    bindAddressCountryGroup(form);
  };

  const getAddressActionText = control =>
    normalizeText(control?.textContent || control?.value).toLowerCase();

  const getNativeAddressSubmit = form =>
    form.querySelector('button[type="submit"], input[type="submit"]');

  const getNativeAddressCancel = form => {
    const candidates = Array.from(
      form.querySelectorAll(
        'button, a, [role="button"], input[type="button"], input[type="reset"]'
      )
    );

    return (
      candidates.find(candidate => {
        if (
          candidate.matches(
            '[data-cad-address-edit-back], [data-cad-address-edit-cancel], [data-cad-address-edit-save]'
          )
        ) {
          return false;
        }

        const actionText = getAddressActionText(candidate);

        return (
          actionText === 'cancel' ||
          actionText === 'back' ||
          actionText.includes('cancel') ||
          actionText.includes('back')
        );
      }) || null
    );
  };

  const ensureAddressSaveButtonStructure = button => {
    if (!(button instanceof HTMLElement)) return;

    if (button instanceof HTMLInputElement) {
      if (normalizeText(button.value).toLowerCase() !== 'save') {
        button.value = 'SAVE';
      }
      return;
    }

    let label = button.querySelector(
      '.submit-text, .cad-address-edit-save__label'
    );

    if (!(label instanceof HTMLElement)) {
      label = document.createElement('span');
      label.textContent = normalizeText(button.textContent) || 'SAVE';
      button.replaceChildren(label);
    }

    label.classList.add('cad-address-edit-save__label');
    if (normalizeText(label.textContent).toLowerCase() !== 'save') {
      label.textContent = 'SAVE';
    }

    if (!button.querySelector('.cad-address-edit-save__loader')) {
      const loader = document.createElement('span');
      loader.className = 'cad-address-edit-save__loader';
      loader.setAttribute('aria-hidden', 'true');
      button.appendChild(loader);
    }
  };

  const getAddressSaveButtons = frame => {
    if (!(frame instanceof Element)) return [];

    return Array.from(
      frame.querySelectorAll('[data-cad-address-edit-save]')
    ).filter(
      button =>
        button instanceof HTMLButtonElement ||
        button instanceof HTMLInputElement
    );
  };

  const clearCadAddressSaveLoading = frame => {
    if (!(frame instanceof HTMLElement)) return;

    if (frame.__cadAddressSavePendingTimer) {
      window.clearTimeout(frame.__cadAddressSavePendingTimer);
      frame.__cadAddressSavePendingTimer = 0;
    }

    getAddressSaveButtons(frame).forEach(button => {
      if (
        !(
          button instanceof HTMLButtonElement ||
          button instanceof HTMLInputElement
        )
      ) {
        return;
      }

      const wasDisabled = button.dataset.cadAddressWasDisabled === 'true';
      delete button.dataset.cadAddressWasDisabled;
      delete button.dataset.cadLoading;
      button.removeAttribute('aria-busy');
      button.disabled = wasDisabled;

      if (
        button instanceof HTMLInputElement &&
        normalizeText(button.value).toLowerCase() !== 'save'
      ) {
        button.value = 'SAVE';
      }

      const label = button.querySelector(
        '.submit-text, .cad-address-edit-save__label'
      );
      if (
        label instanceof HTMLElement &&
        normalizeText(label.textContent).toLowerCase() !== 'save'
      ) {
        label.textContent = 'SAVE';
      }
    });
  };

  const setCadAddressSaveLoading = (frame, activeButton) => {
    if (!(frame instanceof HTMLElement)) return;

    clearCadAddressSaveLoading(frame);

    const buttons = getAddressSaveButtons(frame);
    if (buttons.length === 0 && activeButton instanceof HTMLElement) {
      ensureAddressSaveButtonStructure(activeButton);
    }

    const loadingButtons = getAddressSaveButtons(frame);
    loadingButtons.forEach(button => {
      if (
        !(
          button instanceof HTMLButtonElement ||
          button instanceof HTMLInputElement
        )
      ) {
        return;
      }

      ensureAddressSaveButtonStructure(button);
      button.dataset.cadAddressWasDisabled = button.disabled ? 'true' : 'false';
      button.dataset.cadLoading = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      if (button instanceof HTMLInputElement) {
        button.value = 'SAVING...';
      }
    });

    frame.__cadAddressSavePendingTimer = window.setTimeout(() => {
      clearCadAddressSaveLoading(frame);
    }, CAD_ADDRESS_SAVE_PENDING_TIMEOUT_MS);
  };

  const hasAddressFormErrors = form => {
    if (!(form instanceof HTMLFormElement)) return false;

    return Array.from(
      form.querySelectorAll(
        '.error, [role="alert"], .errors, .form__message, .alert'
      )
    ).some(element => normalizeText(element.textContent).length > 0);
  };

  const bindAddressFormSubmitGuard = (frame, form) => {
    if (!(form instanceof HTMLFormElement) || !(frame instanceof HTMLElement)) {
      return;
    }

    if (form.__cadAddressFormSubmitBound === true) return;

    ensureAddressRequiredFieldValidation(form);
    ensureAddressFormNoValidate(form);

    form.addEventListener('submit', event => {
      stripAddressProvinceField(form);
      ensureAddressProvinceSelection(form);
      syncAddressProvinceMirror(form);
      syncAddressFieldLabels(form);
      bindCadAddressPhoneMask(form);

      if (!validateAddressRequiredFields(form)) {
        event.preventDefault();
        event.stopPropagation();
        clearCadAddressSaveLoading(frame);
        return;
      }

      setCadAddressSaveLoading(frame, getNativeAddressSubmit(form));

      window.setTimeout(() => {
        if (hasAddressFormErrors(form)) {
          clearCadAddressSaveLoading(frame);
        }
      }, 1400);
    });

    form.__cadAddressFormSubmitBound = true;
    form.dataset.cadAddressFormSubmitBound = 'true';
  };

  const hideNativeAddressAction = control => {
    if (!control) return;

    const container =
      control.closest(
        '.save-button--container, .button-group, .buttons, .actions, .cad-actions'
      ) || control;

    container.hidden = true;
    container.style.display = 'none';
  };

  const hideAddressEditorChrome = (activeItem, form, actions) => {
    if (!activeItem || !form) return;

    const formHost = form.parentElement || activeItem;

    Array.from(activeItem.children).forEach(child => {
      if (child === formHost) return;
      if (actions && (child === actions || child.contains(actions))) return;
      if (child.contains(form)) return;

      child.dataset.cadAddressEditorHidden = 'true';
    });

    if (formHost !== activeItem) {
      Array.from(formHost.children).forEach(child => {
        if (child === form) return;
        if (actions && child === actions) return;

        child.dataset.cadAddressEditorHidden = 'true';
      });
    }
  };

  const isAddressInteractiveTarget = target => {
    if (!(target instanceof Element)) return false;

    if (target.closest('[data-cad-address-active-item]')) {
      return !!target.closest(
        'input, select, textarea, button, a, label, option, [role="button"]'
      );
    }

    return !!target.closest(
      'cad-address, .default-address, [data-cad-address-add-card], .add-address, .cad--new-address, [data-cad-addresses-page], button, a, input, select, textarea, label, [role="button"]'
    );
  };

  const clickAddressControl = (frame, control, useSyntheticFlag = false) => {
    if (!control) return false;

    if (useSyntheticFlag && frame) {
      frame.__cadAddressesSyntheticEntryClick = true;
    }

    control.click();

    if (useSyntheticFlag && frame) {
      window.setTimeout(() => {
        delete frame.__cadAddressesSyntheticEntryClick;
      }, 0);
    }

    return true;
  };

  const getAddressEditToggle = target => {
    if (!(target instanceof Element)) return null;

    const toggle = target.closest(ADDRESS_EDIT_TOGGLE_SELECTOR);

    if (!(toggle instanceof HTMLElement)) return null;
    if (toggle.closest('form')) return null;

    return toggle;
  };

  const bindAddressesFrameInteractionShield = frame => {
    if (!frame || frame.dataset.cadAddressesInteractionShield === 'true') {
      return;
    }

    const handler = event => {
      if (frame.__cadAddressesSyntheticEntryClick === true) {
        return;
      }

      if (frame.dataset.cadAddressesState === 'edit') {
        return;
      }

      if (event.type === 'click') {
        const eventTarget =
          event.target instanceof Element ? event.target : null;
        const addCardTrigger = eventTarget?.closest(
          '[data-cad-address-add-card]'
        );

        if (addCardTrigger) {
          event.preventDefault();
          event.stopPropagation();
          requestAddressesEditorMode(frame, 'new');
          return;
        }

        const editEntryTrigger = getAddressEditToggle(eventTarget);

        if (
          editEntryTrigger &&
          editEntryTrigger.closest('cad-address, .default-address')
        ) {
          event.preventDefault();
          event.stopPropagation();
          frame.__cadAddressLastEditTrigger = editEntryTrigger;
          requestAddressesEditorMode(frame, 'edit');
          clickAddressControl(frame, editEntryTrigger, true);
          return;
        }
      }

      if (isAddressInteractiveTarget(event.target)) return;

      event.preventDefault();
      event.stopPropagation();
    };

    ['pointerdown', 'mousedown', 'click'].forEach(eventName => {
      frame.addEventListener(eventName, handler, true);
    });

    frame.dataset.cadAddressesInteractionShield = 'true';
  };

  const bindAddressesFrameFocusGuard = () => {};

  const bindAddressesEditorActionDelegation = frame => {
    if (!frame || frame.dataset.cadAddressesEditorActionsBound === 'true') {
      return;
    }

    frame.dataset.cadAddressesEditorActionsBound = 'true';
    frame.addEventListener('click', event => {
      if (frame.__cadAddressesSyntheticEntryClick === true) {
        return;
      }

      const target = event.target;
      if (!(target instanceof Element)) return;

      const backOrCancelTrigger = target.closest(
        '[data-cad-address-edit-back], [data-cad-address-edit-cancel]'
      );

      if (backOrCancelTrigger) {
        const backHandler = frame.__cadAddressBackHandler;
        if (typeof backHandler !== 'function') return;

        event.preventDefault();
        event.stopPropagation();
        backHandler(event);
        return;
      }

      const saveTrigger = target.closest('[data-cad-address-edit-save]');

      if (saveTrigger) {
        event.preventDefault();
        event.stopPropagation();

        const form =
          saveTrigger.closest('form') ||
          getAddressEditorForms(frame).find(isElementVisible) ||
          getAddressEditorForms(frame)[0];
        if (!(form instanceof HTMLFormElement)) return;

        const nativeSubmit = getNativeAddressSubmit(form);
        submitAddressEditorForm(frame, form, nativeSubmit, saveTrigger);
      }
    });
  };

  let addressesResyncRafId = 0;

  const scheduleAddressesResync = () => {
    if (addressesResyncRafId) return;

    addressesResyncRafId = window.requestAnimationFrame(() => {
      addressesResyncRafId = 0;
      syncAddressesFrame();
    });
  };

  const getFirstAddressEditToggle = frame => {
    if (!frame) return null;

    const cards = Array.from(
      frame.querySelectorAll(
        ':scope > .cad-frame--data > :is(cad-address, .default-address)'
      )
    );
    const targetCard = cards.find(isElementVisible) || cards[0];

    if (targetCard instanceof HTMLElement) {
      const toggle = targetCard.querySelector(ADDRESS_EDIT_TOGGLE_SELECTOR);
      if (toggle instanceof HTMLElement) return toggle;
    }

    const fallbackToggle = frame.querySelector(ADDRESS_EDIT_TOGGLE_SELECTOR);
    return fallbackToggle instanceof HTMLElement ? fallbackToggle : null;
  };

  let addressHashRouteRafId = 0;

  const scheduleAddressHashRoute = () => {
    if (addressHashRouteRafId) return;

    addressHashRouteRafId = window.requestAnimationFrame(() => {
      addressHashRouteRafId = 0;

      const mode = getAddressModeFromHash();
      const hasAddressesSectionHash = isAddressesSectionHash();
      const frame = document.querySelector(ADDRESSES_FRAME_SELECTOR);
      if (!(frame instanceof HTMLElement)) return;

      if (
        !frame.classList.contains('active') &&
        (mode || hasAddressesSectionHash)
      ) {
        const navItem = document.querySelector(
          '.cad-nav__menu-item[data-nav="addresses"]'
        );
        const navTarget =
          navItem?.querySelector('a, button, [role="button"]') || navItem;

        if (
          navTarget instanceof HTMLElement &&
          frame.dataset.cadAddressHashNavRequestedMode !== (mode || 'section')
        ) {
          frame.dataset.cadAddressHashNavRequestedMode = mode || 'section';
          navTarget.click();
        }
        return;
      }

      delete frame.dataset.cadAddressHashNavRequestedMode;

      if (!mode) {
        if (frame.dataset.cadAddressesState === 'edit') {
          const titleElement = frame.querySelector(
            ':scope > .cad-frame--title'
          );
          forceCloseAddressEditor(frame, titleElement);
        } else {
          unlockAddressScroll();
          clearNewAddressOpenRetry(frame);
          if (hasAddressesSectionHash) {
            scheduleAddressesResync();
          }
        }
        return;
      }

      if (
        hasVisibleAddressEditor(frame) &&
        frame.dataset.cadAddressesEditorMode === mode
      ) {
        return;
      }

      if (mode === 'edit') {
        const editToggle = getFirstAddressEditToggle(frame);
        if (editToggle) {
          frame.__cadAddressLastEditTrigger = editToggle;
          requestAddressesEditorMode(frame, 'edit', { syncHash: false });
          clickAddressControl(frame, editToggle, true);
          return;
        }
      }

      requestAddressesEditorMode(frame, mode, { syncHash: false });
    });
  };

  const queuePendingAddressEditorResync = frame => {
    if (!frame || frame.__cadAddressPendingResyncTimer) return;

    frame.__cadAddressPendingResyncTimer = window.setTimeout(() => {
      frame.__cadAddressPendingResyncTimer = 0;
      scheduleAddressesResync();
    }, 120);
  };

  const syncActiveAddressItemMarker = (frame, nextActiveItem) => {
    if (!frame) return;

    const currentActiveItem =
      frame.__cadAddressActiveItem instanceof Element &&
      frame.__cadAddressActiveItem.isConnected
        ? frame.__cadAddressActiveItem
        : null;

    if (currentActiveItem === nextActiveItem) return;

    if (currentActiveItem) {
      currentActiveItem.removeAttribute('data-cad-address-active-item');
    }

    frame.querySelectorAll('[data-cad-address-active-item]').forEach(item => {
      if (item !== nextActiveItem) {
        item.removeAttribute('data-cad-address-active-item');
      }
    });

    if (nextActiveItem instanceof HTMLElement) {
      nextActiveItem.dataset.cadAddressActiveItem = 'true';
      frame.__cadAddressActiveItem = nextActiveItem;
      return;
    }

    delete frame.__cadAddressActiveItem;
  };

  const resolveActiveAddressItemFromForm = (frame, form) => {
    if (!(frame instanceof Element) || !(form instanceof Element)) return null;

    const dataRoot = frame.querySelector(':scope > .cad-frame--data');
    if (!(dataRoot instanceof HTMLElement)) return null;

    const directCandidates = Array.from(
      dataRoot.querySelectorAll(
        ':scope > :is(cad-address, .default-address, .add-address, .cad--new-address, [data-cad-address-add-card])'
      )
    );
    const directMatch = directCandidates.find(item => item.contains(form));
    if (directMatch instanceof HTMLElement) return directMatch;

    const closestAddressNode = form.closest(
      'cad-address, .default-address, .add-address, .cad--new-address, [data-cad-address-add-card]'
    );

    if (closestAddressNode && dataRoot.contains(closestAddressNode)) {
      let node = closestAddressNode;
      while (node && node.parentElement !== dataRoot) {
        node = node.parentElement;
      }

      if (node instanceof HTMLElement && node.parentElement === dataRoot) {
        return node;
      }
    }

    let formBranch = form;
    while (formBranch && formBranch.parentElement !== dataRoot) {
      formBranch = formBranch.parentElement;
    }

    if (
      formBranch instanceof HTMLElement &&
      formBranch.parentElement === dataRoot
    ) {
      return formBranch;
    }

    return null;
  };

  const isAddressEditorForm = form => {
    if (!(form instanceof HTMLFormElement)) return false;

    if (form.querySelector('[name^="address["]')) return true;

    const formTypeField = form.querySelector('input[name="form_type"]');
    if (
      formTypeField &&
      normalizeText(formTypeField.value).toLowerCase() === 'customer_address'
    ) {
      return true;
    }

    return /^address_form_/i.test(form.id || '');
  };

  const getAddressEditorForms = frame => {
    if (!frame) return [];

    return Array.from(
      frame.querySelectorAll(':scope > .cad-frame--data form')
    ).filter(isAddressEditorForm);
  };

  const isNewAddressEditorForm = form => {
    if (!(form instanceof HTMLFormElement)) return false;

    if (
      form.closest(
        '.cad--new-address, [data-cad-address-new], [data-address-new], .add-address'
      )
    ) {
      return true;
    }

    const addressId = normalizeText(
      form.querySelector('input[name="address[addressId]"]')?.value
    );
    const methodValue = normalizeText(
      form.querySelector('input[name="_method"]')?.value
    ).toLowerCase();

    if (!addressId && methodValue !== 'put') {
      return true;
    }

    const action = normalizeText(
      form.getAttribute('action') || form.action
    ).toLowerCase();

    if (/\/account\/addresses\/?$/.test(action)) {
      return true;
    }

    return false;
  };

  const isAddressDeleteForm = form => {
    if (!(form instanceof HTMLFormElement)) return false;

    const methodValue = normalizeText(
      form.querySelector('input[name="_method"]')?.value
    ).toLowerCase();
    if (methodValue !== 'delete') return false;

    const action = normalizeText(
      form.getAttribute('action') || form.action
    ).toLowerCase();

    return /\/account\/addresses\//.test(action);
  };

  const resolveAddressEditorMode = (frame, form) => {
    if (isNewAddressEditorForm(form)) return 'new';

    const requestedMode = frame?.dataset?.cadAddressesEditorMode;
    if (requestedMode === 'new' || requestedMode === 'edit') {
      return requestedMode;
    }

    return 'edit';
  };

  const hasVisibleAddressEditor = frame =>
    getAddressEditorForms(frame).some(isElementVisible);

  const clearForcedAddressEditorForms = frame => {
    if (!frame) return;

    frame.querySelectorAll('[data-cad-address-force-hidden]').forEach(form => {
      if (!(form instanceof HTMLElement)) return;

      form.removeAttribute('data-cad-address-force-hidden');
      form.hidden = false;
      form.style.removeProperty('display');
    });
  };

  const forceCloseAddressEditor = (frame, titleElement) => {
    if (!frame) return;

    getAddressEditorForms(frame)
      .filter(isElementVisible)
      .forEach(form => {
        if (!(form instanceof HTMLElement)) return;

        form.dataset.cadAddressForceHidden = 'true';
        form.hidden = true;
        form.style.display = 'none';
      });

    clearAddressEditorUi(frame);

    const pagination = frame.querySelector('[data-cad-addresses-pagination]');
    if (pagination) pagination.hidden = false;

    const titleNode =
      titleElement || frame.querySelector(':scope > .cad-frame--title');
    if (titleNode) {
      setManagedAddressesTitle(frame, titleNode, ADDRESSES_TITLE);
      scrollToCadSectionTop(titleNode);
    }

    unlockAddressScroll();
    updateAddressLocationHash(null);
    scheduleAddressesResync();
  };

  const submitAddressEditorForm = (
    frame,
    form,
    nativeSubmit,
    triggerButton = null
  ) => {
    if (!form) return;

    if (frame instanceof HTMLElement) {
      clearCadAddressSaveLoading(frame);
    }

    stripAddressProvinceField(form);
    ensureAddressProvinceSelection(form);
    syncAddressProvinceMirror(form);
    syncAddressFieldLabels(form);
    bindCadAddressPhoneMask(form);
    ensureAddressRequiredFieldValidation(form);

    if (!validateAddressRequiredFields(form)) {
      if (frame instanceof HTMLElement) {
        clearCadAddressSaveLoading(frame);
      }
      return;
    }

    if (frame instanceof HTMLElement) {
      const saveButton =
        triggerButton instanceof HTMLElement
          ? triggerButton
          : nativeSubmit instanceof HTMLElement
            ? nativeSubmit
            : frame.querySelector('[data-cad-address-edit-save]');
      setCadAddressSaveLoading(frame, saveButton);
    }

    if (
      nativeSubmit instanceof HTMLButtonElement ||
      nativeSubmit instanceof HTMLInputElement
    ) {
      const wasDisabled = nativeSubmit.disabled;

      if (wasDisabled) {
        nativeSubmit.disabled = false;
      }

      if (frame instanceof HTMLElement && nativeSubmit instanceof HTMLElement) {
        clickAddressControl(frame, nativeSubmit, true);
      } else {
        nativeSubmit.click();
      }

      if (wasDisabled) {
        nativeSubmit.disabled = true;
      }
      return;
    }

    if (typeof form.requestSubmit === 'function') {
      try {
        form.requestSubmit();
        return;
      } catch (_error) {}
    }

    HTMLFormElement.prototype.submit.call(form);
  };

  const requestAddressesEditorMode = (
    frame,
    mode,
    { syncHash = true } = {}
  ) => {
    if (!frame) return;

    const lastRequestAt = frame.__cadAddressesEditorRequestedAt;
    const requestIsFresh =
      typeof lastRequestAt === 'number' && Date.now() - lastRequestAt < 500;
    if (frame.dataset.cadAddressesEditorMode === mode && requestIsFresh) {
      return;
    }

    if (syncHash) {
      updateAddressLocationHash(mode, { replace: true });
    }

    clearForcedAddressEditorForms(frame);
    frame.dataset.cadAddressesEditorMode = mode;
    const requestedAt = Date.now();
    const requestId = (frame.__cadAddressEditorScrollSeq || 0) + 1;
    frame.__cadAddressEditorScrollSeq = requestId;
    frame.__cadAddressesEditorRequestedAt = requestedAt;
    frame.__cadAddressEditorScrollRequestId = requestId;
    frame.__cadAddressEditorScrollPending = 'true';

    if (mode === 'new') {
      const newAddressForm = getNativeNewAddressForm(frame);
      if (newAddressForm) {
        revealNewAddressEditor(newAddressForm);
      }
      ensureNativeNewAddressEditorOpened(frame);
    } else {
      clearNewAddressOpenRetry(frame);
    }

    scheduleAddressesResync();
  };

  const clearAddressEditorUi = frame => {
    if (frame instanceof HTMLElement) {
      clearCadAddressSaveLoading(frame);
    }

    if (frame.__cadAddressPendingResyncTimer) {
      window.clearTimeout(frame.__cadAddressPendingResyncTimer);
      frame.__cadAddressPendingResyncTimer = 0;
    }
    clearNewAddressOpenRetry(frame);

    delete frame.dataset.cadAddressesState;
    delete frame.dataset.cadAddressesEditorMode;
    delete frame.__cadAddressLastEditTrigger;
    delete frame.__cadAddressBackHandler;
    delete frame.__cadAddressEditorScrollPending;
    delete frame.__cadAddressEditorScrollRequestId;
    delete frame.__cadAddressMissingFormSince;
    syncActiveAddressItemMarker(frame, null);
    frame
      .querySelectorAll('[data-cad-address-editor-hidden]')
      .forEach(item => item.removeAttribute('data-cad-address-editor-hidden'));
    frame.querySelector('[data-cad-address-edit-back]')?.remove();
    frame.querySelector('[data-cad-address-edit-actions]')?.remove();
    unlockAddressScroll();
  };

  const renderAddressCardLines = (content, lines) => {
    if (!(content instanceof HTMLElement)) return;
    if (!lines.length) {
      const currentHost = content.querySelector('[data-cad-address-lines]');
      if (currentHost) {
        currentHost.remove();
      }
      delete content.dataset.cadAddressLinesSignature;
      return;
    }

    const signature = lines.join('\n');
    if (content.dataset.cadAddressLinesSignature === signature) return;

    let host = content.querySelector('[data-cad-address-lines]');
    if (!(host instanceof HTMLElement)) {
      host = document.createElement('div');
      host.className = 'cad-address-card__lines';
      host.dataset.cadAddressLines = '';
      content.replaceChildren(host);
    } else {
      host.replaceChildren();
      if (
        content.childNodes.length !== 1 ||
        content.firstElementChild !== host
      ) {
        content.replaceChildren(host);
      }
    }

    const [primaryLine, ...secondaryLines] = lines;
    const strong = document.createElement('strong');
    strong.textContent = primaryLine;
    host.appendChild(strong);

    secondaryLines.forEach(line => {
      const span = document.createElement('span');
      span.textContent = line;
      host.appendChild(span);
    });

    content.dataset.cadAddressLinesSignature = signature;
  };

  const tryCloseAddressEditor = (
    frame,
    {
      editorMode,
      nativeAddToggle,
      nativeCancel,
      nativeEditToggle,
      preferToggle = false
    }
  ) => {
    const primaryCloseControl =
      editorMode === 'new' ? nativeAddToggle : nativeEditToggle;
    const secondaryCloseControl =
      editorMode === 'new' ? nativeEditToggle : null;
    const attempts = preferToggle
      ? [primaryCloseControl, nativeCancel, secondaryCloseControl]
      : [nativeCancel, primaryCloseControl, secondaryCloseControl];

    for (const control of attempts) {
      if (!control) continue;

      const isEditorToggle =
        control === nativeAddToggle || control === nativeEditToggle;

      if (clickAddressControl(frame, control, isEditorToggle)) {
        return true;
      }
    }

    return false;
  };

  const buildAddressFormLayout = form => {
    stripAddressProvinceField(form);
    const existingLayout = form.querySelector('[data-cad-address-form-layout]');
    if (form.dataset.cadAddressFormBound === 'true' && existingLayout) return;

    if (!existingLayout) {
      delete form.dataset.cadAddressFormBound;
      delete form.dataset.cadAddressForm;
    }

    const layout = document.createElement('div');
    layout.className = 'cad-address-form-layout';
    layout.dataset.cadAddressFormLayout = '';

    const collectedBlocks = new Map();
    const appendedBlocks = new Set();
    const appendedGroups = new Set();

    Array.from(form.querySelectorAll('input, select, textarea'))
      .filter(control => control.type !== 'hidden')
      .map(control => getAddressFieldBlock(form, control))
      .filter(Boolean)
      .filter((block, index, array) => array.indexOf(block) === index)
      .forEach(block => {
        const fieldKey = getAddressFieldKey(block);
        if (!fieldKey || collectedBlocks.has(fieldKey)) return;

        collectedBlocks.set(fieldKey, block);
        block.dataset.cadAddressFieldBlock = '';
        block.dataset.cadAddressField = fieldKey;
      });

    ADDRESS_EDITOR_ROWS.forEach(row => {
      const rowElement = document.createElement('div');
      rowElement.className = 'cad-address-form-row';
      rowElement.dataset.cadAddressFormRow = '';
      rowElement.dataset.columns = `${row.columns}`;

      row.fields.forEach(fieldName => {
        const block = collectedBlocks.get(fieldName);

        if (!block || appendedBlocks.has(block)) return;

        const groupedBlock = getAddressFieldGroup(form, block, fieldName);

        if (groupedBlock) {
          const groupedFields = Array.from(
            groupedBlock.querySelectorAll('[data-cad-address-field-block]')
          );

          groupedFields.forEach(groupField => appendedBlocks.add(groupField));

          if (!appendedGroups.has(groupedBlock)) {
            appendedGroups.add(groupedBlock);
            rowElement.appendChild(groupedBlock);
          }

          return;
        }

        appendedBlocks.add(block);
        rowElement.appendChild(block);
      });

      if (rowElement.childElementCount > 0) {
        layout.appendChild(rowElement);
      }
    });

    const remainingBlocks = Array.from(
      form.querySelectorAll('[name^="address["]')
    )
      .map(control => getAddressFieldBlock(form, control))
      .filter(Boolean)
      .filter((block, index, array) => array.indexOf(block) === index)
      .filter(block => !appendedBlocks.has(block))
      .filter(block => getAddressFieldKey(block) !== 'province');

    if (remainingBlocks.length > 0) {
      const extraRow = document.createElement('div');
      extraRow.className = 'cad-address-form-row';
      extraRow.dataset.cadAddressFormRow = '';
      extraRow.dataset.columns = '1';

      remainingBlocks.forEach(block => {
        block.dataset.cadAddressFieldBlock = '';
        extraRow.appendChild(block);
      });

      layout.appendChild(extraRow);
    }

    form.prepend(layout);
    ensureAddressProvinceFallbackControl(form);
    refreshAddressCountryGroups(form);
    syncAddressProvinceMirror(form);
    form.dataset.cadAddressForm = 'true';
    form.dataset.cadAddressFormBound = 'true';
  };

  const syncAddressEditor = (frame, titleElement) => {
    bindAddressesEditorActionDelegation(frame);

    const requestedAt = frame.__cadAddressesEditorRequestedAt;
    const isPendingNewEditorRequest =
      frame.dataset.cadAddressesEditorMode === 'new' &&
      !!requestedAt &&
      Date.now() - requestedAt < 1600;
    const hashMode = getAddressModeFromHash();

    // If the URL hash no longer points at a specific editor mode, but the
    // addresses section is active, always collapse any open editor and show
    // the list view again (e.g. after deletes or redirects back from edit).
    if (!hashMode && isAddressesSectionHash()) {
      if (
        frame.dataset.cadAddressesState === 'edit' ||
        hasVisibleAddressEditor(frame)
      ) {
        forceCloseAddressEditor(frame, titleElement);
      }

      return false;
    }

    const newAddressForm = getNativeNewAddressForm(frame);
    if (frame.dataset.cadAddressesEditorMode === 'new' && newAddressForm) {
      revealNewAddressEditor(newAddressForm);
    }
    const forms = getAddressEditorForms(frame);
    const form =
      forms.find(isElementVisible) ||
      (frame.dataset.cadAddressesEditorMode === 'new'
        ? newAddressForm
        : null) ||
      (isPendingNewEditorRequest ? newAddressForm : null);

    if (!form) {
      const hashMode = getAddressModeFromHash();
      const isPendingEditorRequest =
        !!requestedAt &&
        !!frame.dataset.cadAddressesEditorMode &&
        Date.now() - requestedAt < 1600 &&
        !!hashMode;

      if (isPendingEditorRequest) {
        const pendingMode =
          frame.dataset.cadAddressesEditorMode === 'new' ? 'new' : 'edit';

        if (titleElement) {
          setManagedAddressesTitle(
            frame,
            titleElement,
            getAddressEditorTitle(pendingMode)
          );
        }

        queuePendingAddressEditorResync(frame);
        return true;
      }

      if (!hashMode && frame.dataset.cadAddressesState === 'edit') {
        delete frame.__cadAddressesEditorRequestedAt;
        clearAddressEditorUi(frame);
        if (titleElement) {
          setManagedAddressesTitle(frame, titleElement, ADDRESSES_TITLE);
        }
        updateAddressLocationHash(null);
        return false;
      }

      if (frame.dataset.cadAddressesState === 'edit') {
        if (!frame.__cadAddressMissingFormSince) {
          frame.__cadAddressMissingFormSince = Date.now();
        }

        if (Date.now() - frame.__cadAddressMissingFormSince < 800) {
          queuePendingAddressEditorResync(frame);
          return true;
        }
      }

      delete frame.__cadAddressesEditorRequestedAt;
      clearAddressEditorUi(frame);

      if (titleElement) {
        setManagedAddressesTitle(frame, titleElement, ADDRESSES_TITLE);
      }

      updateAddressLocationHash(null);
      return false;
    }

    frame.dataset.cadAddressesState = 'edit';
    delete frame.__cadAddressMissingFormSince;
    if (frame.__cadAddressPendingResyncTimer) {
      window.clearTimeout(frame.__cadAddressPendingResyncTimer);
      frame.__cadAddressPendingResyncTimer = 0;
    }
    const editorMode = resolveAddressEditorMode(frame, form);
    frame.dataset.cadAddressesEditorMode = editorMode;
    delete frame.__cadAddressesEditorRequestedAt;
    if (titleElement) {
      setManagedAddressesTitle(
        frame,
        titleElement,
        getAddressEditorTitle(editorMode)
      );
    }

    const activeItemFromForm = resolveActiveAddressItemFromForm(frame, form);
    const previousActiveItem =
      frame.__cadAddressActiveItem instanceof Element &&
      frame.__cadAddressActiveItem.isConnected
        ? frame.__cadAddressActiveItem
        : null;
    const activeItem = activeItemFromForm || previousActiveItem || null;
    syncActiveAddressItemMarker(frame, activeItem);

    buildAddressFormLayout(form);
    ensureAddressProvinceFallbackControl(form);
    syncAddressProvinceMirror(form);
    syncAddressFieldLabels(form);
    bindCadAddressPhoneMask(form);
    ensureAddressRequiredFieldValidation(form);
    bindAddressFormSubmitGuard(frame, form);

    const pagination = frame.querySelector('[data-cad-addresses-pagination]');
    if (pagination) pagination.hidden = true;

    const nativeSubmit = getNativeAddressSubmit(form);
    const nativeCancel = getNativeAddressCancel(form);
    const nativeAddToggle = getNativeAddAddressButton(frame);
    const nativeEditToggle =
      (frame.__cadAddressLastEditTrigger?.isConnected &&
        frame.__cadAddressLastEditTrigger) ||
      activeItem?.querySelector(ADDRESS_EDIT_TOGGLE_SELECTOR) ||
      null;

    const nativeActions =
      nativeSubmit?.closest(
        '.actions, .save-button--container, .button-group, .buttons, .cad-actions'
      ) ||
      nativeCancel?.closest(
        '.actions, .save-button--container, .button-group, .buttons, .cad-actions'
      ) ||
      null;

    if (nativeActions instanceof HTMLElement) {
      nativeActions.dataset.cadAddressNativeActions = 'true';
      nativeActions.hidden = false;
      nativeActions.style.display = '';
    }

    const setAddressButtonLabel = (button, text) => {
      if (!(button instanceof HTMLElement)) return;

      if (button instanceof HTMLInputElement) {
        if (normalizeText(button.value) !== text.toLowerCase()) {
          button.value = text;
        }
        return;
      }

      const labelTarget =
        button.querySelector('.submit-text, .cad-address-edit-save__label') ||
        button;

      if (normalizeText(labelTarget.textContent) !== text.toLowerCase()) {
        labelTarget.textContent = text;
      }
    };

    if (nativeCancel) {
      nativeCancel.classList.add('cad-address-edit-cancel');
      nativeCancel.dataset.cadAddressEditCancel = '';
      setAddressButtonLabel(nativeCancel, 'CANCEL');
    }

    if (nativeSubmit) {
      nativeSubmit.classList.add('cad-address-edit-save');
      nativeSubmit.dataset.cadAddressEditSave = '';
      ensureAddressSaveButtonStructure(nativeSubmit);
      setAddressButtonLabel(nativeSubmit, 'SAVE');

      if (nativeSubmit.dataset.cadAddressSubmitGuardBound !== 'true') {
        nativeSubmit.addEventListener('click', () => {
          ensureAddressProvinceSelection(form);
        });
        nativeSubmit.dataset.cadAddressSubmitGuardBound = 'true';
      }
    }

    let backButton = frame.querySelector('[data-cad-address-edit-back]');

    if (!backButton) {
      backButton = document.createElement('button');
      backButton.type = 'button';
      backButton.className = 'cad-address-edit-back';
      backButton.dataset.cadAddressEditBack = '';
      backButton.textContent = 'Back';

      const titleNode = frame.querySelector(':scope > .cad-frame--title');
      if (titleNode) {
        frame.insertBefore(backButton, titleNode);
      } else {
        frame.prepend(backButton);
      }
    }

    const pendingScrollRequestId = frame.__cadAddressEditorScrollRequestId || 0;
    const shouldScrollToEditor =
      frame.__cadAddressEditorScrollPending === 'true' &&
      pendingScrollRequestId > 0 &&
      frame.__cadAddressEditorScrollHandledRequestId !== pendingScrollRequestId;

    if (shouldScrollToEditor) {
      frame.__cadAddressEditorScrollHandledRequestId = pendingScrollRequestId;
      delete frame.__cadAddressEditorScrollPending;
      window.requestAnimationFrame(() => {
        scrollToCadSectionTop(
          backButton || frame.querySelector(':scope > .cad-frame--title')
        );
      });
    }

    const goBack = event => {
      event.preventDefault();
      delete frame.__cadAddressesEditorRequestedAt;
      updateAddressLocationHash(null);
      unlockAddressScroll();

      const fallbackToAddressesList = () => {
        const navItem = document.querySelector(
          '.cad-nav__menu-item[data-nav="addresses"]'
        );
        const navTarget = navItem?.querySelector('a, button, [role="button"]');

        if (navTarget instanceof HTMLElement) {
          navTarget.click();
          return;
        }

        if (navItem instanceof HTMLElement) {
          navItem.click();
        }
      };

      const editorMode = frame.dataset.cadAddressesEditorMode;
      if (!hasVisibleAddressEditor(frame)) {
        clearAddressEditorUi(frame);
        if (titleElement) {
          setManagedAddressesTitle(frame, titleElement, ADDRESSES_TITLE);
        }
        fallbackToAddressesList();
        scheduleAddressesResync();
        return;
      }

      const runFallbackCloseFlow = () => {
        if (
          !tryCloseAddressEditor(frame, {
            editorMode,
            nativeAddToggle,
            nativeCancel,
            nativeEditToggle
          })
        ) {
          fallbackToAddressesList();
        }

        scheduleAddressesResync();

        window.setTimeout(() => {
          const stillEditing = hasVisibleAddressEditor(frame);

          if (stillEditing) {
            if (
              !tryCloseAddressEditor(frame, {
                editorMode,
                nativeAddToggle,
                nativeCancel,
                nativeEditToggle,
                preferToggle: true
              })
            ) {
              fallbackToAddressesList();
            }

            scheduleAddressesResync();

            window.setTimeout(() => {
              const stillEditingAfterFallback = hasVisibleAddressEditor(frame);

              if (stillEditingAfterFallback) {
                forceCloseAddressEditor(frame, titleElement);
                fallbackToAddressesList();
              }
            }, 250);
          }
        }, 250);
      };

      if (
        nativeCancel instanceof HTMLElement &&
        nativeCancel.isConnected &&
        nativeCancel !== backButton
      ) {
        clickAddressControl(frame, nativeCancel, true);
        scheduleAddressesResync();

        window.setTimeout(() => {
          if (hasVisibleAddressEditor(frame)) {
            runFallbackCloseFlow();
          }
        }, 220);
        return;
      }

      runFallbackCloseFlow();
    };

    backButton.onclick = goBack;
    frame.__cadAddressBackHandler = goBack;

    const existingCustomActions = frame.querySelector(
      '[data-cad-address-edit-actions]'
    );

    if (nativeActions && existingCustomActions) {
      existingCustomActions.remove();
    }

    let actions =
      nativeActions || frame.querySelector('[data-cad-address-edit-actions]');

    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'cad-address-edit-actions';
      actions.dataset.cadAddressEditActions = '';
      const cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'cad-address-edit-cancel';
      cancel.dataset.cadAddressEditCancel = '';
      cancel.textContent = 'CANCEL';

      const save = document.createElement('button');
      save.type = 'button';
      save.className = 'cad-address-edit-save';
      save.dataset.cadAddressEditSave = '';
      const saveLabel = document.createElement('span');
      saveLabel.className = 'cad-address-edit-save__label';
      saveLabel.textContent = 'SAVE';
      const saveLoader = document.createElement('span');
      saveLoader.className = 'cad-address-edit-save__loader';
      saveLoader.setAttribute('aria-hidden', 'true');
      save.append(saveLabel, saveLoader);

      actions.append(cancel, save);
      form.insertAdjacentElement('afterend', actions);
    }

    if (
      !nativeActions &&
      (actions.parentElement !== form.parentElement ||
        form.nextElementSibling !== actions)
    ) {
      form.insertAdjacentElement('afterend', actions);
    }

    hideAddressEditorChrome(activeItem, form, actions);

    const cancelButton = nativeActions
      ? nativeCancel
      : actions.querySelector('[data-cad-address-edit-cancel]');

    if (cancelButton && !nativeActions) {
      cancelButton.onclick = goBack;
    }

    const saveButton = nativeActions
      ? nativeSubmit
      : actions.querySelector('[data-cad-address-edit-save]');

    if (saveButton instanceof HTMLElement) {
      ensureAddressSaveButtonStructure(saveButton);
      setAddressButtonLabel(saveButton, 'SAVE');
    }

    if (saveButton && !nativeActions) {
      if (!form.id) {
        form.id = `cad-address-form-${Math.random().toString(36).slice(2, 10)}`;
      }

      saveButton.type = 'button';
      saveButton.removeAttribute('form');

      saveButton.onclick = () => {
        submitAddressEditorForm(frame, form, nativeSubmit, saveButton);
      };
    }

    return true;
  };

  const formatStatus = value => {
    const normalized = normalizeText(value).replace(/[_-]+/g, ' ');
    if (!normalized) return '-';

    return normalized.replace(/\b\w/g, character => character.toUpperCase());
  };

  const getAddressHtml = (scope, selector) => {
    const container = scope.querySelector(selector);
    if (!container) return '-';

    const lines = sanitizeAddressCardLines(extractAddressLines(container));
    if (!lines.length) return '-';

    return formatAddressHtml(lines);
  };

  const getDefaultAddressHtml = () => {
    const container = document.querySelector(
      '.cad-addresses.cad-frame-content[data-frame="addresses"] .default-address .formatted_address, .cad-addresses.cad-frame-content[data-frame="addresses"] .default-address .body'
    );

    if (!container) return '';

    const lines = sanitizeAddressCardLines(extractAddressLines(container));

    if (!lines.length) return '';

    return formatAddressHtml(lines);
  };

  const getOrderPlacedAt = order =>
    normalizeText(order.dataset.createdAt) || formatOrderDate(order);

  const getOrderTitle = order => {
    const orderNumber =
      normalizeText(order.dataset.orderName).replace(/^#/, '') ||
      normalizeText(order.dataset.orderNumber);

    return orderNumber ? `Order №${orderNumber}` : 'Order';
  };

  const parseOrderTimestamp = order => {
    const createdAtRaw = normalizeText(order.dataset.createdAtRaw);
    if (createdAtRaw) {
      const parsedRaw = new Date(createdAtRaw);
      if (!Number.isNaN(parsedRaw.getTime())) {
        return parsedRaw.getTime();
      }
    }

    const createdAt = normalizeText(order.dataset.createdAt);
    if (createdAt) {
      const parsedCreatedAt = new Date(createdAt);
      if (!Number.isNaN(parsedCreatedAt.getTime())) {
        return parsedCreatedAt.getTime();
      }

      const createdAtDatePart = normalizeText(createdAt.split(' at ')[0]);
      if (createdAtDatePart) {
        const parsedDatePart = new Date(createdAtDatePart);
        if (!Number.isNaN(parsedDatePart.getTime())) {
          return parsedDatePart.getTime();
        }
      }
    }

    return 0;
  };

  const buildOrderTriggerId = (order, index) => {
    const primaryId =
      normalizeText(order.dataset.orderId) ||
      normalizeText(order.dataset.orderName) ||
      normalizeText(order.dataset.orderNumber);
    const createdAtRaw = normalizeText(order.dataset.createdAtRaw);

    if (!primaryId) {
      return `cad-order-${index}`;
    }

    return createdAtRaw
      ? `${primaryId}::${createdAtRaw}`
      : `${primaryId}::${index}`;
  };

  const getSummaryValue = (scope, selector) =>
    normalizeText(scope.querySelector(selector)?.textContent) || '-';

  const readOrderItems = order => {
    return Array.from(order.querySelectorAll('.cad-frame--data__item')).map(
      item => ({
        imageAlt:
          normalizeText(
            item.querySelector('.cad-frame--data__item--title')?.textContent
          ) || 'Order item',
        imageSrc:
          item
            .querySelector('.cad-frame--data__item--image-container img')
            ?.getAttribute('src') || '',
        price:
          normalizeText(
            item.querySelector('.cad-frame--data__item--price')?.textContent
          ) || '-',
        quantity:
          normalizeText(item.dataset.quantity) ||
          normalizeText(
            item.querySelector('.cad-frame--data__item--eyelet')?.textContent
          ) ||
          '1',
        title:
          normalizeText(
            item.querySelector('.cad-frame--data__item--title')?.textContent
          ) || '-',
        variant:
          normalizeText(
            item.querySelector('.cad-frame--data__item--variant-title')
              ?.textContent
          ) || ''
      })
    );
  };

  const readOrders = frame => {
    return Array.from(frame.querySelectorAll('cad-order[data-order-name]'))
      .map((order, index) => ({
        _sourceIndex: index,
        _timestamp: parseOrderTimestamp(order),
        billingAddressHtml: getAddressHtml(
          order,
          '.cad-frame--data__addresses--billing .cad-frame--data__addresses--content'
        ),
        date: formatOrderDate(order),
        id: buildOrderTriggerId(order, index),
        items: readOrderItems(order),
        orderName: normalizeText(order.dataset.orderName) || '-',
        orderTitle: getOrderTitle(order),
        paymentStatus: formatStatus(order.dataset.financialStatus),
        placedAt: getOrderPlacedAt(order),
        shippingAddressHtml: getAddressHtml(
          order,
          '.cad-frame--data__addresses--shipping .cad-frame--data__addresses--content'
        ),
        shippingAmount: getSummaryValue(
          order,
          '.cad-frame--data__summary--shipping .cad-frame--data__summary--content'
        ),
        shippingLabel: normalizeText(order.dataset.shippingMethod)
          ? `Shipping (${normalizeText(order.dataset.shippingMethod)})`
          : 'Shipping',
        subtotal: getSummaryValue(
          order,
          '.cad-frame--data__summary--sub .cad-frame--data__summary--content'
        ),
        fulfillmentStatus: formatStatus(order.dataset.fulfillmentStatus),
        total: normalizeText(order.dataset.totalPrice) || '-'
      }))
      .sort((left, right) => {
        if (left._timestamp !== right._timestamp) {
          return right._timestamp - left._timestamp;
        }

        return left._sourceIndex - right._sourceIndex;
      })
      .map(({ _sourceIndex, _timestamp, ...order }) => order);
  };

  const getFieldContainer = (profile, key) =>
    profile.querySelector(`[data-customer-field="${key}"]`);

  const getFieldWrapper = container =>
    container?.querySelector('.cad-frame--data__account--field');

  const getFieldControl = container => {
    if (!container) return null;

    if (
      getAccountFieldSemanticKey(container.dataset.customerField) === 'phone'
    ) {
      return (
        container.querySelector('cad-field input[name="customer[phone]"]') ||
        container.querySelector('input[name="customer[phone]"]')
      );
    }

    return container.querySelector('select, input, textarea');
  };

  const ACCOUNT_FIELD_ALIASES = {
    birth: ['birth', 'birthdate', 'birth_date', 'date_of_birth', 'dob'],
    phone: ['phone', 'contact_number', 'contactnumber', 'contact'],
    skin_tone: ['skin_tone', 'skin_color', 'skin_colour']
  };

  const normalizeFieldKey = value =>
    normalizeText(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');

  const getAccountFieldSemanticKey = rawKey => {
    const normalizedKey = normalizeFieldKey(rawKey);
    if (!normalizedKey) return '';

    for (const [canonicalKey, aliases] of Object.entries(
      ACCOUNT_FIELD_ALIASES
    )) {
      const normalizedAliases = aliases.map(alias => normalizeFieldKey(alias));
      if (
        normalizedKey === canonicalKey ||
        normalizedAliases.includes(normalizedKey)
      ) {
        return canonicalKey;
      }
    }

    return normalizedKey;
  };

  const getAccountFieldHost = field => {
    if (!(field instanceof HTMLElement)) return null;

    const group = field.closest('[data-customer-fields-group]');
    if (!(group instanceof HTMLElement)) return field.parentElement;

    return group.querySelector(':scope > .cad-frame--data') || group;
  };

  const moveAccountFieldsToHostIfNeeded = (profile, host, fieldKeys) => {
    if (!(profile instanceof HTMLElement) || !(host instanceof HTMLElement)) {
      return;
    }

    const entries = fieldKeys
      .map(key => ({
        key,
        field: getAccountFieldByKey(profile, key)
      }))
      .filter(entry => entry.field instanceof HTMLElement);
    if (!entries.length) return;

    const expectedOrder = entries.map(entry => entry.key);
    const currentOrder = Array.from(
      host.querySelectorAll(':scope > [data-customer-field]')
    )
      .map(field => getAccountFieldSemanticKey(field.dataset.customerField))
      .filter(key => expectedOrder.includes(key));
    const isAlreadyInOrder =
      currentOrder.length === expectedOrder.length &&
      currentOrder.every((key, index) => key === expectedOrder[index]) &&
      entries.every(entry => entry.field.parentElement === host);
    if (isAlreadyInOrder) return;

    entries.forEach(entry => {
      host.appendChild(entry.field);
    });
  };

  const mergeAccountEditGridHosts = frame => {
    if (!(frame instanceof HTMLElement)) return;

    const form = frame.querySelector(
      `${CAD_ACCOUNT_SELECTOR} #editAccountForm`
    );
    if (!(form instanceof HTMLElement)) return;

    const infoGroup = form.querySelector('[data-customer-fields-group="info"]');
    const contactGroup = form.querySelector(
      '[data-customer-fields-group="contact_method"]'
    );
    if (
      !(infoGroup instanceof HTMLElement) ||
      !(contactGroup instanceof HTMLElement)
    ) {
      return;
    }

    const infoHost = infoGroup.querySelector(':scope > .cad-frame--data');
    const contactHost = contactGroup.querySelector(':scope > .cad-frame--data');
    if (
      !(infoHost instanceof HTMLElement) ||
      !(contactHost instanceof HTMLElement)
    ) {
      return;
    }

    if (infoHost === contactHost) return;

    const fieldsToMerge = Array.from(
      contactHost.querySelectorAll(':scope > [data-customer-field]')
    ).filter(field => field instanceof HTMLElement);
    if (!fieldsToMerge.length) return;

    fieldsToMerge.forEach(field => {
      infoHost.appendChild(field);
    });

    const hasRemainingFields = contactHost.querySelector(
      ':scope > [data-customer-field]'
    );
    if (!hasRemainingFields) {
      contactGroup.hidden = true;
      contactGroup.dataset.cadMergedIntoInfo = 'true';
    }
  };

  const getAccountFieldByKey = (profile, key) => {
    if (!profile) return null;

    const aliases = (ACCOUNT_FIELD_ALIASES[key] || [key]).map(alias =>
      normalizeFieldKey(alias)
    );
    const directMatch = getFieldContainer(profile, key);
    if (directMatch) return directMatch;

    for (const alias of aliases) {
      const field = getFieldContainer(profile, alias);
      if (field) return field;
    }

    const semanticMatch = Array.from(
      profile.querySelectorAll('[data-customer-field]')
    ).find(field => {
      if (!(field instanceof HTMLElement)) return false;
      return getAccountFieldSemanticKey(field.dataset.customerField) === key;
    });
    if (semanticMatch instanceof HTMLElement) return semanticMatch;

    return null;
  };

  const syncAccountEditFieldOrder = frame => {
    void frame;
  };

  const getRawValue = container => {
    const control = getFieldControl(container);

    if (!control) return '';

    return normalizeText(control.value);
  };

  const getDisplayValue = (container, rawValue) => {
    if (!container) return '-';

    const control = getFieldControl(container);

    if (
      getAccountFieldSemanticKey(container.dataset.customerField) === 'birth'
    ) {
      if (isBirthPlaceholderValue(rawValue, control)) {
        return '-';
      }

      return formatDate(rawValue);
    }

    if (control?.tagName === 'SELECT') {
      const selectedOption =
        Array.from(control.options).find(option => option.value === rawValue) ||
        control.options[control.selectedIndex];
      const optionText = normalizeText(selectedOption?.textContent);

      if (!optionText || /select a value/i.test(optionText)) {
        return '-';
      }

      return optionText;
    }

    return rawValue || '-';
  };

  const readSnapshot = profile => {
    return SNAPSHOT_FIELD_KEYS.reduce((snapshot, key) => {
      const container = getAccountFieldByKey(profile, key);
      const raw = getRawValue(container);

      snapshot[key] = {
        raw,
        text: getDisplayValue(container, raw)
      };

      return snapshot;
    }, {});
  };

  const isSameAccountSnapshot = (previousSnapshot, nextSnapshot) => {
    if (!previousSnapshot || !nextSnapshot) return false;

    return SNAPSHOT_FIELD_KEYS.every(key => {
      const previous = previousSnapshot[key] || {};
      const next = nextSnapshot[key] || {};

      return previous.raw === next.raw && previous.text === next.text;
    });
  };

  const getGreeting = snapshot => {
    const firstName = snapshot.first_name?.text;

    if (firstName && firstName !== '-') {
      return `Hello ${firstName}!`;
    }

    const navName = normalizeText(
      document.querySelector('.cad-nav__menu--title--name')?.textContent
    );

    if (navName) {
      return `Hello ${navName.split(' ')[0]}!`;
    }

    return 'Hello!';
  };

  const renderSummary = frame => {
    const snapshot = frame.__cadAccountSnapshot;

    if (!snapshot) return;

    const greeting = getGreeting(snapshot);
    const title = frame.querySelector('[data-cad-summary-title]');
    if (title && title.textContent !== greeting) title.textContent = greeting;

    const editTitle = frame.querySelector('[data-cad-edit-title]');
    if (editTitle && editTitle.textContent !== greeting) {
      editTitle.textContent = greeting;
    }

    SUMMARY_FIELDS.forEach(field => {
      const target = frame.querySelector(
        `[data-cad-summary-field="${field.key}"]`
      );
      const nextText = snapshot[field.key]?.text || '-';
      if (target && target.textContent !== nextText) {
        target.textContent = nextText;
      }
    });
  };

  const exitEditMode = frame => {
    clearCadAccountSavePending(frame);
    restoreSnapshot(frame);
    renderSummary(frame);
    setMode(frame, 'view');
  };

  const triggerAccountSave = frame => {
    if (!(frame instanceof HTMLElement)) return;
    if (frame.dataset.cadAccountSavePending === 'true') return;

    markCadAccountSavePending(frame);
    syncAccountPhoneValidation(frame);
    const isPhoneValid = normalizeAccountPhoneBeforeSubmit(frame);
    if (!isPhoneValid) {
      clearCadAccountSavePending(frame);
      syncEditActions(frame);
      return;
    }
    const isBirthValid = normalizeAccountBirthBeforeSubmit(frame);
    if (!isBirthValid) {
      clearCadAccountSavePending(frame);
      syncEditActions(frame);
      return;
    }
    syncEditActions(frame);

    const saveActionButton = frame.querySelector(
      '[data-cad-account-edit-save]'
    );
    if (saveActionButton instanceof HTMLButtonElement) {
      saveActionButton.dataset.cadLoading = 'true';
      saveActionButton.disabled = true;
      saveActionButton.setAttribute('aria-busy', 'true');
    }

    const saveButton = frame.querySelector(
      `${CAD_ACCOUNT_SELECTOR} #saveButtonDiv`
    );

    if (saveButton instanceof HTMLElement) {
      saveButton.click();
      return;
    }

    const form = frame.querySelector(
      `${CAD_ACCOUNT_SELECTOR} #editAccountForm, ${CAD_ACCOUNT_SELECTOR} form`
    );

    if (!(form instanceof HTMLFormElement)) {
      clearCadAccountSavePending(frame);
      return;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }

    form.submit();
  };

  const bindAccountActionDelegation = frame => {
    if (!frame || frame.dataset.cadAccountActionsBound === 'true') return;

    frame.dataset.cadAccountActionsBound = 'true';
    frame.addEventListener('click', event => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const backOrCancelTrigger = target.closest(
        '[data-cad-account-back], [data-cad-account-edit-cancel]'
      );

      if (backOrCancelTrigger) {
        event.preventDefault();
        event.stopPropagation();
        exitEditMode(frame);
        return;
      }

      const editTrigger = target.closest('[data-cad-account-edit]');

      if (editTrigger) {
        event.preventDefault();
        event.stopPropagation();
        setMode(frame, 'edit');
        return;
      }

      const saveTrigger = target.closest('[data-cad-account-edit-save]');

      if (saveTrigger) {
        event.preventDefault();
        event.stopPropagation();
        triggerAccountSave(frame);
      }
    });
  };

  const setMode = (frame, mode) => {
    frame.dataset.cadAccountState = mode;

    const backButton = frame.querySelector('[data-cad-account-back]');
    if (backButton) backButton.hidden = mode !== 'edit';

    const editHeader = frame.querySelector('[data-cad-account-edit-header]');
    if (editHeader) editHeader.hidden = mode !== 'edit';

    const editActions = frame.querySelector('[data-cad-account-edit-actions]');
    if (editActions) editActions.hidden = mode !== 'edit';

    if (mode !== 'edit') return;

    syncAccountEditFieldOrder(frame);

    const firstEditableField = frame.querySelector(
      `${CAD_ACCOUNT_SELECTOR} .cad-frame--data__account--field[data-field-editable="true"] :is(input:not([disabled]), select:not([disabled]), textarea:not([disabled]))`
    );

    window.requestAnimationFrame(() => {
      syncEditActions(frame);

      if (firstEditableField) firstEditableField.focus();
    });
  };

  const restoreSnapshot = frame => {
    const profile = frame.querySelector(CAD_ACCOUNT_SELECTOR);
    const snapshot = frame.__cadAccountSnapshot;

    if (!profile || !snapshot) return;

    SNAPSHOT_FIELD_KEYS.forEach(key => {
      const container = getAccountFieldByKey(profile, key);
      const control = getFieldControl(container);
      const wrapper = getFieldWrapper(container);
      const raw = snapshot[key]?.raw || '';

      if (!control) return;

      control.value = raw;

      if (wrapper?.hasAttribute('data-current-value')) {
        wrapper.setAttribute('data-current-value', raw);
      }

      const cadField = container?.querySelector('cad-field');
      if (cadField) cadField.setAttribute('data-field-value', raw);

      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const buildSummary = frame => {
    if (frame.querySelector('[data-cad-account-summary]')) return;

    const profile = frame.querySelector(CAD_ACCOUNT_SELECTOR);
    if (!profile) return;

    const backButton = document.createElement('button');
    backButton.type = 'button';
    backButton.hidden = true;
    backButton.dataset.cadAccountBack = '';
    backButton.textContent = 'Back';
    backButton.addEventListener('click', () => exitEditMode(frame));

    const editTitle = document.createElement('div');
    editTitle.className = 'cad-account-edit-header';
    editTitle.dataset.cadAccountEditHeader = '';
    editTitle.hidden = true;
    const editTitleHeading = document.createElement('h1');
    editTitleHeading.className = 'cad-account-edit-header__title';
    editTitleHeading.dataset.cadEditTitle = '';
    editTitle.append(editTitleHeading);

    const editActions = document.createElement('div');
    editActions.className = 'cad-account-edit-actions';
    editActions.dataset.cadAccountEditActions = '';
    editActions.hidden = true;
    const cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.className = 'cad-account-edit-cancel';
    cancelButton.dataset.cadAccountEditCancel = '';
    cancelButton.textContent = 'CANCEL';

    const saveButton = document.createElement('button');
    saveButton.type = 'button';
    saveButton.className = 'cad-account-edit-save';
    saveButton.dataset.cadAccountEditSave = '';
    const saveButtonLabel = document.createElement('span');
    saveButtonLabel.className = 'cad-account-edit-save__label';
    saveButtonLabel.textContent = 'SAVE';
    const saveButtonLoader = document.createElement('span');
    saveButtonLoader.className = 'cad-account-edit-save__loader';
    saveButtonLoader.setAttribute('aria-hidden', 'true');
    saveButton.append(saveButtonLabel, saveButtonLoader);
    editActions.append(cancelButton, saveButton);

    const summary = document.createElement('section');
    summary.className = 'cad-account-summary';
    summary.dataset.cadAccountSummary = '';

    const summaryHeader = document.createElement('div');
    summaryHeader.className = 'cad-account-summary__header';
    const summaryTitle = document.createElement('h1');
    summaryTitle.className = 'cad-account-summary__title';
    summaryTitle.dataset.cadSummaryTitle = '';
    summaryHeader.append(summaryTitle);

    const summaryList = document.createElement('dl');
    summaryList.className = 'cad-account-summary__list';
    SUMMARY_FIELDS.forEach(field => {
      const row = document.createElement('div');
      row.className = 'cad-account-summary__row';

      const dt = document.createElement('dt');
      dt.textContent = `${field.label}:`;

      const dd = document.createElement('dd');
      dd.dataset.cadSummaryField = field.key;

      row.append(dt, dd);
      summaryList.append(row);
    });

    const summaryActions = document.createElement('div');
    summaryActions.className = 'cad-account-summary__actions';
    const summaryEditButton = document.createElement('button');
    summaryEditButton.type = 'button';
    summaryEditButton.className = 'cad-account-summary__edit';
    summaryEditButton.dataset.cadAccountEdit = '';
    summaryEditButton.textContent = 'Edit';
    summaryActions.append(summaryEditButton);

    summary.append(summaryHeader, summaryList, summaryActions);

    summary
      .querySelector('[data-cad-account-edit]')
      ?.addEventListener('click', () => {
        setMode(frame, 'edit');
      });

    editActions
      .querySelector('[data-cad-account-edit-cancel]')
      ?.addEventListener('click', () => exitEditMode(frame));

    editActions
      .querySelector('[data-cad-account-edit-save]')
      ?.addEventListener('click', () => {
        triggerAccountSave(frame);
      });

    frame.insertBefore(backButton, profile);
    frame.insertBefore(editTitle, profile);
    frame.insertBefore(summary, profile);
    frame.insertBefore(editActions, profile.nextSibling);
  };

  const syncEditActions = frame => {
    const saveButton = frame.querySelector(
      `${CAD_ACCOUNT_SELECTOR} #saveButtonDiv`
    );
    if (!saveButton) return;

    const saveContainer = saveButton.closest('.save-button--container');
    const submitText = saveButton.querySelector('.submit-text');
    if (submitText && normalizeText(submitText.textContent) !== 'save') {
      submitText.textContent = 'SAVE';
    }

    if (saveContainer) {
      saveContainer.hidden = true;
      saveContainer.style.display = 'none';
    }

    if (saveButton.dataset.cadAccountSaveBound === 'true') return;

    saveButton.dataset.cadAccountSaveBound = 'true';
    saveButton.addEventListener('click', () => {
      markCadAccountSavePending(frame);
      window.clearTimeout(frame.__cadAccountSaveTimer);

      frame.__cadAccountSaveTimer = window.setTimeout(() => {
        const profile = frame.querySelector(CAD_ACCOUNT_SELECTOR);
        if (!profile) {
          clearCadAccountSavePending(frame);
          return;
        }

        const hasError = Array.from(profile.querySelectorAll('.error')).some(
          element => {
            return normalizeText(element.textContent).length > 0;
          }
        );

        if (hasError) {
          clearCadAccountSavePending(frame);
          return;
        }

        clearCadAccountSavePending(frame);
      }, 1800);
    });
  };

  const observeProfile = frame => {
    if (frame.__cadAccountObserver) return;

    const profile = frame.querySelector(CAD_ACCOUNT_SELECTOR);
    if (!profile) return;

    const observer = new MutationObserver(mutations => {
      const shouldRefresh = mutations.some(mutation => {
        return (
          mutation.type === 'childList' ||
          (mutation.type === 'attributes' &&
            [
              'value',
              'selected',
              'data-current-value',
              'data-init-value'
            ].includes(mutation.attributeName))
        );
      });

      if (!shouldRefresh || frame.dataset.cadAccountState === 'edit') return;

      const nextSnapshot = readSnapshot(profile);
      if (isSameAccountSnapshot(frame.__cadAccountSnapshot, nextSnapshot)) {
        return;
      }

      frame.__cadAccountSnapshot = nextSnapshot;
      renderSummary(frame);
    });

    observer.observe(profile, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'value',
        'selected',
        'data-current-value',
        'data-init-value'
      ]
    });

    frame.__cadAccountObserver = observer;
  };

  const patchCadEndpointFetch = () => {
    if (window.__cadEndpointFetchPatched === 'true') return;
    if (typeof window.fetch !== 'function') return;
    window.__cadEndpointFetchPatched = 'true';

    const nativeFetch = window.fetch;
    window.fetch = function (...args) {
      let requestUrl = '';
      let requestMethod = 'GET';

      if (args[0] instanceof Request) {
        requestUrl = args[0].url;
        requestMethod =
          normalizeText(args[1]?.method || args[0].method).toUpperCase() ||
          'GET';
      } else {
        requestUrl = `${args[0] ?? ''}`;
        requestMethod = normalizeText(args[1]?.method).toUpperCase() || 'GET';
      }

      const blockUntil = Number.parseInt(
        `${window.__cadAccountNavBlockUntil ?? ''}`,
        10
      );
      const hasPendingSave =
        cadAccountSavePending ||
        (Number.isFinite(blockUntil) && Date.now() <= blockUntil);

      if (
        !hasPendingSave ||
        requestMethod !== 'POST' ||
        !isCadEndpointPath(requestUrl)
      ) {
        return nativeFetch.apply(this, args);
      }

      const requestKey = `${requestMethod}:${getCadPathname(requestUrl)}`;
      const now = Date.now();
      const hasFreshInFlight =
        requestKey === cadEndpointFetchInFlightKey &&
        cadEndpointFetchInFlight &&
        now - cadEndpointFetchInFlightAt <= CAD_ENDPOINT_DEDUP_WINDOW_MS;

      if (hasFreshInFlight) {
        return cadEndpointFetchInFlight.then(response => response.clone());
      }

      cadEndpointFetchInFlightKey = requestKey;
      cadEndpointFetchInFlightAt = now;
      cadEndpointFetchInFlight = Promise.resolve(
        nativeFetch.apply(this, args)
      ).finally(() => {
        window.setTimeout(() => {
          if (cadEndpointFetchInFlightKey !== requestKey) return;
          cadEndpointFetchInFlight = null;
          cadEndpointFetchInFlightKey = '';
          cadEndpointFetchInFlightAt = 0;
        }, CAD_ENDPOINT_DEDUP_WINDOW_MS);
      });

      return cadEndpointFetchInFlight.then(response => response.clone());
    };
  };

  const patchCadNavigationGuards = () => {
    if (window.__cadEndpointNavigationGuardPatched === 'true') return;
    window.__cadEndpointNavigationGuardPatched = 'true';

    const locationProto = window.Location?.prototype;

    if (locationProto) {
      try {
        const nativeAssign = locationProto.assign;
        if (typeof nativeAssign === 'function') {
          locationProto.assign = function (...args) {
            if (shouldBlockCadAccountNavigation(args[0])) return;
            return nativeAssign.apply(this, args);
          };
        }
      } catch (_error) {}

      try {
        const nativeReplace = locationProto.replace;
        if (typeof nativeReplace === 'function') {
          locationProto.replace = function (...args) {
            if (shouldBlockCadAccountNavigation(args[0])) return;
            return nativeReplace.apply(this, args);
          };
        }
      } catch (_error) {}

      try {
        const hrefDescriptor = Object.getOwnPropertyDescriptor(
          locationProto,
          'href'
        );
        if (
          hrefDescriptor?.configurable &&
          typeof hrefDescriptor.set === 'function'
        ) {
          Object.defineProperty(locationProto, 'href', {
            configurable: true,
            enumerable: hrefDescriptor.enumerable,
            get: hrefDescriptor.get,
            set(value) {
              if (shouldBlockCadAccountNavigation(value)) return;
              return hrefDescriptor.set.call(this, value);
            }
          });
        }
      } catch (_error) {}

      try {
        const nativeReload = locationProto.reload;
        if (typeof nativeReload === 'function') {
          locationProto.reload = function (...args) {
            if (shouldBlockCadAccountNavigation(window.location.href)) return;
            return nativeReload.apply(this, args);
          };
        }
      } catch (_error) {}
    }

    try {
      const historyProto = window.History?.prototype;
      if (historyProto) {
        const nativePushState = historyProto.pushState;
        if (typeof nativePushState === 'function') {
          historyProto.pushState = function (...args) {
            if (shouldBlockCadAccountNavigation(args[2])) return;
            return nativePushState.apply(this, args);
          };
        }

        const nativeReplaceState = historyProto.replaceState;
        if (typeof nativeReplaceState === 'function') {
          historyProto.replaceState = function (...args) {
            if (shouldBlockCadAccountNavigation(args[2])) return;
            return nativeReplaceState.apply(this, args);
          };
        }
      }
    } catch (_error) {}

    const patchLocationSetter = (owner, property) => {
      if (!owner) return;

      const ownerProto = Object.getPrototypeOf(owner);
      const ownDescriptor = Object.getOwnPropertyDescriptor(owner, property);
      const protoDescriptor = ownerProto
        ? Object.getOwnPropertyDescriptor(ownerProto, property)
        : null;
      const descriptor = ownDescriptor || protoDescriptor;
      const target = ownDescriptor ? owner : ownerProto;

      if (
        !descriptor ||
        !target ||
        !descriptor.configurable ||
        typeof descriptor.set !== 'function'
      ) {
        return;
      }

      Object.defineProperty(target, property, {
        configurable: true,
        enumerable: descriptor.enumerable,
        get: descriptor.get,
        set(value) {
          if (shouldBlockCadAccountNavigation(value)) return;
          return descriptor.set.call(this, value);
        }
      });
    };

    try {
      patchLocationSetter(window, 'location');
      patchLocationSetter(document, 'location');
    } catch (_error) {}

    try {
      const nativeOpen = window.open;
      if (typeof nativeOpen === 'function') {
        window.open = function (...args) {
          const targetName = normalizeText(args[1]).toLowerCase();
          const isSameContext = !targetName || targetName === '_self';
          if (isSameContext && shouldBlockCadAccountNavigation(args[0])) {
            return null;
          }

          return nativeOpen.apply(this, args);
        };
      }
    } catch (_error) {}
  };

  const syncNavigationMenu = () => {
    document.querySelectorAll(NAV_MENU_ITEM_SELECTOR).forEach(item => {
      const navKey = item.dataset.nav;
      const label = NAV_LABELS[navKey];

      if (label) {
        const target = item.querySelector(
          '.left > span, a > .left > span, a > span'
        );

        if (target && normalizeText(target.textContent) !== label) {
          target.textContent = label;
        }
      }

      const iconMarkup = NAV_ICONS[navKey];
      const iconContainer = item.querySelector('.cad-nav__menu-item--svg');

      if (!iconMarkup || !iconContainer) return;
      if (iconContainer.dataset.themeIcon === navKey) return;

      iconContainer.innerHTML = iconMarkup;
      iconContainer.dataset.themeIcon = navKey;
    });
  };

  const setLoyaltyLeafText = (root, sourceText, nextText) => {
    if (!root) return;

    const source = normalizeText(sourceText).toLowerCase();
    if (!source) return;

    root.querySelectorAll('*').forEach(element => {
      if (!(element instanceof HTMLElement)) return;
      if (element.children.length > 0) return;

      if (normalizeText(element.textContent).toLowerCase() !== source) return;
      element.textContent = nextText;
    });
  };

  const findLoyaltyWorkSection = frame => {
    if (!frame) return null;

    const sections = Array.from(
      frame.querySelectorAll('.cad-switcher-section')
    ).filter(section => section instanceof HTMLElement);

    return (
      sections.find(section => {
        const dataTitle = normalizeText(section.dataset.title).toLowerCase();
        const heading = normalizeText(
          section.querySelector('.cad-loyalty__section--title, h1, h2, h3')
            ?.textContent
        ).toLowerCase();

        return (
          dataTitle.includes('ways to earn points') ||
          heading.includes('ways to earn points') ||
          heading.includes('how does it work')
        );
      }) || null
    );
  };

  const findLoyaltyRewardsSection = frame => {
    if (!frame) return null;

    const sections = Array.from(
      frame.querySelectorAll('.cad-switcher-section')
    ).filter(section => section instanceof HTMLElement);

    return (
      sections.find(section => {
        const dataTitle = normalizeText(section.dataset.title).toLowerCase();
        const heading = normalizeText(
          section.querySelector('.cad-loyalty__section--title, h1, h2, h3')
            ?.textContent
        ).toLowerCase();
        const hasVoucherContent = Boolean(
          section.querySelector('.voucher-list, .voucher')
        );

        return (
          hasVoucherContent ||
          dataTitle.includes('rewards') ||
          dataTitle.includes('coupon') ||
          heading.includes('available discounts') ||
          heading.includes('available rewards')
        );
      }) || null
    );
  };

  const hideLoyaltyBalanceBlock = frame => {
    if (!frame) return;

    const balanceLabel = Array.from(frame.querySelectorAll('*')).find(
      element => {
        if (!(element instanceof HTMLElement)) return false;
        if (element.children.length > 0) return false;

        const text = normalizeText(element.textContent).toLowerCase();
        return text === 'your balance' || text === 'your balance:';
      }
    );

    if (!(balanceLabel instanceof HTMLElement)) return;

    let balanceContainer =
      balanceLabel.closest('[class*="balance"]') || balanceLabel.parentElement;

    while (balanceContainer && balanceContainer !== frame) {
      const text = normalizeText(balanceContainer.textContent).toLowerCase();
      const isBalanceBlock =
        text.includes('your balance') &&
        (text.includes('points') || /\d/.test(text));

      if (isBalanceBlock) {
        break;
      }

      balanceContainer = balanceContainer.parentElement;
    }

    if (
      !(balanceContainer instanceof HTMLElement) ||
      balanceContainer === frame
    ) {
      return;
    }

    balanceContainer.dataset.cadLoyaltyBalance = 'true';
    balanceContainer.hidden = true;
    balanceContainer.style.display = 'none';

    const divider = balanceContainer.nextElementSibling;
    if (divider instanceof HTMLElement && divider.tagName === 'HR') {
      divider.dataset.cadLoyaltyBalanceDivider = 'true';
      divider.hidden = true;
      divider.style.display = 'none';
    }
  };

  const extractCurrencyValues = text => {
    const matches =
      normalizeText(text).match(/(?:£|\$|€)\s?\d+(?:[.,]\d{2})?/g) || [];

    return matches
      .map(raw => ({
        raw: raw.replace(/\s+/g, ''),
        numeric: Number.parseFloat(
          raw.replace(/[^\d.,]/g, '').replace(',', '.')
        )
      }))
      .filter(item => Number.isFinite(item.numeric));
  };

  const findReferralPopupContent = () => {
    const candidates = Array.from(
      document.querySelectorAll(
        'body [role="dialog"], body [class*="modal"], body [class*="popup"], body .cad-popup, body .cad-modal'
      )
    ).filter(element => element instanceof HTMLElement);

    const popup = candidates.find(element => {
      const text = normalizeText(element.textContent).toLowerCase();
      return (
        text.includes('copy your referral link') &&
        text.includes('what you get') &&
        text.includes('friend gets')
      );
    });

    if (!(popup instanceof HTMLElement)) return null;

    const lines = normalizeText(popup.innerText)
      .split(/\n+/)
      .map(normalizeText)
      .filter(Boolean);

    const getLine = pattern =>
      lines.find(line => pattern.test(line.toLowerCase())) || '';
    const getNextLine = pattern => {
      const index = lines.findIndex(line => pattern.test(line.toLowerCase()));
      return index >= 0 ? normalizeText(lines[index + 1]) : '';
    };

    const allText = lines.join(' ');
    const amounts = extractCurrencyValues(allText);
    const sortedAmounts = [...amounts].sort((a, b) => a.numeric - b.numeric);
    const rewardAmount = sortedAmounts[0]?.raw || '£10';
    const thresholdAmount =
      sortedAmounts[sortedAmounts.length - 1]?.raw || '£50';
    const urlMatches = allText.match(/https?:\/\/[^\s"'<>]+/gi) || [];
    const referralLink = urlMatches.find(link =>
      /(refer|referral|invite|friend)/i.test(link)
    );

    return {
      title:
        getLine(/invite friends|earn rewards/) ||
        'Invite friends, earn rewards',
      intro:
        getLine(/first paid order|at least/) ||
        `After your friend’s first paid order of at least ${thresholdAmount}`,
      whatYouGet: getNextLine(/what you get/) || `${rewardAmount} voucher`,
      friendGets:
        getNextLine(/what your friend gets|friend gets/) ||
        `${rewardAmount} voucher`,
      rewardAmount,
      thresholdAmount,
      referralLink: normalizeText(referralLink)
    };
  };

  const getLoyaltyInlineContent = frame => {
    if (!frame) return null;

    const popupInfo = findReferralPopupContent();
    if (popupInfo) {
      frame.__cadLoyaltyInlineInfo = popupInfo;
      return popupInfo;
    }

    if (frame.__cadLoyaltyInlineInfo) return frame.__cadLoyaltyInlineInfo;

    return {
      title: 'Invite friends, earn rewards',
      intro: 'After your friend’s first paid order of at least £50.00',
      whatYouGet: '£10.00 voucher',
      friendGets: '£10.00 voucher',
      rewardAmount: '£10',
      thresholdAmount: '£50'
    };
  };

  const resolveLoyaltyHowIconSources = () => {
    const knownIconNames = LOYALTY_HOW_ICON_FILES.map(
      file => file.split('?')[0]
    );
    const iconSourcesByName = new Map();

    document
      .querySelectorAll('.text-with-icons__icon, img[src*="/cdn/shop/files/"]')
      .forEach(node => {
        if (!(node instanceof HTMLImageElement)) return;

        const source = node.currentSrc || node.src || '';
        if (!source) return;

        knownIconNames.forEach(name => {
          if (!iconSourcesByName.has(name) && source.includes(name)) {
            iconSourcesByName.set(name, source);
          }
        });
      });

    return LOYALTY_HOW_ICON_FILES.map(file => {
      const name = file.split('?')[0];
      return (
        iconSourcesByName.get(name) ||
        `${window.location.origin}/cdn/shop/files/${file}`
      );
    });
  };

  const buildLoyaltyInlineMarkup = info => {
    return `
      <section class="cad-loyalty-inline" data-cad-loyalty-inline>
        <div class="cad-loyalty-inline__details" data-cad-loyalty-details>
          <h3 class="cad-loyalty-inline__details-title">${escapeHtml(info.title || 'Invite friends, earn rewards')}</h3>
          <div class="cad-loyalty-inline__details-card">
            <p class="cad-loyalty-inline__details-intro">${escapeHtml(info.intro || '')}</p>
            <div class="cad-loyalty-inline__details-groups">
              <div class="cad-loyalty-inline__details-group">
                <h4>What you get</h4>
                <p>${escapeHtml(info.whatYouGet || '')}</p>
              </div>
              <div class="cad-loyalty-inline__details-group">
                <h4>What your friend gets</h4>
                <p>${escapeHtml(info.friendGets || '')}</p>
              </div>
            </div>
            <button type="button" class="cad-cta cad-loyalty-inline__copy" data-cad-loyalty-copy-link>
              <span>Copy your referral link</span>
            </button>
          </div>
        </div>
      </section>
    `;
  };

  const buildLoyaltyHowMarkup = (info = {}) => {
    const rewardAmount = info.rewardAmount || '£10';
    const thresholdAmount = info.thresholdAmount || '£50';
    const [shareIcon, friendIcon, earnIcon] = resolveLoyaltyHowIconSources();

    return `
      <section class="cad-loyalty-how-banner" data-cad-loyalty-how-banner>
        <div class="cad-loyalty-inline__how" data-cad-loyalty-how>
          <h3 class="cad-loyalty-inline__how-title">${escapeHtml(LOYALTY_WORKS_TITLE)}</h3>
          <div class="cad-loyalty-inline__how-steps">
            <article class="cad-loyalty-inline__how-step">
              <div class="cad-loyalty-inline__how-icon" aria-hidden="true">
                <img src="${escapeHtml(shareIcon)}" alt="" loading="lazy" decoding="async">
              </div>
              <h4>Share your code</h4>
              <p>Share your unique referral code or link with your friends to earn credit.</p>
            </article>
            <article class="cad-loyalty-inline__how-step">
              <div class="cad-loyalty-inline__how-icon" aria-hidden="true">
                <img src="${escapeHtml(friendIcon)}" alt="" loading="lazy" decoding="async">
              </div>
              <h4>Your friend saves</h4>
              <p>Your friend will get ${escapeHtml(rewardAmount)} off their first order when they spend ${escapeHtml(thresholdAmount)}+.</p>
            </article>
            <article class="cad-loyalty-inline__how-step">
              <div class="cad-loyalty-inline__how-icon" aria-hidden="true">
                <img src="${escapeHtml(earnIcon)}" alt="" loading="lazy" decoding="async">
              </div>
              <h4>You earn rewards</h4>
              <p>Earn ${escapeHtml(rewardAmount)} with every friend that spends ${escapeHtml(thresholdAmount)}+.</p>
            </article>
          </div>
        </div>
      </section>
    `;
  };

  const findNativeReferralCopyControl = scope => {
    if (!(scope instanceof ParentNode)) return null;

    const explicit = scope.querySelector('.cad-referral-copy');
    if (
      explicit instanceof HTMLElement &&
      !explicit.closest('[data-cad-loyalty-inline]')
    ) {
      return explicit;
    }

    const candidates = Array.from(
      scope.querySelectorAll('button, a, [role="button"]')
    ).filter(
      element =>
        element instanceof HTMLElement &&
        !element.closest('[data-cad-loyalty-inline]')
    );

    return (
      candidates.find(element =>
        /copy your referral link|copy referral link|copy referral/i.test(
          normalizeText(element.textContent)
        )
      ) || null
    );
  };

  const buildCadReferralShareUrl = () => {
    const referralId = normalizeText(
      window.CadApp?.customer?.referralId ||
        globalThis.CadApp?.customer?.referralId
    );
    if (!referralId) return '';

    const root = normalizeText(window.Shopify?.routes?.root) || '/';
    const registerPath = `${root.replace(/\/?$/, '/')}apps/deluxe/account/register`;

    try {
      const shareUrl = new URL(registerPath, window.location.origin);
      shareUrl.searchParams.set('cad_referral', referralId);
      return shareUrl.toString();
    } catch (error) {
      return '';
    }
  };

  const resolveReferralLinkForCopy = frame => {
    const cadShareUrl = buildCadReferralShareUrl();
    if (cadShareUrl) return cadShareUrl;

    if (frame?.__cadLoyaltyInlineInfo?.referralLink) {
      return frame.__cadLoyaltyInlineInfo.referralLink;
    }

    const popupInfo = findReferralPopupContent();
    if (popupInfo?.referralLink) {
      if (frame) frame.__cadLoyaltyInlineInfo = popupInfo;
      return popupInfo.referralLink;
    }
    return '';
  };

  const copyTextToClipboard = text => {
    const value = normalizeText(text);
    if (!value) return Promise.resolve(false);

    if (navigator.clipboard?.writeText) {
      return navigator.clipboard
        .writeText(value)
        .then(() => true)
        .catch(() => false);
    }

    const buffer = document.createElement('textarea');
    buffer.value = value;
    buffer.setAttribute('readonly', '');
    buffer.style.position = 'fixed';
    buffer.style.opacity = '0';
    buffer.style.pointerEvents = 'none';
    document.body.appendChild(buffer);
    buffer.select();

    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (error) {
      ok = false;
    }

    buffer.remove();
    return Promise.resolve(ok);
  };

  const showLoyaltyCopyToast = message => {
    const toastMessage =
      normalizeText(message) || LOYALTY_COPY_TOAST_SUCCESS_MESSAGE;
    let toast = document.querySelector('[data-cad-copy-toast]');

    if (!(toast instanceof HTMLElement)) {
      toast = document.createElement('div');
      toast.className = 'cad-copy-toast';
      toast.dataset.cadCopyToast = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = toastMessage;
    toast.classList.add('is-visible');

    if (toast.__cadHideTimer) {
      window.clearTimeout(toast.__cadHideTimer);
    }

    toast.__cadHideTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, LOYALTY_COPY_TOAST_DURATION_MS);
  };

  const bindLoyaltyCopyButton = frame => {
    if (!frame || frame.dataset.cadLoyaltyCopyBound === 'true') return;

    frame.dataset.cadLoyaltyCopyBound = 'true';
    frame.addEventListener('click', event => {
      const copyTrigger = event.target.closest('[data-cad-loyalty-copy-link]');
      if (!copyTrigger) return;

      event.preventDefault();
      event.stopPropagation();

      const tryCopy = async () => {
        const referralLink = resolveReferralLinkForCopy(frame);
        if (referralLink && (await copyTextToClipboard(referralLink))) {
          showLoyaltyCopyToast(LOYALTY_COPY_TOAST_SUCCESS_MESSAGE);
          return;
        }

        const nativeCopyControl =
          findNativeReferralCopyControl(frame) ||
          findNativeReferralCopyControl(document);
        if (nativeCopyControl instanceof HTMLElement) {
          nativeCopyControl.click();
          showLoyaltyCopyToast(LOYALTY_COPY_TOAST_SUCCESS_MESSAGE);
        }
      };

      tryCopy();
    });
  };

  const injectLoyaltyHowInfo = (frame, info) => {
    if (!frame || !info) return;

    const nextMarkup = buildLoyaltyHowMarkup(info);
    let howHost = frame.querySelector('[data-cad-loyalty-how-host]');

    if (!howHost) {
      howHost = document.createElement('div');
      howHost.dataset.cadLoyaltyHowHost = 'true';
    }

    const frameTitle =
      frame.querySelector(':scope > .cad-frame--title') ||
      frame.querySelector('.cad-frame--title');

    if (frameTitle instanceof HTMLElement) {
      if (frameTitle.nextElementSibling !== howHost) {
        frameTitle.insertAdjacentElement('afterend', howHost);
      }
    } else if (!howHost.parentElement) {
      frame.prepend(howHost);
    }

    if (howHost.dataset.cadLoyaltyHowMarkup !== nextMarkup) {
      howHost.innerHTML = nextMarkup;
      howHost.dataset.cadLoyaltyHowMarkup = nextMarkup;
    }
  };

  const injectLoyaltyInlineInfo = (frame, workSection, info) => {
    if (!frame || !workSection) return;
    if (!info) return;

    const nextMarkup = buildLoyaltyInlineMarkup(info);
    let inlineRoot = workSection.querySelector(
      '[data-cad-loyalty-inline-host]'
    );
    const nativeBlocks = Array.from(
      workSection.querySelectorAll(
        '.ways-list, .cad-way-list, .voucher-list, .earn-methods, .earn-method, [data-earn-methods], [data-cad-loyalty-ways-list]'
      )
    ).filter(block => block instanceof HTMLElement);
    const nativeCards = nativeBlocks[0] || null;
    workSection
      .querySelectorAll(':scope > .cad-loyalty__section--title, :scope > p')
      .forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        node.dataset.cadLoyaltyWorkMeta = 'true';
        node.hidden = true;
        node.style.display = 'none';
      });

    if (!inlineRoot) {
      inlineRoot = document.createElement('div');
      inlineRoot.dataset.cadLoyaltyInlineHost = 'true';

      if (nativeCards instanceof HTMLElement) {
        nativeCards.insertAdjacentElement('beforebegin', inlineRoot);
      } else {
        const contentAnchor =
          workSection.querySelector('.cad-switcher-section-content') ||
          workSection.querySelector(
            '.cad-loyalty__section--title + p, .cad-loyalty__section--title'
          );

        if (contentAnchor instanceof HTMLElement) {
          contentAnchor.insertAdjacentElement('afterend', inlineRoot);
        } else {
          workSection.appendChild(inlineRoot);
        }
      }
    }

    nativeBlocks.forEach(block => {
      block.dataset.cadLoyaltyCards = 'true';
      block.hidden = true;
      block.style.display = 'none';
    });

    if (inlineRoot.dataset.cadLoyaltyInlineMarkup !== nextMarkup) {
      inlineRoot.innerHTML = nextMarkup;
      inlineRoot.dataset.cadLoyaltyInlineMarkup = nextMarkup;
    }
  };

  const enhanceLoyaltyFrame = () => {
    const loyaltyFrame = document.querySelector(LOYALTY_FRAME_SELECTOR);
    if (!loyaltyFrame) return;

    const loyaltyTitle = loyaltyFrame.querySelector(
      ':scope > .cad-frame--title'
    );
    if (
      loyaltyTitle &&
      normalizeText(loyaltyTitle.textContent) !== LOYALTY_TITLE
    ) {
      loyaltyTitle.textContent = LOYALTY_TITLE;
    }

    hideLoyaltyBalanceBlock(loyaltyFrame);
    setLoyaltyLeafText(
      loyaltyFrame,
      'Ways to Earn Points',
      LOYALTY_REFERRALS_TITLE
    );
    setLoyaltyLeafText(loyaltyFrame, 'Your Coupons', 'Your rewards');
    setLoyaltyLeafText(
      loyaltyFrame,
      'Available discounts',
      'Available rewards'
    );

    const rewardsSection = findLoyaltyRewardsSection(loyaltyFrame);
    if (rewardsSection) {
      rewardsSection.dataset.cadLoyaltyRewardsSection = 'true';
    }

    const workSection = findLoyaltyWorkSection(loyaltyFrame);
    if (!workSection) return;

    workSection.dataset.cadLoyaltyWork = 'true';
    const inlineInfo = getLoyaltyInlineContent(loyaltyFrame);
    injectLoyaltyHowInfo(loyaltyFrame, inlineInfo);
    injectLoyaltyInlineInfo(loyaltyFrame, workSection, inlineInfo);
    bindLoyaltyCopyButton(loyaltyFrame);
  };

  const showCadFavoritesConfirm = onConfirm => {
    let overlay = document.querySelector('[data-cad-favorites-confirm]');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'cad-favorites-confirm';
      overlay.dataset.cadFavoritesConfirm = '';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'cad-favorites-confirm-title');
      overlay.innerHTML = `
        <div class="cad-favorites-confirm__backdrop" data-cad-favorites-confirm-cancel></div>
        <div class="cad-favorites-confirm__dialog">
          <p class="cad-favorites-confirm__message" id="cad-favorites-confirm-title">${FAVORITES_CONFIRM_POPUP_TEXT}</p>
          <div class="cad-favorites-confirm__actions">
            <button type="button" class="cad-favorites-confirm__btn cad-favorites-confirm__btn--cancel" data-cad-favorites-confirm-cancel>${FAVORITES_CONFIRM_POPUP_CANCEL_LABEL}</button>
            <button type="button" class="cad-favorites-confirm__btn cad-favorites-confirm__btn--confirm" data-cad-favorites-confirm-ok>${FAVORITES_CONFIRM_POPUP_CONFIRM_LABEL}</button>
          </div>
        </div>
      `;
      document.body.appendChild(overlay);

      overlay.addEventListener('click', event => {
        if (event.target.closest('[data-cad-favorites-confirm-cancel]')) {
          overlay.classList.remove('is-visible');
          overlay.__cadConfirmCallback = null;
          return;
        }

        if (event.target.closest('[data-cad-favorites-confirm-ok]')) {
          overlay.classList.remove('is-visible');
          const callback = overlay.__cadConfirmCallback;
          overlay.__cadConfirmCallback = null;
          if (typeof callback === 'function') callback();
        }
      });
    }

    overlay.__cadConfirmCallback = onConfirm;
    overlay.classList.add('is-visible');
  };

  const syncFavoritesFrame = () => {
    const favoritesFrame = document.querySelector(FAVORITES_FRAME_SELECTOR);

    if (!favoritesFrame) return;

    if (favoritesFrame.dataset.cadFavoritesBound !== 'true') {
      favoritesFrame.dataset.cadFavoritesBound = 'true';
      favoritesFrame.addEventListener('click', event => {
        const trigger = event.target.closest('[data-cad-favorites-page]');
        if (!trigger) return;

        const triggerInsidePagination = trigger.closest(
          '[data-cad-favorites-pagination]'
        );
        if (!triggerInsidePagination) return;
        event.preventDefault();

        const previousPage = parsePositiveInt(
          favoritesFrame.dataset.cadFavoritesPage,
          1
        );
        const nextPage = parsePositiveInt(trigger.dataset.cadFavoritesPage, 1);

        favoritesFrame.dataset.cadFavoritesPage = `${nextPage}`;
        syncFavoritesFrame();

        if (nextPage !== previousPage) {
          scrollToCadSectionTop(
            favoritesFrame.querySelector(':scope > .cad-frame--title')
          );
        }
      });
    }

    const favoritesTitle = favoritesFrame.querySelector(
      ':scope > .cad-frame--title'
    );

    if (
      favoritesTitle &&
      normalizeText(favoritesTitle.textContent) !== FAVORITES_TITLE
    ) {
      favoritesTitle.textContent = FAVORITES_TITLE;
    }

    favoritesFrame
      .querySelectorAll('.product-single__variant-price--amount')
      .forEach(price => {
        const normalizedPrice = normalizeText(price.textContent);

        if (normalizedPrice && price.textContent !== normalizedPrice) {
          price.textContent = normalizedPrice;
        }
      });

    favoritesFrame
      .querySelectorAll('.product-viewed__variant-images')
      .forEach(imageGroup => {
        if (
          imageGroup.querySelector('.product-viewed__variant-image.selected')
        ) {
          return;
        }

        imageGroup
          .querySelector('.product-viewed__variant-image')
          ?.classList.add('selected');
      });

    favoritesFrame.querySelectorAll('.product-viewed').forEach(item => {
      if (!(item instanceof HTMLElement)) return;

      const closeControl = item.querySelector(
        ':scope > .product-viewed__close'
      );
      const mediaLink = item.querySelector(
        '.product-viewed__container > a.left'
      );

      if (
        closeControl instanceof HTMLElement &&
        mediaLink instanceof HTMLElement &&
        closeControl.parentElement !== mediaLink
      ) {
        mediaLink.appendChild(closeControl);
      }

      if (
        closeControl instanceof HTMLElement &&
        closeControl.dataset.cadPreventProductNavigateBound !== 'true'
      ) {
        closeControl.dataset.cadPreventProductNavigateBound = 'true';
        closeControl.addEventListener(
          'click',
          event => {
            if (
              closeControl.dataset.cadPreventProductNavigateBound === 'bypassed'
            ) {
              event.preventDefault();
              return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            showCadFavoritesConfirm(() => {
              closeControl.dataset.cadPreventProductNavigateBound = 'bypassed';
              closeControl.click();
              closeControl.dataset.cadPreventProductNavigateBound = 'true';
            });
          },
          true
        );
      }
    });

    const favoritesData = favoritesFrame.querySelector(
      ':scope > cad-stored-products.cad-frame--data'
    );

    if (!favoritesData) return;

    let pagination = favoritesFrame.querySelector(
      '[data-cad-favorites-pagination]'
    );

    if (!pagination) {
      pagination = document.createElement('div');
      pagination.className = 'cad-favorites-pagination';
      pagination.dataset.cadFavoritesPagination = '';
      favoritesData.insertAdjacentElement('afterend', pagination);
    }

    const items = [
      ...favoritesData.querySelectorAll(':scope > .product-viewed')
    ];
    const isFavoritesEmpty = items.length === 0;
    favoritesData.dataset.cadFavoritesEmpty = isFavoritesEmpty
      ? 'true'
      : 'false';
    favoritesFrame.dataset.cadFavoritesEmpty = isFavoritesEmpty
      ? 'true'
      : 'false';
    const itemsPerPage = getFavoritesItemsPerPage();
    const totalPages = Math.max(1, Math.ceil(items.length / itemsPerPage));
    const currentPage = resolveCurrentPage(
      favoritesFrame.dataset.cadFavoritesPage,
      totalPages
    );

    favoritesFrame.dataset.cadFavoritesPage = `${currentPage}`;

    applyPagedVisibility(items, currentPage, itemsPerPage);

    const shouldHidePagination = totalPages <= 1;
    if (pagination.hidden !== shouldHidePagination) {
      pagination.hidden = shouldHidePagination;
    }

    syncPaginationMarkup(
      favoritesFrame,
      pagination,
      '__cadFavoritesPaginationMarkup',
      buildPaginationMarkup({
        totalPages,
        currentPage,
        pageDataAttribute: 'data-cad-favorites-page'
      })
    );
  };

  const syncAddressesFrame = () => {
    const addressesFrame = document.querySelector(ADDRESSES_FRAME_SELECTOR);
    if (!addressesFrame) return;

    const hashMode = getAddressModeFromHash();
    const wantsAddressesFrame = isAddressesSectionHash() || !!hashMode;

    if (!addressesFrame.classList.contains('active') && wantsAddressesFrame) {
      const navItem = document.querySelector(
        '.cad-nav__menu-item[data-nav="addresses"]'
      );
      const navTarget =
        navItem?.querySelector('a, button, [role="button"]') || navItem;

      if (navTarget instanceof HTMLElement) {
        navTarget.click();
      }
      return;
    }

    bindAddressesFrameInteractionShield(addressesFrame);
    bindAddressesFrameFocusGuard(addressesFrame);

    if (addressesFrame.dataset.cadAddressesBound !== 'true') {
      addressesFrame.dataset.cadAddressesBound = 'true';
      scheduleAddressHashRoute();
      addressesFrame.addEventListener(
        'submit',
        event => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          if (!isAddressDeleteForm(form)) return;

          event.preventDefault();
          event.stopPropagation();

          const formData = new FormData(form);
          const action = form.getAttribute('action') || form.action;

          fetch(action, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
          })
            .then(response => {
              if (!response.ok) {
                window.location.href = action;
                return;
              }

              updateAddressLocationHash(null);

              const titleElement = addressesFrame.querySelector(
                ':scope > .cad-frame--title'
              );
              forceCloseAddressEditor(addressesFrame, titleElement);
            })
            .catch(() => {
              window.location.href = action;
            });
        },
        true
      );
      addressesFrame.addEventListener('click', event => {
        if (addressesFrame.__cadAddressesSyntheticEntryClick === true) {
          return;
        }

        if (addressesFrame.dataset.cadAddressesState === 'edit') {
          return;
        }

        if (
          event.target.closest(
            'form, [data-cad-address-form-layout], [data-cad-address-edit-actions], [data-cad-address-edit-back]'
          )
        ) {
          return;
        }

        // Ignore clicks on delete controls so they don't trigger the edit flow.
        const deleteTrigger = event.target.closest(
          '.address-footer [data-action="delete"], .address-footer .delete, [data-cad-address-delete]'
        );
        if (deleteTrigger) {
          return;
        }

        const addCardTrigger = event.target.closest(
          '[data-cad-address-add-card]'
        );

        if (addCardTrigger) {
          event.preventDefault();
          requestAddressesEditorMode(addressesFrame, 'new');
          return;
        }

        const editTrigger = event.target.closest(
          'cad-address, .default-address'
        );
        if (editTrigger) {
          event.preventDefault();
          const editToggle =
            getAddressEditToggle(event.target) ||
            editTrigger.querySelector(ADDRESS_EDIT_TOGGLE_SELECTOR);

          if (editToggle) {
            addressesFrame.__cadAddressLastEditTrigger = editToggle;
            requestAddressesEditorMode(addressesFrame, 'edit');
            clickAddressControl(addressesFrame, editToggle, true);
            return;
          }

          requestAddressesEditorMode(addressesFrame, 'edit');
        }

        const trigger = event.target.closest('[data-cad-addresses-page]');
        if (!trigger) return;

        event.preventDefault();
        addressesFrame.dataset.cadAddressesPage =
          trigger.dataset.cadAddressesPage || '1';
        syncAddressesFrame();
        scrollToCadSectionTop(
          addressesFrame.querySelector(':scope > .cad-frame--title')
        );
      });
    }

    const addressesTitle = addressesFrame.querySelector(
      ':scope > .cad-frame--title'
    );

    if (syncAddressEditor(addressesFrame, addressesTitle)) return;

    if (
      addressesTitle &&
      normalizeText(addressesTitle.textContent) !== ADDRESSES_TITLE
    ) {
      setManagedAddressesTitle(addressesFrame, addressesTitle, ADDRESSES_TITLE);
    }

    addressesFrame
      .querySelectorAll(
        ':scope > .cad-frame--data > :is(cad-address, .default-address)'
      )
      .forEach(card => {
        let content =
          card.querySelector('.formatted_address') ||
          card.querySelector('.body');
        const formLines = sanitizeAddressCardLines(
          buildAddressLinesFromCardForm(card)
        );

        if (!content && formLines.length > 0) {
          const fallbackContent = document.createElement('div');
          fallbackContent.className = 'formatted_address';
          const footer = card.querySelector('.address-footer');

          if (footer) {
            card.insertBefore(fallbackContent, footer);
          } else {
            card.prepend(fallbackContent);
          }

          content = fallbackContent;
        }

        if (!content) {
          card.dataset.cadAddressCardEmpty = 'false';
          return;
        }

        const fallbackLines = formLines.length
          ? formLines
          : sanitizeAddressCardLines(extractAddressLines(content));
        const isCardEmpty = fallbackLines.length === 0;

        card.dataset.cadAddressCardEmpty = 'false';
        if (isCardEmpty) {
          renderAddressCardLines(content, []);
          return;
        }

        renderAddressCardLines(content, fallbackLines);
      });

    const addressesData = addressesFrame.querySelector(
      ':scope > .cad-frame--data'
    );
    const nativeAddButton = getNativeAddAddressButton(addressesFrame);

    if (!addressesData || !nativeAddButton) return;

    let addCard = addressesData.querySelector('[data-cad-address-add-card]');

    if (!addCard) {
      addCard = document.createElement('button');
      addCard.type = 'button';
      addCard.className = 'cad-address-add-card';
      addCard.dataset.cadAddressAddCard = '';
      const plus = document.createElement('span');
      plus.className = 'cad-address-add-card__plus';
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+';

      const label = document.createElement('span');
      label.className = 'cad-address-add-card__label';
      label.textContent = 'Add new Address';

      addCard.append(plus, label);
      addCard.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        requestAddressesEditorMode(addressesFrame, 'new');
      });
    }

    if (nativeAddButton.previousElementSibling !== addCard) {
      nativeAddButton.insertAdjacentElement('beforebegin', addCard);
    }

    let pagination = addressesFrame.querySelector(
      '[data-cad-addresses-pagination]'
    );

    if (!pagination) {
      pagination = document.createElement('div');
      pagination.className = 'cad-addresses-pagination';
      pagination.dataset.cadAddressesPagination = '';
      addressesData.insertAdjacentElement('afterend', pagination);
    }

    const allItems = [
      ...addressesData.querySelectorAll(
        ':scope > :is(cad-address, .default-address, [data-cad-address-add-card])'
      )
    ];

    let items = allItems.filter(
      item => item.dataset.cadAddressCardEmpty !== 'true'
    );
    if (items.length === 0 && allItems.length > 0) {
      items = allItems;
      items.forEach(item => {
        item.hidden = false;
        item.style.display = '';
      });
    }
    const totalPages = Math.max(
      1,
      Math.ceil(items.length / ADDRESSES_ITEMS_PER_PAGE)
    );
    const currentPage = resolveCurrentPage(
      addressesFrame.dataset.cadAddressesPage,
      totalPages
    );

    addressesFrame.dataset.cadAddressesPage = `${currentPage}`;

    applyPagedVisibility(items, currentPage, ADDRESSES_ITEMS_PER_PAGE);

    const shouldHidePagination = totalPages <= 1;
    if (pagination.hidden !== shouldHidePagination) {
      pagination.hidden = shouldHidePagination;
    }

    syncPaginationMarkup(
      addressesFrame,
      pagination,
      '__cadAddressesPaginationMarkup',
      buildPaginationMarkup({
        totalPages,
        currentPage,
        pageDataAttribute: 'data-cad-addresses-page'
      })
    );
  };

  const CAD_MANAGED_ROOT_SELECTOR = [
    '[data-cad-account-summary]',
    '[data-cad-account-edit-header]',
    '[data-cad-account-edit-actions]',
    '[data-cad-orders-summary]',
    '[data-cad-favorites-pagination]',
    '[data-cad-address-edit-back]',
    '[data-cad-address-edit-actions]',
    '[data-cad-address-form-layout]',
    '[data-cad-addresses-pagination]',
    '[data-cad-address-add-card]',
    '[data-cad-address-lines]',
    '[data-cad-loyalty-cards]',
    '[data-cad-loyalty-how-host]',
    '[data-cad-loyalty-how-banner]',
    '[data-cad-loyalty-inline]',
    '[data-cad-loyalty-inline-host]',
    '[data-cad-loyalty-work]'
  ].join(', ');

  const getMutationElement = node => {
    if (node instanceof Element) return node;
    return node?.parentElement || null;
  };

  const isManagedCadNode = node => {
    const element = getMutationElement(node);
    return !!element?.closest(CAD_MANAGED_ROOT_SELECTOR);
  };

  const getOrdersPaginationSource = frame => {
    if (!(frame instanceof HTMLElement)) return null;

    return (
      Array.from(frame.querySelectorAll('.orders-pagination')).find(
        pagination => !pagination.closest('[data-cad-orders-summary]')
      ) || null
    );
  };

  const buildOrdersSummary = frame => {
    if (frame.querySelector('[data-cad-orders-summary]')) return;

    if (!frame.dataset.cadOrdersState) {
      frame.dataset.cadOrdersState = 'list';
    }

    const summary = document.createElement('section');
    summary.className = 'cad-orders-summary';
    summary.dataset.cadOrdersSummary = '';
    summary.innerHTML = `
      <div class="cad-orders-summary__list-view" data-cad-orders-list-view>
        <div class="cad-orders-summary__header">
          <h1 class="cad-orders-summary__title">My orders</h1>
          <p class="cad-orders-summary__subtitle">${escapeHtml(ORDERS_SUBTITLE)}</p>
        </div>
        <div class="cad-orders-summary__content">
          <div class="cad-orders-summary__table-wrap" data-cad-orders-table-wrap>
            <div class="cad-orders-summary__table" data-cad-orders-table></div>
          </div>
          <aside class="cad-orders-summary__billing" data-cad-orders-billing></aside>
        </div>
        <div class="cad-orders-summary__pagination" data-cad-orders-pagination></div>
      </div>
      <section class="cad-order-detail" data-cad-orders-detail hidden></section>
    `;

    summary.addEventListener('click', event => {
      const trigger = event.target.closest('[data-cad-order-trigger]');
      if (trigger) {
        frame.dataset.cadOrdersState = 'detail';
        frame.dataset.cadOrdersOrderId = trigger.dataset.cadOrderTrigger || '';
        renderOrderDetail(frame);
        return;
      }

      const paginationLink = event.target.closest(
        '[data-cad-orders-pagination] a'
      );
      if (paginationLink) {
        frame.dataset.cadOrdersScrollPending = 'true';

        const linkIndex = Number.parseInt(
          `${paginationLink.dataset.cadOrdersPaginationIndex ?? ''}`,
          10
        );
        const paginationSource = getOrdersPaginationSource(frame);
        const sourceLink =
          paginationSource && Number.isFinite(linkIndex) && linkIndex >= 0
            ? paginationSource.querySelectorAll('a')[linkIndex]
            : null;

        if (sourceLink instanceof HTMLAnchorElement) {
          event.preventDefault();
          event.stopPropagation();
          sourceLink.click();
        }
      }

      if (event.target.closest('[data-cad-orders-detail-back]')) {
        frame.dataset.cadOrdersState = 'list';
        delete frame.dataset.cadOrdersOrderId;
        renderOrderDetail(frame);
      }
    });

    frame.insertBefore(summary, frame.firstChild);
  };

  const renderOrderDetail = frame => {
    const summary = frame.querySelector('[data-cad-orders-summary]');
    if (!summary) return;

    const listView = summary.querySelector('[data-cad-orders-list-view]');
    const detailTarget = summary.querySelector('[data-cad-orders-detail]');
    const selectedOrderId = frame.dataset.cadOrdersOrderId || '';
    const order = (frame.__cadOrdersData || []).find(
      item => item.id === selectedOrderId
    );

    if (!detailTarget || !listView) return;

    if (frame.dataset.cadOrdersState !== 'detail' || !order) {
      if (listView.hidden) listView.hidden = false;
      if (!detailTarget.hidden) detailTarget.hidden = true;
      if (frame.__cadOrdersDetailMarkup) {
        detailTarget.innerHTML = '';
        frame.__cadOrdersDetailMarkup = '';
      }
      return;
    }

    const shippingRow =
      order.shippingAmount && order.shippingAmount !== '-'
        ? `
            <div class="cad-order-detail__summary-row">
              <span>${escapeHtml(order.shippingLabel)}</span>
              <strong>${escapeHtml(order.shippingAmount)}</strong>
            </div>
          `
        : '';

    const itemsMarkup = order.items.length
      ? order.items
          .map(
            item => `
              <article class="cad-order-detail__item-row">
                <div class="cad-order-detail__product">
                  <div class="cad-order-detail__product-media">
                    ${
                      item.imageSrc
                        ? `<img src="${escapeHtml(item.imageSrc)}" alt="${escapeHtml(item.imageAlt)}" loading="lazy">`
                        : ''
                    }
                  </div>
                  <div class="cad-order-detail__product-copy">
                    <h3 class="cad-order-detail__product-title">${escapeHtml(item.title)}</h3>
                    ${
                      item.variant
                        ? `<p class="cad-order-detail__product-variant">${escapeHtml(item.variant)}</p>`
                        : ''
                    }
                    <p class="cad-order-detail__product-price">${escapeHtml(item.price)}</p>
                  </div>
                </div>
                <div class="cad-order-detail__item-quantity">${escapeHtml(item.quantity)}</div>
                <div class="cad-order-detail__item-total">${escapeHtml(item.price)}</div>
              </article>
            `
          )
          .join('')
      : `<div class="cad-order-detail__empty">No items found</div>`;

    const nextMarkup = `
      <button type="button" class="cad-order-detail__back" data-cad-orders-detail-back>Back</button>
      <div class="cad-order-detail__header">
        <h1 class="cad-order-detail__title">${escapeHtml(order.orderTitle)}</h1>
        <p class="cad-order-detail__subtitle">Order placed on ${escapeHtml(order.placedAt)}</p>
      </div>
      <div class="cad-order-detail__content">
        <div class="cad-order-detail__table-wrap">
          <div class="cad-order-detail__table-header">
            <div>Product</div>
            <div>Quantity</div>
            <div>Total</div>
          </div>
          <div class="cad-order-detail__items">
            ${itemsMarkup}
          </div>
        </div>
        <aside class="cad-order-detail__address">
          <div class="cad-order-detail__address-title">Billing address</div>
          <div class="cad-order-detail__address-content">${order.billingAddressHtml}</div>
        </aside>
      </div>
      <div class="cad-order-detail__footer">
        <div class="cad-order-detail__totals">
          <div class="cad-order-detail__summary-row">
            <span>Subtotal</span>
            <strong>${escapeHtml(order.subtotal)}</strong>
          </div>
          ${shippingRow}
          <div class="cad-order-detail__summary-row cad-order-detail__summary-row--total">
            <span>Total</span>
            <strong>${escapeHtml(order.total)}</strong>
          </div>
        </div>
        <aside class="cad-order-detail__address cad-order-detail__address--shipping">
          <div class="cad-order-detail__address-title">Shipping address</div>
          <div class="cad-order-detail__address-content">${order.shippingAddressHtml}</div>
        </aside>
      </div>
    `;

    if (!listView.hidden) listView.hidden = true;
    if (detailTarget.hidden) detailTarget.hidden = false;

    if (frame.__cadOrdersDetailMarkup !== nextMarkup) {
      detailTarget.innerHTML = nextMarkup;
      frame.__cadOrdersDetailMarkup = nextMarkup;
    }
  };

  const renderOrdersSummary = frame => {
    const summary = frame.querySelector('[data-cad-orders-summary]');
    if (!summary) return;

    const tableTarget = summary.querySelector('[data-cad-orders-table]');
    const billingTarget = summary.querySelector('[data-cad-orders-billing]');
    const paginationTarget = summary.querySelector(
      '[data-cad-orders-pagination]'
    );
    const emptyText =
      normalizeText(frame.querySelector('.no-orders')?.textContent) ||
      'No orders yet';
    const orders = readOrders(frame);
    frame.__cadOrdersData = orders;
    const billingAddressHtml =
      getDefaultAddressHtml() || orders[0]?.billingAddressHtml || '-';

    const nextTableMarkup = orders.length
      ? `
          <div class="cad-orders-summary__table-header">
            <div>Order</div>
            <div>Date</div>
            <div>Payment status</div>
            <div>Fulfillment status</div>
            <div>Total</div>
          </div>
          <div class="cad-orders-summary__table-body">
            ${orders
              .map(
                order => `
                  <button type="button" class="cad-orders-summary__row cad-orders-summary__row--trigger" data-cad-order-trigger="${escapeHtml(order.id)}">
                    <div class="cad-orders-summary__cell" data-label="Order">${escapeHtml(order.orderName)}</div>
                    <div class="cad-orders-summary__cell" data-label="Date">${escapeHtml(order.date)}</div>
                    <div class="cad-orders-summary__cell" data-label="Payment status">${escapeHtml(order.paymentStatus)}</div>
                    <div class="cad-orders-summary__cell" data-label="Fulfillment status">${escapeHtml(order.fulfillmentStatus)}</div>
                    <div class="cad-orders-summary__cell cad-orders-summary__cell--total" data-label="Total">${escapeHtml(order.total)}</div>
                  </button>
                `
              )
              .join('')}
          </div>
        `
      : `<div class="cad-orders-summary__empty">${escapeHtml(emptyText)}</div>`;

    const nextBillingMarkup = orders.length
      ? `
          <div class="cad-orders-summary__billing-title">Billing address</div>
          <div class="cad-orders-summary__billing-content">${billingAddressHtml}</div>
        `
      : '';

    if (tableTarget && frame.__cadOrdersTableMarkup !== nextTableMarkup) {
      tableTarget.innerHTML = nextTableMarkup;
      frame.__cadOrdersTableMarkup = nextTableMarkup;
    }

    if (billingTarget) {
      if (billingTarget.hidden === !!nextBillingMarkup) {
        billingTarget.hidden = !nextBillingMarkup;
      }

      if (frame.__cadOrdersBillingMarkup !== nextBillingMarkup) {
        billingTarget.innerHTML = nextBillingMarkup;
        frame.__cadOrdersBillingMarkup = nextBillingMarkup;
      }
    }

    const paginationSource = getOrdersPaginationSource(frame);
    const nextPaginationMarkup = paginationSource
      ? paginationSource.innerHTML
      : '';

    if (paginationTarget) {
      if (paginationTarget.hidden === !!nextPaginationMarkup) {
        paginationTarget.hidden = !nextPaginationMarkup;
      }

      if (frame.__cadOrdersPaginationMarkup !== nextPaginationMarkup) {
        paginationTarget.innerHTML = nextPaginationMarkup;
        paginationTarget.querySelectorAll('a').forEach((link, index) => {
          link.setAttribute('allow-hash-change', '');
          link.dataset.cadOrdersPaginationIndex = `${index}`;
        });
        frame.__cadOrdersPaginationMarkup = nextPaginationMarkup;
      }
    }

    if (frame.dataset.cadOrdersScrollPending === 'true') {
      delete frame.dataset.cadOrdersScrollPending;
      scrollToCadSectionTop(
        summary.querySelector('.cad-orders-summary__header') || summary
      );
    }

    renderOrderDetail(frame);
  };

  const enhanceOrdersFrame = frame => {
    const hasOrdersContent =
      frame.querySelector('cad-order[data-order-name]') ||
      frame.querySelector('.no-orders');

    if (!hasOrdersContent) return;

    if (frame.dataset.cadOrdersEnhanced !== 'true') {
      frame.dataset.cadOrdersEnhanced = 'true';
      buildOrdersSummary(frame);
    }

    renderOrdersSummary(frame);
  };

  const enhanceAccountFrame = frame => {
    const profile = frame.querySelector(CAD_ACCOUNT_SELECTOR);
    if (!profile || frame.dataset.cadAccountEnhanced === 'true') return;

    frame.dataset.cadAccountEnhanced = 'true';
    frame.__cadAccountSnapshot = readSnapshot(profile);

    buildSummary(frame);
    bindAccountActionDelegation(frame);
    renderSummary(frame);
    setMode(frame, 'view');
    syncEditActions(frame);
    syncAccountPhoneValidation(frame);
    observeProfile(frame);
  };

  const moveCode8SignupToCadFrame = frame => {
    const cadFrame = frame?.closest('.cad-frame');
    const signup = document.querySelector(CODE8_SIGNUP_SELECTOR);
    const appSection = signup?.closest('.shopify-section');

    if (!cadFrame || !appSection) return false;

    if (cadFrame.firstElementChild !== appSection) {
      cadFrame.prepend(appSection);
    }

    appSection.dataset.cadOptinPositioned = '';
    return true;
  };

  const hasCode8AuthOptinIntent = () => {
    try {
      return localStorage.getItem(CODE8_AUTH_OPTIN_STORAGE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  };

  const setCode8AuthOptinIntent = enabled => {
    try {
      if (enabled) {
        localStorage.setItem(CODE8_AUTH_OPTIN_STORAGE_KEY, 'true');
      } else {
        localStorage.removeItem(CODE8_AUTH_OPTIN_STORAGE_KEY);
      }
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browser contexts.
    }
  };

  const getCode8OptinConfig = root => {
    const rawConfig = root?.dataset.config || '';
    const jsonStart = rawConfig.indexOf('{');
    const jsonEnd = rawConfig.lastIndexOf('}');

    if (jsonStart < 0 || jsonEnd <= jsonStart) return null;

    try {
      return JSON.parse(rawConfig.slice(jsonStart, jsonEnd + 1));
    } catch (error) {
      return null;
    }
  };

  const syncCode8AuthOptinCheckbox = () => {
    if (!isCadAppRegisterPage) return;

    const socialLogin = document.querySelector(
      "cad-login.cad_login[data-login-style='minimal'] cad-social-login"
    );
    if (!(socialLogin instanceof HTMLElement)) return;

    let host = document.querySelector('[data-cad-auth-marketing-optin]');
    if (!(host instanceof HTMLLabelElement)) {
      host = document.createElement('label');
      host.className = 'cad-auth-marketing-optin';
      host.dataset.cadAuthMarketingOptin = '';

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.dataset.cadAuthMarketingOptinInput = '';
      checkbox.checked = hasCode8AuthOptinIntent();
      checkbox.addEventListener('change', () => {
        setCode8AuthOptinIntent(checkbox.checked);
      });

      const text = document.createElement('span');
      text.dataset.cadAuthMarketingOptinText = '';
      host.append(checkbox, text);
    }

    const config = getCode8OptinConfig(
      document.querySelector(CODE8_OPTIN_ROOT_SELECTOR)
    );
    const text = host.querySelector('[data-cad-auth-marketing-optin-text]');
    if (text) {
      text.textContent =
        config?.signup_checkbox_text || CODE8_AUTH_OPTIN_FALLBACK_TEXT;
    }

    const checkbox = host.querySelector('[data-cad-auth-marketing-optin-input]');
    if (checkbox instanceof HTMLInputElement) {
      checkbox.checked = hasCode8AuthOptinIntent();
    }

    if (socialLogin.nextElementSibling !== host) {
      socialLogin.insertAdjacentElement('afterend', host);
    }
  };

  let code8OptinPopupRetryTimer = 0;
  let code8OptinPopupRetryCount = 0;
  let code8OptinPopupDecisionSignature = '';

  const scheduleCode8OptinPopupRetry = () => {
    if (
      code8OptinPopupRetryTimer ||
      code8OptinPopupRetryCount >= CODE8_OPTIN_POPUP_MAX_RETRIES ||
      !hasCode8AuthOptinIntent()
    ) {
      return;
    }

    code8OptinPopupRetryTimer = window.setTimeout(() => {
      code8OptinPopupRetryTimer = 0;
      code8OptinPopupRetryCount += 1;
      syncCode8OptinPopupIntent();
    }, CODE8_OPTIN_POPUP_RETRY_DELAY_MS);
  };

  const syncCode8OptinPopupIntent = () => {
    if (isCadAppLoginPage || isCadAppRegisterPage) return;

    const flag = hasCode8AuthOptinIntent();

    const root = document.querySelector(CODE8_OPTIN_ROOT_SELECTOR);
    if (!(root instanceof HTMLElement)) {
      if (flag) scheduleCode8OptinPopupRetry();
      return;
    }

    const config = getCode8OptinConfig(root);
    const appSection = root.closest('.shopify-section');
    const isPositioned =
      appSection?.hasAttribute('data-cad-optin-positioned') === true;
    const isAuthenticated = root.dataset.authenticated === 'true';
    const customerEmail = (root.dataset.customerEmail || '').trim();
    const hasEmail = customerEmail.length > 0;
    const acceptsMarketing =
      root.dataset.customerAcceptsMarketing === 'true';
    const shouldShowPopup =
      isPositioned &&
      isAuthenticated &&
      hasEmail &&
      !acceptsMarketing &&
      config?.enabled_account === true;

    const domInfo = {
      positioned: isPositioned,
      authenticated: root.dataset.authenticated,
      customerEmail,
      customerAcceptsMarketing: root.dataset.customerAcceptsMarketing,
      enabledAccount: config?.enabled_account,
      rootHidden: root.hidden,
      shouldShowPopup
    };
    const decisionSignature = JSON.stringify({ flag, dom: domInfo });

    if (decisionSignature !== code8OptinPopupDecisionSignature) {
      code8OptinPopupDecisionSignature = decisionSignature;
      console.info('[Code8 opt-in] Popup decision', {
        flag,
        dom: domInfo
      });
    }

    if (!flag || !shouldShowPopup) return;

    const dialog = document.querySelector('.code8-optin-dialog');
    if (dialog instanceof HTMLDialogElement && dialog.open) {
      console.info('[Code8 opt-in] Popup opened', {
        flag,
        dom: domInfo
      });
      setCode8AuthOptinIntent(false);
      return;
    }

    if (!(dialog instanceof HTMLDialogElement)) {
      scheduleCode8OptinPopupRetry();
      return;
    }

    const title = dialog.querySelector('[data-code8-popup-title]');
    const body = dialog.querySelector('[data-code8-popup-body]');
    const bodyText = [config.signup_popup_body, config.discount_text]
      .filter(value => typeof value === 'string' && value.trim())
      .join(' ');

    if (title) title.textContent = config.signup_popup_title || '';
    if (body) body.textContent = bodyText;

    root.removeAttribute('hidden');
    dialog.showModal();

    if (dialog.open) {
      console.info('[Code8 opt-in] Popup opened', {
        flag,
        dom: domInfo
      });
      setCode8AuthOptinIntent(false);
      return;
    }

    scheduleCode8OptinPopupRetry();
  };

  let scanScheduled = false;

  const scanPage = () => {
    scanScheduled = false;
    syncCadLoginCopy();
    syncNavigationMenu();
    syncFavoritesFrame();
    syncAddressesFrame();
    enhanceLoyaltyFrame();

    let code8OptinPositioned = false;
    const accountFrame = document.querySelector(ACCOUNT_FRAME_SELECTOR);
    if (accountFrame) {
      enhanceAccountFrame(accountFrame);
      if (!isCadAppLoginPage && !isCadAppRegisterPage) {
        code8OptinPositioned =
          moveCode8SignupToCadFrame(accountFrame);
      }
      syncEditActions(accountFrame);
      syncAccountPhoneValidation(accountFrame);
      if (accountFrame.dataset.cadAccountState === 'edit') {
        syncAccountEditFieldOrder(accountFrame);
      }
    }

    syncCode8AuthOptinCheckbox();
    if (code8OptinPositioned) syncCode8OptinPopupIntent();

    const ordersFrame = document.querySelector(ORDERS_FRAME_SELECTOR);
    if (ordersFrame) enhanceOrdersFrame(ordersFrame);
  };

  const scheduleScan = () => {
    if (scanScheduled) return;

    scanScheduled = true;
    window.requestAnimationFrame(scanPage);
  };

  patchCadEndpointFetch();
  patchCadNavigationGuards();
  scheduleScan();
  scheduleAddressHashRoute();

  // When header wishlist link is clicked, trigger favorites nav item click to use existing CAD logic
  document.addEventListener('click', event => {
    const trigger =
      event.target && event.target.closest
        ? event.target.closest('.header__add-to-wishlist a')
        : null;

    if (!trigger) return;

    // Click the favorites nav item to trigger existing CAD state management
    const favNav = document.querySelector(
      '.cad-nav__menu-item[data-nav="favorites"]'
    );
    if (favNav) {
      favNav.click();
    }
  });

  window.addEventListener('hashchange', () => {
    scheduleAddressHashRoute();
    scheduleScan();
  });

  let favoritesResizeRaf = 0;
  window.addEventListener('resize', () => {
    if (favoritesResizeRaf) return;

    favoritesResizeRaf = window.requestAnimationFrame(() => {
      favoritesResizeRaf = 0;
      syncFavoritesFrame();
    });
  });

  const pageObserver = new MutationObserver(mutations => {
    const shouldScan = mutations.some(mutation => {
      const targetElement = getMutationElement(mutation.target);

      if (!targetElement) return true;
      if (!targetElement.closest(CAD_MANAGED_ROOT_SELECTOR)) return true;

      return [...mutation.addedNodes, ...mutation.removedNodes].some(
        node => !isManagedCadNode(node)
      );
    });

    if (shouldScan) scheduleScan();
  });
  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
